$(document).ready(function () {
	$('#mbtiretr').show();
	setupTire();
	updateBrakeRotor();
	updateModelSpecificSprocketOptions();
	$(document).on('change', 'select:not(#mbtire), input', function () {
		setupTire();
	});
	$(document).on('change', 'select:not(#brake_rotor), input', function () {
		updateBrakeRotor();
	});
	updateBrakeRotorImage();
	$(document).on('change', 'select, input', function () {
		updateBrakeRotorImage();
	});

	function updateBrakeRotorImage() {
		var img = '';
		var brake_rotor_style = document.querySelector('#brake_rotor').value;
		switch (brake_rotor_style) {
			case '203mm x 1.8 Fixed':
				img = 'https://cdn.shopify.com/s/files/1/0676/2096/2552/files/203mm_x_1.8_Fixed-removebg-preview.png?v=1729155909';
				break;
			case '220mm x 1.8 Fixed':
			case '220mm Fixed':
				img = 'https://cdn.shopify.com/s/files/1/0676/2096/2552/files/220mm_x__1.8_Fixed-removebg-preview.png?v=1729155909';
				break;
			case '220mm x 2.3 Floating':
			case '220mm Floating':
				img = 'https://cdn.shopify.com/s/files/1/0676/2096/2552/files/220mm_x_2.3_Floating-removebg-preview.png?v=1729155909';
				break;
			case '240mm x 2.3 Floating with bracket':
			case '240mm Floating':
			case '240 Floating':
				img = 'https://cdn.shopify.com/s/files/1/0676/2096/2552/files/240mm_x_2.3_Floating_with_bracket_-removebg-preview.png?v=1729155910';
				break;
			case '240 Fixed':
			case '260 Floating w/ Bracket':
			case '300 Floating w/ Bracket':
				img = '';
				break;
			default:
				// console.log("Unknown rotor style selected");
				img = '';
				break;
		}
		document.querySelector('.rotor img').src = img;
	}
	rotorImageSetup();
	$(document).on('change', 'select, input', function () {
		rotorImageSetup();

	});

	// --- Set rim lock to yes when a tire is selected
	$(document).on('change', 'select#mbtire', function() {
		const selectedTireValue = $(this).val();
		const rimLock = document.querySelector('#rim_lock');

		if (selectedTireValue != 'mbno') {
			rimLock.querySelector('option[value="Yes"]').setAttribute('selected', 'selected');
			rimLock.querySelector('option[value="No"]').removeAttribute('selected');
		} else {
			rimLock.querySelector('option[value="No"]').setAttribute('selected', 'selected');
			rimLock.querySelector('option[value="Yes"]').removeAttribute('selected');
		}
	});

	function rotorImageSetup() {
		var wheel_type = document.querySelector('#wheel_type').value;
		var rear_name = ['Rear', 'REAR'];
		if (rear_name.includes(wheel_type)) {
			document.querySelector('#resultAreaID_1_6').style.display = 'block';
			document.querySelector('#resultAreaID_1_7').style.display = 'block';

			// Rear
		} else {
			document.querySelector('#resultAreaID_1_6').style.display = 'block';
			document.querySelector('#resultAreaID_1_7').style.display = 'none';
			//Front
		}
	}

	var NO_ROTOR_OPTION = 'No rotor';
	var ERIDE_SR_3_REAR_ROTOR_OPTIONS = [NO_ROTOR_OPTION, '220mm Fixed', '220mm Floating'];
	var ERIDE_SR_3_FRONT_ROTOR_OPTIONS = ERIDE_SR_3_REAR_ROTOR_OPTIONS.slice();
	var ERIDE_SR_3_SPROCKET_OPTIONS_HTML = '<option class="category" value="40T">40T</option><option class="category" value="45T">45T</option><option class="category" value="50T">50T</option><option class="category" value="54T">54T</option><option class="category" value="58T">58T</option><option class="category" value="no">No Sprocket</option>';
	var ULTRA_BEE_SPROCKET_OPTIONS_HTML = '<option class="category" value="40T">40T</option><option class="category" value="42T">42T</option><option class="category" value="44T">44T</option><option class="category" value="46T">46T</option><option class="category" value="50T">50T</option><option class="category" value="52T">52T</option><option class="category" value="54T">54T</option><option class="category" value="56T">56T</option><option class="category" value="58T">58T</option><option class="category" value="no">No Sprocket</option>';

	function isErideSr3Model(bikeModel) {
		return ['SR 3.0 *FRONT*', 'SR 3.0 *REAR*'].includes((bikeModel || '').toString());
	}

	function isBonnell805RxModel(bikeModel) {
		return ['805RX *FRONT*', '805RX *REAR*'].includes((bikeModel || '').toString());
	}

	function isBonnell805RxPricingModel() {
		return isBonnell805RxModel($('select#bike_model').val());
	}

	function updateModelSpecificSprocketOptions() {
		var select = $('#sprocket_size');
		if (!select.length) {
			return;
		}

		var bikeModel = $('#bike_model').val();
		var optionsHtml = '';
		if (isSurronUltraBeePricingModel()) {
			optionsHtml = ULTRA_BEE_SPROCKET_OPTIONS_HTML;
		} else if (isErideSr3Model(bikeModel)) {
			optionsHtml = ERIDE_SR_3_SPROCKET_OPTIONS_HTML;
		}

		if (!optionsHtml) {
			return;
		}

		var selectedValue = select.val();
		select.empty().append(optionsHtml);
		if (select.find('option[value="' + selectedValue + '"]').length) {
			select.val(selectedValue);
		}
	}

	function bikeAllowsNoRotorOption(bikeMake, bikeModel) {
		bikeMake = (bikeMake || '').toString();
		bikeModel = (bikeModel || '').toString();

		return (bikeMake === 'Surron' && ['X *FRONT*', 'X *REAR*', 'Ultra *FRONT*', 'Ultra *REAR*'].includes(bikeModel))
			|| (bikeMake === 'ERIDE' && ['PRO-SS *FRONT*', 'PRO-SS *REAR*', 'PRO 2.0 *FRONT*', 'PRO 2.0 *REAR*', 'SR 3.0 *FRONT*', 'SR 3.0 *REAR*'].includes(bikeModel))
			|| bikeMake === 'Segway'
			|| (bikeMake === 'Talaria' && ['Sting MX5 *FRONT*', 'Sting MX5 *REAR*'].includes(bikeModel))
			|| bikeMake === 'Rawr'
			|| bikeMake === 'Throne';
	}

	function syncNoRotorOption() {
		var select = $('select#brake_rotor');
		var selectedValue = select.val();

		select.find('option').filter(function () {
			return this.value === NO_ROTOR_OPTION || this.text === NO_ROTOR_OPTION;
		}).remove();

		if (bikeAllowsNoRotorOption($('#bike_make').val(), $('#bike_model').val())) {
			select.prepend($('<option>', {
				value: NO_ROTOR_OPTION,
				text: NO_ROTOR_OPTION
			}));
			if (selectedValue === NO_ROTOR_OPTION) {
				select.val(NO_ROTOR_OPTION);
			}
		}
	}

	function isStandardEbikePricingModel() {
		var bike_model = $('select#bike_model').val();
		return !['Ultra *FRONT*', 'Ultra *REAR*'].includes(bike_model) && !isBonnell805RxModel(bike_model);
	}

	function isSurronUltraBeePricingModel() {
		return ['Ultra *FRONT*', 'Ultra *REAR*'].includes(($('select#bike_model').val() || '').toString());
	}

	function getNormalizedOptionValue(value) {
		return (value || '').toString().toLowerCase().replace(/[-_]/g, ' ').replace(/\s+/g, ' ').trim();
	}

	function isNoChargeColor(colorValue, noChargeColors) {
		colorValue = getNormalizedOptionValue(colorValue);
		return noChargeColors.some(function (freeColor) {
			return colorValue === getNormalizedOptionValue(freeColor);
		});
	}

	function getStandardEbikeBasePrice(isDealer) {
		return $('select#wheel_type').val() === "FRONT" ? (isDealer ? 225 : 304) : (isDealer ? 235 : 316);
	}

	function getStandardEbikeHubPrice(isDealer) {
		return isNoChargeColor($('#hub_color').val(), ['Silver', 'Black']) ? 0 : (isDealer ? 7.5 : 9);
	}

	function getStandardEbikeRimPrice(isDealer) {
		return isNoChargeColor($('#rim_color').val(), ['Black']) ? 0 : (isDealer ? 15 : 19);
	}

	function getStandardEbikeSpokePrice(isDealer) {
		return isNoChargeColor($('#spoke_color').val(), ['Silver', 'Black']) ? 0 : (isDealer ? 15 : 19);
	}

	function getStandardEbikeNipplePrice(isDealer) {
		return isNoChargeColor($('#nipple_color').val(), ['Silver', 'Black']) ? 0 : (isDealer ? 7.5 : 9);
	}

	function getSurronUltraBeeBasePrice(isDealer) {
		var bikeModel = ($('select#bike_model').val() || '').toString();
		var rimSize = getNormalizedOptionValue($('select#rim_size').val());
		var is17InchSupermoto = (bikeModel === 'Ultra *FRONT*' && rimSize.indexOf('front 17x3.0') === 0)
			|| (bikeModel === 'Ultra *REAR*' && rimSize.indexOf('rear 17x4.25') === 0);

		if (is17InchSupermoto) {
			return isDealer ? 305 : 410;
		}

		return isDealer ? 297 : 399;
	}

	function getSurronUltraBeeHubPrice(isDealer) {
		return isNoChargeColor($('#hub_color').val(), ['Silver', 'Black']) ? 0 : (isDealer ? 8 : 10);
	}

	function getSurronUltraBeeRimPrice(isDealer) {
		return isNoChargeColor($('#rim_color').val(), ['Black']) ? 0 : (isDealer ? 22 : 28);
	}

	function getSurronUltraBeeSpokePrice(isDealer) {
		return isNoChargeColor($('#spoke_color').val(), ['Silver', 'Black']) ? 0 : (isDealer ? 18 : 25);
	}

	function getSurronUltraBeeNipplePrice(isDealer) {
		return isNoChargeColor($('#nipple_color').val(), ['Silver', 'Black']) ? 0 : (isDealer ? 8 : 10);
	}

	function getSurronUltraBeeBrakePrice(isDealer) {
		var brakeRotorStyle = getNormalizedOptionValue($('select#brake_rotor').val());
		var wheelType = ($('select#wheel_type').val() || '').toString();

		switch (brakeRotorStyle) {
			case getNormalizedOptionValue(NO_ROTOR_OPTION):
				return 0;
			case '240 mm':
			case '240 fixed':
			case '240mm fixed':
			case '240 x 3.0 mm fixed':
			case '240mm x 2.3 fixed':
				return isDealer ? 32 : 49;
			case '240 floating':
			case '240mm floating':
			case '240mm blue button floating rotor':
				return isDealer ? 57 : 79;
			case '260mm blue button floating rotor with bracket':
			case '260 floating':
			case '260 floating w/ bracket':
				return wheelType === 'FRONT' ? (isDealer ? 69 : 95) : 0;
			case '300mm blue button floating rotor with bracket':
			case '300 floating':
			case '300 floating w/ bracket':
				return wheelType === 'FRONT' ? (isDealer ? 70 : 99) : 0;
			default:
				return 0;
		}
	}

	function getStandardEbikeBrakePrice(isDealer) {
		var brake_rotor_style = ($('select#brake_rotor').val() || '').toString();
		switch (brake_rotor_style) {
			case NO_ROTOR_OPTION:
				return 0;
			case '203_mm':
			case '203 x 1.8 mm Fixed':
			case '203mm x 1.8 Fixed':
				return isDealer ? 35 : 46.5;
			case '220_mm':
			case '220 x 1.8 mm Fixed':
			case '220mm x 1.8 Fixed':
			case '220mm Fixed':
			case '220 Fixed':
				return isDealer ? 35 : 46.5;
			case '220_mm_floating':
			case '220_mm_2':
			case '220 x 1.8 mm Floating':
			case '220mm x 2.3 Floating':
			case '220mm x 2.3mm Floating':
			case '220mm Floating':
			case '220 Floating':
				return isDealer ? 49 : 65.5;
			case '240_mm_2':
			case '240mm x 2.3 Floating':
			case '240mm x 2.3 Floating with bracket':
			case '240mm Floating':
				return $('select#wheel_type').val() === "FRONT" ? (isDealer ? 54 : 89.5) : 0;
			default:
				return 0;
		}
	}

	function getBonnell805RxMxBasePrice(isDealer) {
		var rimSize = $('select#rim_size').val();
		if (rimSize === 'FRONT 17x3.00' || rimSize === 'REAR 17x4.25') {
			return isDealer ? 379 : 500;
		}

		return $('select#wheel_type').val() === "FRONT" ? (isDealer ? 304 : 410) : (isDealer ? 329 : 440);
	}

	function applyBonnell805RxMxPricing(isDealer, prices) {
		if (!isBonnell805RxPricingModel()) {
			return prices;
		}

		var basePrice = getBonnell805RxMxBasePrice(isDealer);
		if ($('select#rim_type').val() === "Elite") {
			basePrice += isDealer ? 12 : 20;
		}
		if ($('#cush_drive').val() === "Cush Drive") {
			basePrice += isDealer ? 125 : 175;
		}
		if ($("#sprocket").css('display') == "block" && $('#carrier_id').val() == "Yes") {
			basePrice += isDealer ? 125 : 175;
		}

		prices.base_price = basePrice;
		prices.hub_price = 0;
		prices.brake_price = getBrakePrice();
		prices.sprocket_price = 0;
		return prices;
	}

	function applyStandardEbikePricing(isDealer, prices) {
		if (isBonnell805RxPricingModel()) {
			return applyBonnell805RxMxPricing(isDealer, prices);
		}

		if (isSurronUltraBeePricingModel()) {
			prices.base_price = getSurronUltraBeeBasePrice(isDealer);
			prices.hub_price = getSurronUltraBeeHubPrice(isDealer);
			prices.rim_color = getSurronUltraBeeRimPrice(isDealer);
			prices.spoke_price = getSurronUltraBeeSpokePrice(isDealer);
			prices.nipple_price = getSurronUltraBeeNipplePrice(isDealer);
			prices.brake_price = getSurronUltraBeeBrakePrice(isDealer);
			prices.sprocket_price = getSprocketPrice();
			return prices;
		}

		if (!isStandardEbikePricingModel()) {
			return prices;
		}

		prices.base_price = getStandardEbikeBasePrice(isDealer);
		prices.hub_price = getStandardEbikeHubPrice(isDealer);
		prices.rim_color = getStandardEbikeRimPrice(isDealer);
		prices.spoke_price = getStandardEbikeSpokePrice(isDealer);
		prices.nipple_price = getStandardEbikeNipplePrice(isDealer);
		prices.brake_price = getStandardEbikeBrakePrice(isDealer);
		prices.sprocket_price = getSprocketPrice();
		return prices;
	}

	function getBrakePrice() {
		var role = $(".custom-variant-wrapper").attr('data-role');
		if (isSurronUltraBeePricingModel()) {
			return getSurronUltraBeeBrakePrice(role == "true");
		}
		if (isStandardEbikePricingModel()) {
			return getStandardEbikeBrakePrice(role == "true");
		}
		var brake_price = 0;
		var brake_rotor_style = document.querySelector('#brake_rotor').value;
		switch (brake_rotor_style) {
			case NO_ROTOR_OPTION:
				brake_price = 0;
				break;
            case '240mm x 2.3 Fixed':
				brake_price = role == "true" ? 53 : 70;
				break;
			case '240mm Blue Button Floating Rotor':
				brake_price = role == "true" ? 15 : 20;
				break;
			case '260mm Blue Button Floating Rotor with bracket':
				brake_price = role == "true" ? 45 : 60;
				break;
			case '300mm Blue Button Floating Rotor with bracket':
				brake_price = role == "true" ? 55 : 65;
				break;
			case '220mm X2.3MM Blue Button Floating Rotor':
				brake_price = role == "true" ? 53 : 70;
				break;
			case '240mmx2.3mm Blue Button Floating':
				brake_price = role == "true" ? 53 : 70;
				break;
			case '220MM 1 FixedRotor with Caliper Bracket':
				brake_price = role == "true" ? 25 : 30;
				break;

			case '203mm x 1.8 Fixed': //203_mm
				brake_price = role == "true" ? 25 : 30;
				break;
			case '220mm x 1.8 Fixed': //220_mm
			case '220mm Fixed':
			case '220 Fixed':
				brake_price = role == "true" ? 35 : 46.5;
				break;
			case '220mm x 2.3 Floating': //220_mm_2
			case '220mm Floating':
			case '220 Floating':
				brake_price = role == "true" ? 49 : 65.5;
				break;
			case '240mm x 2.3 Floating with bracket': //240mm_f
				brake_price = role == "true" ? 63 : 80;
				break;
			default:
				// console.log("Unknown rotor style selected");
				brake_price = role == "true" ? 0 : 0;
				break;
		}

		// alert(brake_rotor_style);
		// alert(brake_price);
		return brake_price;
	}

    //Excluding front wheels from having the cost of a sprocket and making sure rear wheels do include a price for both retail and dealer.
    function getSprocketPrice() {
		var role = $(".custom-variant-wrapper").attr('data-role');
		var sprocket_price = 0;
		if (isBonnell805RxPricingModel()) {
			return 0;
		}
            if ($('select#sprocket_size').val() == "no" && $('#wheel_type').val() == "REAR") {
                sprocket_price = 0;
            }
             
            else if ($('#wheel_type').val() == "FRONT"){
            sprocket_price = 0;
            }
            
            else {
                sprocket_price = (isSurronUltraBeePricingModel() || isStandardEbikePricingModel() || isErideSr3Model($('select#bike_model').val())) ? (role == "true" ? 32 : 51) : (role == "true" ? 20 : 28);
            }
		return sprocket_price;
	}

	function updateBrakeRotor() {
		var previous_BR_value = document.querySelector("#brake_rotor").value;
		var rim_size = $('#rim_size').val();
		if (rim_size.split(' ')[1]) {
			rim_size = rim_size.split(' ')[1];
		}
		var wheel_type = $('#wheel_type').val();
		var bike_model = $('#bike_model').val();
		var rim_size = document.querySelector('#rim_size').value;
		var rear_name = ['Rear', 'REAR'];
		var front_name = ['Front', 'FRONT'];
		var brake_rotor_style = [];

		if (rear_name.includes(wheel_type)) {
			// the ultra bee rotor sizes on the rear wheel would be 240mm fixed and 240mm floating.
			if(bike_model == 'Ultra *REAR*'){
				brake_rotor_style = [
					'240 Fixed',
					'240 Floating'
				];
			}
			else if (bike_model == 'SR 3.0 *REAR*') {
				brake_rotor_style = ERIDE_SR_3_REAR_ROTOR_OPTIONS.slice();
			}
			else if (bike_model == 'SRPNT X3 *REAR*') {
				brake_rotor_style = [
					// '203mm x 1.8 Fixed',
					'220mm x 1.8 Fixed',
					'220mm x 2.3 Floating'
				];
			}
			else if (rim_size.includes(16) || rim_size.includes(17) || rim_size.includes(18) || rim_size.includes(19)) {
				brake_rotor_style = [
					'203mm x 1.8 Fixed',
					'220mm x 1.8 Fixed',
					'220mm x 2.3 Floating'
				];
			}
		} else {
			if (rim_size.includes(16) || rim_size.includes(17) || rim_size.includes(19) || rim_size.includes(21)) {
				if(bike_model == 'Ultra *FRONT*'){
					brake_rotor_style = [
						'240 Fixed',
						'240 Floating',
						'260 Floating w/ Bracket',
						'300 Floating w/ Bracket'
					];
				} else if (bike_model == 'SR 3.0 *FRONT*') {
					brake_rotor_style = ERIDE_SR_3_FRONT_ROTOR_OPTIONS.slice();
				} else if (bike_model == 'SRPNT X3 *FRONT*') {
					brake_rotor_style = [
						// '203mm x 1.8 Fixed',
						'220mm x 1.8 Fixed',
						'220mm x 2.3 Floating',
						// '240mm x 2.3 Floating with bracket'
					];
				} else {
					brake_rotor_style = [
						'203mm x 1.8 Fixed',
						'220mm x 1.8 Fixed',
						'220mm x 2.3 Floating',
						'240mm x 2.3 Floating with bracket'
					];
				}
			}
		}
		// console.log(brake_rotor_style);
		var selectElement = document.getElementById('brake_rotor');
		var selected_bike_make = document.querySelector('#bike_make').value;
		var selected_bike_model = document.querySelector('#bike_model').value;

		if (bikeAllowsNoRotorOption(selected_bike_make, selected_bike_model) && !brake_rotor_style.includes(NO_ROTOR_OPTION)) {
			brake_rotor_style.unshift(NO_ROTOR_OPTION);
		}

		selectElement.innerHTML = '';
		brake_rotor_style.forEach(function (brake_rotor) {
			// console.log(brake_rotor)
			var option = document.createElement("option");
			option.value = brake_rotor;
			option.text = brake_rotor;
			if ((selected_bike_make == 'Talaria' && ['XXX *FRONT*', 'XXX *REAR*', 'Sting R *FRONT*', 'Sting R *REAR*', 'Sting MX5 *FRONT*', 'Sting MX5 *REAR*'].includes(selected_bike_model)) || (selected_bike_make == 'ERIDE' && ['PRO-SS *FRONT*', 'PRO-SS *REAR*', 'PRO 2.0 *FRONT*', 'PRO 2.0 *REAR*', 'SR 3.0 *FRONT*', 'SR 3.0 *REAR*', 'SRPNT X3 *FRONT*', 'SRPNT X3 *REAR*'].includes(selected_bike_model))) {
				if (brake_rotor == '220mm x 1.8 Fixed' || brake_rotor == '220mm Fixed') {
					option.selected = true;
				}
			} else if (brake_rotor === previous_BR_value) {
				option.selected = true;
			}
			selectElement.add(option);
		});

	}

	function setupTire() {
		var selected_to = document.getElementById("mbtire").value;

		var rim_size = $('#rim_size').val();
		if (rim_size.split(' ')[1]) {
			rim_size = rim_size.split(' ')[1];
		}
		var wheel_type = $('#wheel_type').val();
		var rear_name = ['Rear', 'REAR'];
		var front_name = ['Front', 'FRONT'];
		var tire_options = [];

		var bike_model = $('#bike_model').val();
		if (['Ultra *REAR*', 'Ultra *FRONT*'].includes(bike_model)) {
			// console.log('Ultra Bee');
			if (['16x1.85', '16X1.85'].includes(rim_size)) {
				tire_options = [
					'DUNLOP MX34 90/100-16',
					'DUNLOP MX53 90/100-16',
					'DUNLOP MX54 90/100-16',
					'SHINKO 525 90/100-16'
				];
			} else if (['17x2.15', '17X2.15', '17x2.50', '17X2.50'].includes(rim_size)) {
				tire_options = [
					'SHINKO 241 17X300'
				];
			} else if (['17x3.00', '17X3.00'].includes(rim_size)) {
				tire_options = [
					'MICHELIN PILOT POWER 2CT 110/70R17',
					// 'SHINKO 241 17X300'
				];
			} else if (['17x4.25', '17X4.25'].includes(rim_size)) {
				tire_options = [
					'MICHELIN PILOT POWER 2CT 150/60R17',
					'BRIDGESTONE BATTLAX S22 140/70-17',
					'CONTINENTAL CONTI ATTACK SM2 140/70-17',
					'DUNLOP GPR-300 140/70R17',
				];
			} else if (['18x1.85', '18X1.85'].includes(rim_size)) {
				tire_options = [
					'DUNLOP MX34 100/100-18',
					'DUNLOP MX54 100/100-18',
					'SHINKO 241 18x350',
					'TUSK EMEX T-35 100/100-18'
				];
			} else if (['18x2.15', '18X2.15'].includes(rim_size)) {
				tire_options = [
					'DUNLOP MX34 100/100-18',
					'DUNLOP MX54 100/100-18',
					'SHINKO 241 18x350',
					'TUSK EMEX T-35 100/100-18'
				];
			} else if (['19x1.60', '19X1.60'].includes(rim_size) && front_name.includes(wheel_type)) {
				tire_options = [
					'DUNLOP MX34 70/100-19',
					'DUNLOP MX53 70/100-19',
					'DUNLOP MX54 70/100-19',
					'SHINKO 524 70/100-19',
					'SHINKO 241 19x275',
					'TUSK GROUND WIRE 80/90-19'
				];
			} else if (['19x1.60', '19X1.60'].includes(rim_size)) {
				tire_options = [
					// removing this front tire as an option for rear wheels'DUNLOP MX34 70/100-19',
					'DUNLOP MX53 70/100-19',
					'DUNLOP MX54 70/100-19',
					'SHINKO 241 19x275',
					'TUSK GROUND WIRE 80/90-19'
				];
			} else if (['21x1.60', '21X1.60'].includes(rim_size)) {
				tire_options = [
					'DUNLOP MX34 80/100-21',
					'DUNLOP MX54 80/100-21',
					'SHINKO  241 21x275',
					'TUSK EMEX T-35 80/100-21'
				];
			}
		} else {
			if (['16x1.85', '16X1.85'].includes(rim_size)) {
				tire_options = [
					'DUNLOP MX34 90/100-16',
					'DUNLOP MX53 90/100-16',
					'DUNLOP MX54 90/100-16',
					'SHINKO 525 90/100-16',
					'SHINKO 241 16x300'
				];
			} else if (['17x2.15', '17X2.15', '17x2.50', '17X2.50'].includes(rim_size)) {
				tire_options = [
					'MICHELIN PS 2 90/80-17',
					'SHINKO 241 17X300',
					'Michelin City Extra'
				];
			} else if (['17x3.00', '17X3.00'].includes(rim_size)) {
				tire_options = [
					'SHINKO 241 17X300',
					'MICHELIN PS 2 110/70-17'
				];
			} else if (['18x1.85', '18X1.85'].includes(rim_size)) {
				tire_options = [
					'DUNLOP MX33 90/100-18 REAR',
					'KENDA K257D KLASSIC 3.50-18',
					'SHINKO 241 18x350'
				];
			} else if (['19x1.60', '19X1.60'].includes(rim_size) && front_name.includes(wheel_type)) {
				tire_options = [
					'SHINKO 524 70/100-19',
					'DUNLOP MX34 70/100-19',
					'DUNLOP MX53 70/100-19',
					'DUNLOP MX54 70/100-19',
					'SHINKO 241 19x275'
				];
			} else if (['19x1.60', '19X1.60'].includes(rim_size) && rear_name.includes(wheel_type)) {
				tire_options = [
					// removing this front tire as an option for rear wheels'DUNLOP MX34 70/100-19',
					'DUNLOP MX53 70/100-19',
					'DUNLOP MX54 70/100-19',
					'SHINKO 241 19x275',
				];
			} else if (['19x1.60', '19X1.60'].includes(rim_size)) {
				tire_options = [
					// removing this front tire as an option for rear wheels'DUNLOP MX34 70/100-19',
					'DUNLOP MX53 70/100-19',
					'DUNLOP MX54 70/100-19',
					'SHINKO 524 70/100-19',
					'SHINKO 241 19x275',
					'TUSK GROUND WIRE 70/100-19',
				];
			} else if (['21x1.60', '21X1.60'].includes(rim_size)) {
				tire_options = [
					'DUNLOP MX34 80/100-21',
					'DUNLOP MX54 80/100-21',
					'SHINKO  241 21x275',
					'TUSK EMEX T-35 80/100-21'
				];
			}

		}
		var selectElement = document.getElementById("mbtire");
		selectElement.innerHTML = '<option class="category" value="mbno" selected="">No</option>';
		selectElement.length = 1;
		tire_options.forEach(function (tireOption) {
			var option = document.createElement("option");
			option.value = tireOption;
			option.text = tireOption;
			if (tireOption == selected_to) {
				option.selected = true;
			}
			selectElement.add(option);
		});
	}

	function updateRimSize() {
		const bikeMake = $('#bike_make').val();
		const bikeModel = $('#bike_model').val();
		const wheelType = $('#wheel_type').val();

		var previousValue = $('#rim_size').val();
		const rimSizes = {
			FRONT: {
				default: {
					'FRONT 16x1.65': 'FRONT 16x1.65',
					'FRONT 17x2.15': 'FRONT 17x2.15',
					'FRONT 17x2.50': 'FRONT 17x2.50',
					'FRONT 21x1.60': 'FRONT 21x1.60',
					'FRONT 19x1.60': 'FRONT 19x1.60',
				},
				Ultra: {
					'FRONT 17x3.00': 'FRONT 17x3.00',
					'FRONT 19x1.60': 'FRONT 19x1.60',
					'FRONT 21x1.60': 'FRONT 21x1.60',
				},
				Bonnell805RX: {
					'FRONT 17x3.00': 'FRONT 17x3.00',
					'FRONT 21x1.60': 'FRONT 21x1.60',
				}
			},
			REAR: {
				default: {
					'REAR 17x2.50': 'REAR 17x2.50',
					'REAR 18x1.85': 'REAR 18x1.85',
					'REAR 19x1.60': 'REAR 19x1.60',
					'REAR 16x1.85': 'REAR 16x1.85',
				},
				Talaria: {
					'REAR 17x3.00': 'REAR 17x3.00',
					'REAR 17x2.50': 'REAR 17x2.50',
					'REAR 18x1.85': 'REAR 18x1.85',
					'REAR 19x1.60': 'REAR 19x1.60',
					'REAR 16x1.85': 'REAR 16x1.85',
				},
				Surron: {
					'REAR 17x3.00': 'REAR 17x3.00',
					'REAR 17x2.50': 'REAR 17x2.50',
					'REAR 18x1.85': 'REAR 18x1.85',
					'REAR 19x1.60': 'REAR 19x1.60',
					'REAR 16x1.85': 'REAR 16x1.85',
				},
				Ultra: {
					'REAR 17x4.25': 'REAR 17x4.25',
					'REAR 18x1.85': 'REAR 18x1.85',
					'REAR 18x2.15': 'REAR 18x2.15',
					'REAR 19x1.60': 'REAR 19x1.60',
					'REAR 16x1.85': 'REAR 16x1.85',
				},
				ERIDE: {
					'REAR 17x2.50': 'REAR 17x2.50',
					'REAR 17x3.00': 'REAR 17x3.00',
					'REAR 18x1.85': 'REAR 18x1.85',
					'REAR 19x1.60': 'REAR 19x1.60',
					'REAR 16x1.85': 'REAR 16x1.85',
				},
				Altis: {
					'REAR 17x3.00': 'REAR 17x3.00',
					'REAR 17x2.50': 'REAR 17x2.50',
					'REAR 18x1.85': 'REAR 18x1.85',
					'REAR 19x1.60': 'REAR 19x1.60',
					'REAR 16x1.85': 'REAR 16x1.85',
				},
				Bonnell805RX: {
					'REAR 17x4.25': 'REAR 17x4.25',
					'REAR 18x2.15': 'REAR 18x2.15',
				}
			}
		};

		function updateRimSizeOptions(rimSizeOptions) {
			const rimSizeElement = $('#rim_size');
			rimSizeElement.empty();
			$.each(rimSizeOptions, function (value, text) {
				rimSizeElement.append($('<option>', {
					value,
					text
				}));
			});

			// Preselect the previous option if it exists in the new list
			if (rimSizeOptions[previousValue]) {
				rimSizeElement.val(previousValue);
			} else {
				rimSizeElement.prop('selectedIndex', 0); // Default to the first option
			}
			rimSizeElement.change();
			tprice();
		}

		if (bikeModel && bikeModel.includes('FRONT')) {
			if (bikeMake === 'Bonnell' && bikeModel === '805RX *FRONT*') {
				updateRimSizeOptions(rimSizes.FRONT.Bonnell805RX);
			} else if (bikeModel === 'Ultra *FRONT*') {
				updateRimSizeOptions(rimSizes.FRONT.Ultra);
			} else {
				updateRimSizeOptions(rimSizes.FRONT.default);
			}
		} else if (wheelType === 'REAR') {
			if (bikeMake === 'Bonnell' && bikeModel === '805RX *REAR*') {
				updateRimSizeOptions(rimSizes.REAR.Bonnell805RX);
			} else if (bikeMake === 'Talaria' && bikeModel === 'Sting *REAR*') {
				updateRimSizeOptions(rimSizes.REAR.Talaria);
			} else if (bikeMake === 'Surron' && bikeModel === 'X *REAR*' || bikeMake === 'Altis' && bikeModel === 'X *REAR*') {
				updateRimSizeOptions(rimSizes.REAR.Surron);
			} else if (bikeModel === 'Ultra *REAR*') {
				updateRimSizeOptions(rimSizes.REAR.Ultra);
			} else if (bikeMake === 'ERIDE' && (bikeModel === 'PRO-SS *REAR*' || bikeModel === 'PRO 2.0 *REAR*' || bikeModel === 'SR 3.0 *REAR*' || bikeModel === 'SRPNT X3 *REAR*')) {
				updateRimSizeOptions(rimSizes.REAR.ERIDE);
			} else {
				updateRimSizeOptions(rimSizes.REAR.default);
			}
		} else {
			updateRimSizeOptions(rimSizes.FRONT.default);
		}
	}

	$(document).ready(updateRimSize);
	$('#bike_make').on('change', updateRimSize);
	$('#bike_model').on('change', updateRimSize);
	$('#bike_year').on('change', updateRimSize);
	$('#wheel_type').on('change', updateRimSize);


	function showHideRimLock(){
		var selected_bike_make = $('#bike_make').val();
		var selected_bike_model = $('#bike_model').val();
		var selected_rim_size = $('#rim_size').val();
		if (selected_rim_size === "FRONT 21x1.60" || 
			selected_rim_size === "FRONT 19x1.60" || 
			selected_rim_size === "REAR 16x1.85" || 
			selected_rim_size === "REAR 18x1.85" ||
			selected_rim_size.includes("16") ||
			selected_rim_size.includes("18") || 
			selected_rim_size.includes("19") || 
		(selected_bike_make === "Surron" &&
			selected_bike_model.includes("Ultra") &&
			(selected_rim_size.includes("16") || selected_rim_size.includes("18"))
			)
		) {

			$("#rim_lock_field").show();
			$("#resultAreaID_1_9").show();
		} else {
			$("#rim_lock").val($("#rim_lock option:first").val());
			$("#rim_lock_field").hide();
			$("#resultAreaID_1_9").hide();
		}
	}

	$(document).on('change', 'select:not(#rim_lock), input', function () {
		showHideRimLock();
	});
	$(document).on('change', 'select:not(#mbtire), input', function () {
		setupTire();
	});
	function applyEliteBlackRimOnly() {
		if ($('#rim_type').val() !== 'Elite') {
			return false;
		}

		$('.rim-type-wrap.powder-coat, .rim-type-wrap[data-category="powder-coat"]').hide().removeClass('active');
		$('.rim-type-wrap.anodized, .rim-type-wrap[data-category="anodized"]').show().addClass('active');

		var $rimColorSwatches = $('.rim_color_wrapper .color-swatch');
		$rimColorSwatches.removeClass('show active').hide();
		var $blackRim = $rimColorSwatches.filter('[data-category="anodized"][data-value="Black"]').first();
		if (!$blackRim.length) {
			$blackRim = $rimColorSwatches.filter('[data-value="Black"]').first();
		}

		$blackRim.addClass('show active').show();
		$('#rim_color').val('Black');
		return true;
	}

	function showColors(category) {
		$('.rim_color_wrapper .color-swatch').removeClass('show');
		$('.rim_color_wrapper .color-swatch').hide();
		$('.rim_color_wrapper .color-swatch[data-category="' + category + '"]').addClass('show');

		if (applyEliteBlackRimOnly()) {
			return;
		}

		var sizes = ["17x3.00"];
		var selectedSize = $('#rim_size').val();
		if (selectedSize) {
			var exists = sizes.some(size => selectedSize.includes(size));
			if (exists && $('.rim-type-wrap.anodized.active').data('category') == "anodized") {
				$(".rim_color_wrapper .color-swatch").each(function () {
					if ($(this).data('value') == "Black") {
						$(this).show();
						$(this).removeClass('hide');
						$(this).addClass('show');
					} else {
						$(this).hide();
						$(this).removeClass('show');
						$(this).addClass('hide');
					}
				});
			}
		}

		if ($('#rim_type').val() == "Elite" && $('#bike_make').val() == "Surron") {
			if ($('#rim_size').val() == 'FRONT 21x1.60' || $('#rim_size').val() == 'REAR 18x1.85' || $('#rim_size').val() == 'REAR 18x2.15') {
				$('.rim_color_wrapper [title="Matte-Black / Anodized"]').removeClass('show');
				$('.rim_color_wrapper [title="Matte-Black"]').removeClass('show');
				$('.rim_color_wrapper [title="Blue"]').removeClass('show');
			}
		}

		if ($('#bike_make').val() == "Surron" && ($('#bike_model').val() == "Ultra *FRONT*" || $('#bike_model').val() == "Ultra *REAR*")) {
			if ($('.rim-type-wrap.anodized.active').data('category') == "anodized") {
				$(".rim_color_wrapper .color-swatch").each(function () {
					if ($(this).data('value') == "Black") {
						$(this).show();
						$(this).removeClass('hide');
						$(this).addClass('show');
					} else {
						$(this).hide();
						$(this).removeClass('show');
						$(this).addClass('hide');
					}
				});
			}
		}
		if ($('#bike_make').val() == "Surron" && ($('#bike_model').val() == "Ultra *FRONT*" || $('#bike_model').val() == "Ultra *REAR*")) {
			var allow_color = ['19x1.60', '18x1.85', '18x2.15', '16x1.85', '19x1.60', '21x1.60'];
			var selectedSize = $('#rim_size').val();
			var rim_size = selectedSize.match(/\d+x\d+\.\d+/)[0];  // Extracts '16x1.65' using regex

			

			if ($('.rim-type-wrap.anodized.active').data('category') == "anodized") {
				if (allow_color.includes(rim_size)) {
					console.log('Rim size is allowed');			
					$('.rim_color_wrapper .color-swatch[data-category="anodized"]').each(function () {
						var allow_color = ['Black', 'Matte-Black', 'Blue', 'Green', 'Gold', 'Magnesium', 'Orange', 'Purple', 'Red'];
						if (allow_color.includes($(this).data('value') )) {
							$(this).show();
							$(this).removeClass('hide');
							$(this).addClass('show');
						} else {
							$(this).hide();
							$(this).removeClass('show');
							$(this).addClass('hide');
						}
					});
			}
			}
		}
	}

	showColors('anodized');

	$('.rim-type-wrap').click(function () {
		// console.log('here');
		$('.rim-type-wrap').removeClass('active');
		$(this).addClass('active');
		var category = $(this).attr('data-category');
		showColors(category);
		$('.color-swatch[data-category="' + category + '"].show').eq(0).click();
	});
	$(document).on('change', '#rim_size', function () {
		$('.rim-type-wrap.active').click()
	})
	var role = $(".custom-variant-wrapper").attr('data-role');
	var images = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/e-";
	var colorImages = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/";
	var new_base_price = 304;
	var base_price = 304;
	var dealerprice = 225;
	if (role == "true") {
		$('#price').text('$' + dealerprice);
	}
	$("#bike_make").prop("selectedIndex", 0);
	//husqvarna = hq
	var hqf1 = 'CR 125 *FRONT*';
	var hqf2 = 'SM 125 *FRONT*';
	var hqf3 = 'TC125 *FRONT*';
	var hqf4 = 'TE 125 *FRONT*';
	var hqf5 = 'TX125 *FRONT*';
	var hqf6 = 'TXC 125 *FRONT*';
	var hqf7 = 'WR 125 *FRONT*';
	var hqf8 = 'TE150 *FRONT*';
	var hqf9 = 'FC 250 *FRONT*';
	var hqf10 = 'TC 250 *FRONT*';
	var hqf11 = 'FE 250 *FRONT*';
	var hqf12 = 'TE 250 *FRONT*';
	var hqf13 = 'TE250I *FRONT*';
	var hqf14 = 'SM 250 *FRONT*';
	var hqf15 = 'TXC 250 *FRONT*';
	var hqf16 = 'WR 250 *FRONT*';
	var hqf17 = 'CR 250 *FRONT*';
	var hqf18 = '2014 - 17 TE300 *FRONT*';
	var hqf19 = 'TE300I *FRONT*';
	var hqf20 = 'TX300 *FRONT*';
	var hqf21 = 'TX300i *FRONT*';
	var hqf22 = 'FC350 *FRONT*';
	var hqf23 = 'FE350 *FRONT*';
	var hqf24 = 'FX350 *FRONT*';
	var hqf25 = 'SM 449 *FRONT*';
	var hqf26 = 'TC 449 *FRONT*';
	var hqf27 = 'TE 449 *FRONT*';
	var hqf28 = 'TXC 449 *FRONT*';
	var hqf29 = 'WR 449 *FRONT*';
	var hqf30 = 'CR 449 *FRONT*';
	var hqf31 = 'CR 450 *FRONT*';
	var hqf32 = '2014 - 17 FC450 *FRONT*';
	var hqf33 = 'FC450 Rockstar Edition *FRONT*';
	var hqf34 = 'FE450 *FRONT*';
	var hqf35 = 'FX450 *FRONT*';
	var hqf36 = 'SM 450 *FRONT*';
	var hqf37 = 'TC 450 *FRONT*';
	var hqf38 = 'TE 450 *FRONT*';
	var hqf39 = 'TXC 450 *FRONT*';
	var hqf40 = 'WR 450 *FRONT*';
	var hqf41 = '2014 - 17 FE501 *FRONT*';
	var hqf42 = 'SM 510 *FRONT*';
	var hqf43 = 'TC 510 *FRONT*';
	var hqf44 = 'TE 510 *FRONT*';
	var hqf45 = 'TXC 510 *FRONT*';
	var hqf46 = 'WR 510 *FRONT*';
	var hqf47 = 'CR 510 *FRONT*';
	var hqf48 = 'SM 610 *FRONT*';
	var hqf49 = 'TC 610 *FRONT*';
	var hqf50 = 'TE 610 *FRONT*';
	var hqf51 = 'TXC 610 *FRONT*';
	var hqf52 = 'WR 610 *FRONT*';
	var hqf53 = 'CR 610 *FRONT*';
	var hqf54 = '701 Enduro ABS *FRONT*';
	var hqr1 = 'CR 125 *REAR*';
	var hqr2 = 'SM 125 *REAR*';
	var hqr3 = '2014 - 17 TC125 *REAR*';
	var hqr4 = 'TE 125 *REAR*';
	var hqr5 = 'TX125 *REAR*';
	var hqr6 = 'TXC 125 *REAR*';
	var hqr7 = 'WR 125 *REAR*';
	var hqr8 = 'TE150 *REAR*';
	var hqr9 = '2014 - 17 FC 250 *REAR*';
	var hqr10 = '2014 - 17 TC 250 *REAR*';
	var hqr11 = '2014 - 17 FE 250 *REAR*';
	var hqr12 = '2014 - 17 TE 250 *REAR*';
	var hqr13 = 'TE250I *REAR*';
	var hqr14 = 'SM 250 *REAR*';
	var hqr15 = 'TXC 250 *REAR*';
	var hqr16 = 'WR 250 *REAR*';
	var hqr17 = 'CR 250 *REAR*';
	var hqr18 = '2014 - 17 TE300 *REAR*';
	var hqr19 = 'TE300I *REAR*';
	var hqr20 = 'TX300 *REAR*';
	var hqr21 = 'TX300i *REAR*';
	var hqr22 = 'FC350 *REAR*';
	var hqr23 = 'FE350 *REAR*';
	var hqr24 = 'FX350 *REAR*';
	var hqr25 = 'SM 449 *REAR*';
	var hqr26 = 'TC 449 *REAR*';
	var hqr27 = 'TE 449 *REAR*';
	var hqr28 = 'TXC 449 *REAR*';
	var hqr29 = 'WR 449 *REAR*';
	var hqr30 = 'CR 449 *REAR*';
	var hqr31 = 'CR 450 *REAR*';
	var hqr32 = '2014 - 17 FC450 *REAR*';
	var hqr33 = 'FC450 Rockstar Edition *REAR*';
	var hqr34 = 'FE450 *REAR*';
	var hqr35 = 'FX450 *REAR*';
	var hqr36 = 'SM 450 *REAR*';
	var hqr37 = 'TC 450 *REAR*';
	var hqr38 = 'TE 450 *REAR*';
	var hqr39 = 'TXC 450 *REAR*';
	var hqr40 = 'WR 450 *REAR*';
	var hqr41 = '2014 - 17 FE501 *REAR*';
	var hqr42 = 'SM 510 *REAR*';
	var hqr43 = 'TC 510 *REAR*';
	var hqr44 = 'TE 510 *REAR*';
	var hqr45 = 'TXC 510 *REAR*';
	var hqr46 = 'WR 510 *REAR*';
	var hqr47 = 'CR 510 *REAR*';
	var hqr48 = 'SM 610 *REAR*';
	var hqr49 = 'TC 610 *REAR*';
	var hqr50 = 'TE 610 *REAR*';
	var hqr51 = 'TXC 610 *REAR*';
	var hqr52 = 'WR 610 *REAR*';
	var hqr53 = 'CR 610 *REAR*';
	var hqr54 = '701 Enduro ABS *REAR*';
	//honda = hn
	var hnf1 = '1995 - 99 CR125, CR250 *FRONT*';
	var hnf2 = '2000 - 11 CR125, CR250 *FRONT*';
	var hnf3 = '2017+ CRF250L *FRONT*';
	var hnf4 = 'CRF250L ABS *FRONT*';
	var hnf5 = '2017+ CRF250L Rally *FRONT*';
	var hnf6 = '2004 - 14 CRF250R *FRONT*';
	var hnf7 = '2004 - 2017 CRF250X *FRONT*';
	var hnf8 = 'CRF250RX *FRONT*';
	var hnf9 = '1996 - 04 XR400 *FRONT*';
	var hnf10 = '2002 - 14 CRF450R *FRONT*';
	var hnf11 = 'CRF450R Works Edition *FRONT*';
	var hnf12 = 'CRF450L *FRONT*';
	var hnf13 = '2003 - 2017 CRF450X *FRONT*';
	var hnf14 = '2017+  CRF450RX *FRONT*';
	var hnf15 = '1995 - 01 CR500 *FRONT*';
	var hnf16 = '1991 - 00 XR600 *FRONT*';
	var hnf17 = '1993 - 2017 XR650L *FRONT*';
	var hnf18 = '2000 - 08 XR650R *FRONT*';
	var hnf19 = '2016 - 2017 CRF1000L *FRONT*';
	var hnf20 = 'CRF450RL *FRONT*';
	var hnr1 = '1989 - 97 CR125, CR250 *REAR*';
	var hnr2 = '2000 - 12 CR125, CR250 *REAR*';
	var hnr3 = '2017+ CRF250L *REAR*';
	var hnr4 = 'CRF250L ABS *REAR*';
	var hnr5 = '2017+ CRF250L Rally *REAR*';
	var hnr6 = '2004 - 13 CRF250R *REAR*';
	var hnr7 = '2004 - 2017 CRF250X *REAR*';
	var hnr8 = 'CRF250RX *REAR*';
	var hnr9 = '1996 - 04 XR 400 *REAR*';
	var hnr10 = '2002 - 12 CRF450R *REAR*';
	var hnr11 = 'CRF450R Works Edition *REAR*';
	var hnr12 = 'CRF450L *REAR*';
	var hnr20 = 'CRF450RL *REAR*';
	var hnr13 = '2002 - 2017 CRF450X *REAR*';
	var hnr14 = '2017+ CRF450RX *REAR*';
	var hnr15 = '1989 - 01 CR500 *REAR*';
	var hnr16 = '1993 - 00 XR600 *REAR*';
	var hnr17 = '1993 - 2017 XR650L *REAR*';
	var hnr18 = '2000 - 08 XR650R *REAR*';
	var hnr19 = '2016 - 2017 CRF1000L *REAR*';
	//ktm = ktm
	var ktmf1 = 'EXC125 *FRONT*';

	function rimcolorhideblue() {
		if (!$('select#rim_size').val() == "REAR 17x1.60") {
			if ($('select#rim_size').val() == "FRONT 21x1.60" || $('select#wheel_type').val() == 'REAR') {
				var select = $('#rim_color');
				select.val('Black');
				// select.empty().append('<option class="opdis" value="Anodized" disabled>Anodized</option><option class="category" value="Black">Black</option><option class="category" value="Blue">Blue</option><option class="category" value="Gold">Gold</option><option class="category" value="Magnesium">Magnesium</option><option class="category" value="Matte-Black">Matte Black</option><option class="category" value="Purple">Purple</option><option class="category" value="Red">Red</option><option class="category" value="Silver">Silver</option><option class="opdis" value="Powder-Coated" disabled>Powder Coated</option><option class="category" value="Blue">Blue</option><option class="category" value="Baby-Blue">Baby Blue</option><option class="category" value="Flo-Yellow">Flo Yellow</option><option class="category" value="Nardo-Grey">Nardo Grey</option><option class="category" value="Orange">Orange</option><option class="category" value="School-Bus-Yellow">School Bus Yellow</option><option class="category" value="White">White</option>'); 
				var rim_color_wrapper = $('.rim_color_wrapper');
				// console.log("in rimcolorhideblue");
				// rim_color_wrapper.empty().append(`
				//     <div class="color-swatch active show" data-category="anodized" data-value="Black" title="Black" style="background: url(${colorImages}black.svg?v=1717478021);"></div>
				//     <div class="color-swatch" data-category="powder-coat" data-value="Blue" title="Blue" style="background: url(${colorImages}blue.svg?v=1717478021);"></div>
				//     <div class="color-swatch" data-category="powder-coat" data-value="Gold" title="Gold" style="background: url(${colorImages}gold.svg?v=1717478021);"></div>
				//     <div class="color-swatch" data-category="powder-coat" data-value="Magnesium" title="Magnesium" style="background: url(${colorImages}magnesium.svg?v=1717478021);"></div>
				//     <div class="color-swatch" data-category="powder-coat" data-value="Matte-Black" title="Matte-Black" style="background: url(${colorImages}matte-black.svg?v=1717478021);"></div>
				//     <div class="color-swatch" data-category="powder-coat" data-value="Purple" title="Purple" style="background: url(${colorImages}purple.svg?v=1717478021);"></div>
				//     <div class="color-swatch" data-category="powder-coat" data-value="Red" title="Red" style="background: url(${colorImages}red.svg?v=1717478021);"></div>
				//     <div class="color-swatch" data-category="powder-coat" data-value="Silver" title="Silver" style="background: url(${colorImages}silver.svg?v=1717478021);"></div>
				//     <div class="color-swatch" data-category="powder-coat" data-value="Blue" title="Blue" style="background: url(${colorImages}blue.svg?v=1717478021);"></div>
				//     <div class="color-swatch" data-category="powder-coat" data-value="Baby-Blue" title="Baby-Blue" style="background: url(${colorImages}baby-blue.svg?v=1717478021);"></div>
				//     <div class="color-swatch" data-category="powder-coat" data-value="Flo-Yellow" title="Flo-Yellow" style="background: url(${colorImages}flo-yellow.svg?v=1717478021);"></div>
				//     <div class="color-swatch" data-category="powder-coat" data-value="Nardo-Grey" title="Nardo-Grey" style="background: url(${colorImages}nardo-grey.svg?v=1717478021);"></div>
				//     <div class="color-swatch" data-category="powder-coat" data-value="Orange" title="Orange" style="background: url(${colorImages}orange.svg?v=1717478021);"></div>
				//     <div class="color-swatch" data-category="powder-coat" data-value="School-Bus-Yellow" title="School-Bus-Yellow" style="background: url(${colorImages}school-bus-yellow.svg?v=1717478021);"></div>
				//     <div class="color-swatch" data-category="powder-coat" data-value="White" title="White" style="background: url(${colorImages}white.svg?v=1717478021);"></div>
				// `);

				var image_name = images + "rim-" + $('#rim_color').val() + "-" + $('select#wheel_type').val() + ".png";
				var imageArr2 = [image_name];
				var divArr2 = ["resultAreaID_1_1"];
				$('#resultAreaID_1_1 img').attr('src', image_name);
			}
		} else if ($('select#rim_size').val() == "FRONT 19x1.60" || $('select#rim_size').val() == "FRONT 21x1.60" || $('select#rim_size').val() == "REAR 16x1.85" || $('select#rim_size').val() == "REAR 19x1.60" || $('select#rim_size').val() == "REAR 18x1.85" || $('select#rim_size').val() === "REAR 18x2.15") {
			var select = $('#rim_color');
			select.val('Black');
			// select.empty().append('<option class="opdis" value="Anodized" disabled>Anodized</option><option class="category" value="Black">Black</option><option class="category" value="Blue">Blue</option><option class="category" value="Gold">Gold</option><option class="category" value="Magnesium">Magnesium</option><option class="category" value="Matte-Black">Matte Black</option><option class="category" value="AOrange">Orange</option><option class="category" value="Purple">Purple</option><option class="category" value="Red">Red</option><option class="category" value="Silver">Silver</option><option class="opdis" value="Powder-Coated" disabled>Powder Coated</option><option class="category" value="Blue">Blue</option><option class="category" value="Baby-Blue">Baby Blue</option><option class="category" value="Flo-Yellow">Flo Yellow</option><option class="category" value="Nardo-Grey">Nardo Grey</option><option class="category" value="Orange">Orange</option><option class="category" value="School-Bus-Yellow">School Bus Yellow</option><option class="category" value="White">White</option>'); 
			var rim_color_wrapper = $('.rim_color_wrapper');
			// console.log("in rimcolorhideblue");
			// rim_color_wrapper.empty().append(`
			//      <div class="color-swatch active show" data-category="anodized" data-value="Black" title="Black" style="background: url(${colorImages}black.svg?v=1717478021);"></div>
			//      <div class="color-swatch" data-category="powder-coat" data-value="Blue" title="Blue" style="background: url(${colorImages}blue.svg?v=1717478021);"></div>
			//      <div class="color-swatch" data-category="powder-coat" data-value="Gold" title="Gold" style="background: url(${colorImages}gold.svg?v=1717478021);"></div>
			//      <div class="color-swatch" data-category="powder-coat" data-value="Magnesium" title="Magnesium" style="background: url(${colorImages}magnesium.svg?v=1717478021);"></div>
			//      <div class="color-swatch" data-category="powder-coat" data-value="Matte-Black" title="Matte-Black" style="background: url(${colorImages}matte-black.svg?v=1717478021);"></div>
			//      <div class="color-swatch" data-category="powder-coat" data-value="Purple" title="Purple" style="background: url(${colorImages}purple.svg?v=1717478021);"></div>
			//      <div class="color-swatch" data-category="powder-coat" data-value="Red" title="Red" style="background: url(${colorImages}red.svg?v=1717478021);"></div>
			//      <div class="color-swatch" data-category="powder-coat" data-value="Silver" title="Silver" style="background: url(${colorImages}silver.svg?v=1717478021);"></div>
			//      <div class="color-swatch" data-category="powder-coat" data-value="Blue" title="Blue" style="background: url(${colorImages}blue.svg?v=1717478021);"></div>
			//      <div class="color-swatch" data-category="powder-coat" data-value="Baby-Blue" title="Baby-Blue" style="background: url(${colorImages}baby-blue.svg?v=1717478021);"></div>
			//      <div class="color-swatch" data-category="powder-coat" data-value="Flo-Yellow" title="Flo-Yellow" style="background: url(${colorImages}flo-yellow.svg?v=1717478021);"></div>
			//      <div class="color-swatch" data-category="powder-coat" data-value="Nardo-Grey" title="Nardo-Grey" style="background: url(${colorImages}nardo-grey.svg?v=1717478021);"></div>
			//      <div class="color-swatch" data-category="powder-coat" data-value="Orange" title="Orange" style="background: url(${colorImages}orange.svg?v=1717478021);"></div>
			//      <div class="color-swatch" data-category="powder-coat" data-value="School-Bus-Yellow" title="School-Bus-Yellow" style="background: url(${colorImages}school-bus-yellow.svg?v=1717478021);"></div>
			//      <div class="color-swatch" data-category="powder-coat" data-value="White" title="White" style="background: url(${colorImages}white.svg?v=1717478021);"></div>
			//  `);

			var image_name = images + "rim-" + $('#rim_color').val() + "-" + $('select#wheel_type').val() + ".png";
			var imageArr2 = [image_name];
			var divArr2 = ["resultAreaID_1_1"];
			$('#resultAreaID_1_1 img').attr('src', image_name);
		}
	}

	//Rim Color Only Black
	function rimcolorblack() {
		if ($('select#rim_size').val() == "FRONT 16x1.65") {
			var select = $('#rim_color');
			select.val('Black');
			//Rim Color Temp Hide
			// select.empty().append('<option class="opdis" value="Anodized" disabled>Anodized</option><option class="category" value="Black">Black</option><option class="opdis" value="Powder-Coated" disabled>Powder Coated</option><option class="category" value="Blue">Blue</option><option class="category" value="Baby-Blue">Baby Blue</option><option class="category" value="Flo-Yellow">Flo Yellow</option><option class="category" value="Nardo-Grey">Nardo Grey</option><option class="category" value="Orange">Orange</option><option class="category" value="School-Bus-Yellow">School Bus Yellow</option><option class="category" value="White">White</option>');
			var rim_color_wrapper = $('.rim_color_wrapper');
			// console.log("in rimcolorblack");
			// rim_color_wrapper.empty().append(`<div class="color-swatch category active show" title="Black" data-category="anodized" data-value="Black" style="background: url(${colorImages}black.svg?v=1717478021);"></div>
			//            <div class="color-swatch category" title="Blue"  data-category="powder-coat" data-value="Blue" style="background: url(${colorImages}blue.svg?v=1717478021);"></div>
			//            <div class="color-swatch category" title="Baby-Blue" data-category="powder-coat" data-value="Baby-Blue" style="background: url(${colorImages}baby-blue.svg?v=1717478021);"></div>
			//            <div class="color-swatch category" title="Flo-Yellow" data-category="powder-coat" data-value="Flo-Yellow" style="background: url(${colorImages}flo-yellow.svg?v=1717478021);"></div>
			//            <div class="color-swatch category" title="Nardo-Grey" data-category="powder-coat" data-value="Nardo-Grey" style="background: url(${colorImages}nardo-grey.svg?v=1717478021);"></div>
			//            <div class="color-swatch category" title="Orange"  data-category="powder-coat" data-value="Orange" style="background: url(${colorImages}orange.svg?v=1717478021);"></div>
			//            <div class="color-swatch category" title="School-Bus-Yellow" data-category="powder-coat" data-value="School-Bus-Yellow" style="background: url(${colorImages}school-bus-yellow.svg?v=1717478021);"></div>
			//            <div class="color-swatch category" title="White" data-category="powder-coat" data-value="White" style="background: url(${colorImages}white.svg?v=1717478021);"></div>
			//            `);
			var image_name = images + "rim-" + $('#rim_color').val() + "-" + $('select#wheel_type').val() + ".png";
			var imageArr2 = [image_name];
			var divArr2 = ["resultAreaID_1_1"];
			$('#resultAreaID_1_1 img').attr('src', image_name);

			$("#mbtiretr").hide();
		} else if ($('select#rim_size').val() == "FRONT 17x2.50" || $('select#rim_size').val() == "FRONT 17x2.15" || $('select#rim_size').val() == "REAR 17x2.50") {
			var select = $('#rim_color');
			select.val('Black');
			//Rim Color Temp Hide
			// select.empty().append('<option class="opdis" value="Anodized" disabled>Anodized</option><option class="category" value="Black">Black</option><option class="opdis" value="Powder-Coated" disabled>Powder Coated</option><option class="category" value="Blue">Blue</option><option class="category" value="Baby-Blue">Baby Blue</option><option class="category" value="Flo-Yellow">Flo Yellow</option><option class="category" value="Nardo-Grey">Nardo Grey</option><option class="category" value="Orange">Orange</option><option class="category" value="School-Bus-Yellow">School Bus Yellow</option><option class="category" value="White">White</option>');
			var rim_color_wrapper = $('.rim_color_wrapper');
			// console.log("in rimcolorblack else");
			// rim_color_wrapper.empty().append(`
			//                  <div class="color-swatch category active show" data-category="anodized" data-value="Black" title="Black" style="background: url(${colorImages}black.svg?v=1717478021);"></div>
			//                  <div class="color-swatch category" data-category="powder-coat" data-value="Blue" title="Blue" style="background: url(${colorImages}blue.svg?v=1717478021);"></div>
			//                  <div class="color-swatch category" data-category="powder-coat" data-value="Baby-Blue" title="Baby-Blue" style="background: url(${colorImages}baby-blue.svg?v=1717478021);"></div>
			//                  <div class="color-swatch category" data-category="powder-coat" data-value="Flo-Yellow" title="Flo-Yellow" style="background: url(${colorImages}flo-yellow.svg?v=1717478021);"></div>
			//                  <div class="color-swatch category" data-category="powder-coat" data-value="Nardo-Grey" title="Nardo-Grey" style="background: url(${colorImages}nardo-grey.svg?v=1717478021);"></div>
			//                  <div class="color-swatch category" data-category="powder-coat" data-value="Orange" title="Orange" style="background: url(${colorImages}orange.svg?v=1717478021);"></div>
			//                  <div class="color-swatch category" data-category="powder-coat" data-value="School-Bus-Yellow" title="School-Bus-Yellow" style="background: url(${colorImages}school-bus-yellow.svg?v=1717478021);"></div>
			//                  <div class="color-swatch category" data-category="powder-coat" data-value="White" title="White" style="background: url(${colorImages}white.svg?v=1717478021);"></div>
			//              `);

			var image_name = images + "rim-" + $('#rim_color').val() + "-" + $('select#wheel_type').val() + ".png";
			var imageArr2 = [image_name];
			var divArr2 = ["resultAreaID_1_1"];
			$('#resultAreaID_1_1 img').attr('src', image_name);

			$("#mbtiretr").show();
		} else if ($('select#rim_size').val() == "FRONT 19x1.60" || $('select#rim_size').val() == "FRONT 21x1.60" || $('select#rim_size').val() == "REAR 16x1.85" || $('select#rim_size').val() == "REAR 19x1.60" || $('select#rim_size').val() == "REAR 18x1.85" || $('select#rim_size').val() === "REAR 18x2.15") {
			var select = $('#rim_color');
			select.val('Black')
			var rim_color_wrapper = $('.rim_color_wrapper');
			// rim_color_wrapper.empty().append(`
			//                <div class="color-swatch category active show" data-category="anodized" data-value="Black" title="Black" style="background: url(${colorImages}black.svg?v=1717478021);"></div>
			//                <div class="color-swatch category" data-category="powder-coat" data-value="Blue" title="Blue" style="background: url(${colorImages}blue.svg?v=1717478021);"></div>
			//                <div class="color-swatch category" data-category="powder-coat" data-value="Gold" title="Gold" style="background: url(${colorImages}gold.svg?v=1717478021);"></div>
			//                <div class="color-swatch category" data-category="powder-coat" data-value="Magnesium" title="Magnesium" style="background: url(${colorImages}magnesium.svg?v=1717478021);"></div>
			//                <div class="color-swatch category" data-category="powder-coat" data-value="Matte-Black" title="Matte-Black" style="background: url(${colorImages}matte-black.svg?v=1717478021);"></div>
			//                <div class="color-swatch category" data-category="powder-coat" data-value="AOrange" title="AOrange" style="background: AOrange;"></div>
			//                <div class="color-swatch category" data-category="powder-coat" data-value="Purple" title="Purple" style="background: url(${colorImages}purple.svg?v=1717478021);"></div>
			//                <div class="color-swatch category" data-category="powder-coat" data-value="Red" title="Red" style="background: url(${colorImages}red.svg?v=1717478021);"></div>
			//                <div class="color-swatch category" data-category="powder-coat" data-value="Silver" title="Silver" style="background: url(${colorImages}silver.svg?v=1717478021);"></div>
			//                <div class="color-swatch category" data-category="powder-coat" data-value="Blue" title="Blue" style="background: url(${colorImages}blue.svg?v=1717478021);"></div>
			//                <div class="color-swatch category" data-category="powder-coat" data-value="Baby-Blue" title="Baby-Blue" style="background: url(${colorImages}baby-blue.svg?v=1717478021);"></div>
			//                <div class="color-swatch category" data-category="powder-coat" data-value="Flo-Yellow" title="Flo-Yellow" style="background: url(${colorImages}flo-yellow.svg?v=1717478021);"></div>
			//                <div class="color-swatch category" data-category="powder-coat" data-value="Nardo-Grey" title="Nardo-Grey" style="background: url(${colorImages}nardo-grey.svg?v=1717478021);"></div>
			//                <div class="color-swatch category" data-category="powder-coat" data-value="Orange" title="Orange" style="background: url(${colorImages}orange.svg?v=1717478021);"></div>
			//                <div class="color-swatch category" data-category="powder-coat" data-value="School-Bus-Yellow" title="School-Bus-Yellow" style="background: url(${colorImages}school-bus-yellow.svg?v=1717478021);"></div>
			//                <div class="color-swatch category" data-category="powder-coat" data-value="White" title="White" style="background: url(${colorImages}white.svg?v=1717478021);"></div>
			//            `);

			// select.empty().append('<option class="opdis" value="Anodized" disabled>Anodized</option><option class="category" value="Black">Black</option><option class="category" value="Blue">Blue</option><option class="category" value="Gold">Gold</option><option class="category" value="Magnesium">Magnesium</option><option class="category" value="Matte-Black">Matte Black</option><option class="category" value="AOrange">Orange</option><option class="category" value="Purple">Purple</option><option class="category" value="Red">Red</option><option class="category" value="Silver">Silver</option><option class="opdis" value="Powder-Coated" disabled>Powder Coated</option><option class="category" value="Blue">Blue</option><option class="category" value="Baby-Blue">Baby Blue</option><option class="category" value="Flo-Yellow">Flo Yellow</option><option class="category" value="Nardo-Grey">Nardo Grey</option><option class="category" value="Orange">Orange</option><option class="category" value="School-Bus-Yellow">School Bus Yellow</option><option class="category" value="White">White</option>'); 
			var image_name = images + "rim-" + $('#rim_color').val() + "-" + $('select#wheel_type').val() + ".png";
			var imageArr2 = [image_name];
			var divArr2 = ["resultAreaID_1_1"];
			$('#resultAreaID_1_1 img').attr('src', image_name);
		} else {

			var select = $('#rim_color');
			select.val('Black');
			//Rim Color Temp Hide
			// select.empty().append('<option class="opdis" value="Anodized" disabled>Anodized</option><option class="category" value="Black">Black</option><option class="category" value="Blue">Blue</option><option class="category" value="Gold">Gold</option><option class="category" value="Magnesium">Magnesium</option><option class="category" value="Matte-Black">Matte Black</option><option class="category" value="Purple">Purple</option><option class="category" value="Red">Red</option><option class="category" value="Silver">Silver</option><option class="opdis" value="Powder-Coated" disabled>Powder Coated</option><option class="category" value="Blue">Blue</option><option class="category" value="Baby-Blue">Baby Blue</option><option class="category" value="Flo-Yellow">Flo Yellow</option><option class="category" value="Nardo-Grey">Nardo Grey</option><option class="category" value="Orange">Orange</option><option class="category" value="School-Bus-Yellow">School Bus Yellow</option><option class="category" value="White">White</option>');
			var rim_color_wrapper = $('.rim_color_wrapper');
			// rim_color_wrapper.empty().append(`
			//                  <div class="color-swatch category active" data-category="anodized" data-value="Black" title="Black" style="background: url(${colorImages}black.svg?v=1717478021);"></div>
			//                  <div class="color-swatch category" data-category="powder-coat" data-value="Blue" title="Blue" style="background: url(${colorImages}blue.svg?v=1717478021);"></div>
			//                  <div class="color-swatch category" data-category="powder-coat" data-value="Gold" title="Gold" style="background: url(${colorImages}gold.svg?v=1717478021);"></div>
			//                  <div class="color-swatch category" data-category="powder-coat" data-value="Magnesium" title="Magnesium" style="background: url(${colorImages}magnesium.svg?v=1717478021);"></div>
			//                  <div class="color-swatch category" data-category="powder-coat" data-value="Matte-Black" title="Matte-Black" style="background: url(${colorImages}matte-black.svg?v=1717478021);"></div>
			//                  <div class="color-swatch category" data-category="powder-coat" data-value="Purple" title="Purple" style="background: url(${colorImages}purple.svg?v=1717478021);"></div>
			//                  <div class="color-swatch category" data-category="powder-coat" data-value="Red" title="Red" style="background: url(${colorImages}red.svg?v=1717478021);"></div>
			//                  <div class="color-swatch category" data-category="powder-coat" data-value="Silver" title="Silver" style="background: url(${colorImages}silver.svg?v=1717478021);"></div>
			//                  <div class="color-swatch category" data-category="powder-coat" data-value="Blue" title="Blue" style="background: url(${colorImages}blue.svg?v=1717478021);"></div>
			//                  <div class="color-swatch category" data-category="powder-coat" data-value="Baby-Blue" title="Baby-Blue" style="background: url(${colorImages}baby-blue.svg?v=1717478021);"></div>
			//                  <div class="color-swatch category" data-category="powder-coat" data-value="Flo-Yellow" title="Flo-Yellow" style="background: url(${colorImages}flo-yellow.svg?v=1717478021);"></div>
			//                  <div class="color-swatch category" data-category="powder-coat" data-value="Nardo-Grey" title="Nardo-Grey" style="background: url(${colorImages}nardo-grey.svg?v=1717478021);"></div>
			//                  <div class="color-swatch category" data-category="powder-coat" data-value="Orange" title="Orange" style="background: url(${colorImages}orange.svg?v=1717478021);"></div>
			//                  <div class="color-swatch category" data-category="powder-coat" data-value="School-Bus-Yellow" title="School-Bus-Yellow" style="background: url(${colorImages}school-bus-yellow.svg?v=1717478021);"></div>
			//                  <div class="color-swatch category" data-category="powder-coat" data-value="White" title="White" style="background: url(${colorImages}white.svg?v=1717478021);"></div>
			//              `);

		}
	}

	//Sprocket Hide Function
	function sprockethide() {
		if ($('select#sprocket_size').val() == "no") {
			$('#resultAreaID_1_7').hide();
		} else {
			$('#resultAreaID_1_7').show();
		}
	}

	function nipplespokecolor() {}


	//Nipple Color depends upon Spoke Color
	function nipplecolorreset() {

	}

	function spoketitanium() {
		//Titanium Spoke Color Code
		//Bike Make 
		var bike = $('select#bike_year').val();
		var bikemodel = $('select#bike_model').val();
		var select = $('.spoke_color_wrapper');
		var previous_value = $('.spoke_color_wrapper .color-swatch.active').data('value');
		console.log('Previous Active Value:', previous_value);
		select.empty().append(`
			<div class="color-swatch" data-value="Silver" title="Silver" style="background: url(${colorImages}silver.svg?v=1717478021);"></div>
			<div class="color-swatch" data-value="Black" title="Black" style="background: url(${colorImages}black.svg?v=1717478021);"></div>
			<div class="color-swatch" data-value="Blue" title="Blue" style="background: url(${colorImages}blue.svg?v=1717478021);"></div>
			<div class="color-swatch" data-value="Green" title="Green" style="background: url(${colorImages}green.svg?v=1717478021);"></div>
			<div class="color-swatch" title="Nardo Grey" data-value="Nardo-Grey" style="background: url(${colorImages}nardo-grey.svg?v=1717478021);"></div>
			<div class="color-swatch" data-value="Orange" title="Orange" style="background: url(${colorImages}orange.svg?v=1717478021);"></div>
			<div class="color-swatch" data-value="Red" title="Red" style="background: url(${colorImages}red.svg?v=1717478021);"></div>
			<div class="color-swatch" data-value="White" title="White" style="background: url(${colorImages}white.svg?v=1717478021);"></div>
			<div class="color-swatch" data-value="Yellow" title="Yellow" style="background: url(${colorImages}yellow.svg?v=1717478021);"></div>
			<div class="color-swatch" data-value="Flo-Yellow" title="Flo Yellow" style="background: url(${colorImages}flo-yellow.svg?v=1717478021);"></div>
			<div class="color-swatch" data-value="Titanium" title="Titanium" style="background: url(${colorImages}titanium.svg?v=1717478021);"></div>
		`);
		// Find the swatch matching the previous value
		var swatchToActivate = select.find(`.color-swatch[data-value="${previous_value}"]`);

		if (swatchToActivate.length) {
			// If previous_value is found, set it as active
			swatchToActivate.addClass('active');
		} else {
			// Default to Silver if no match found
			select.find('.color-swatch[data-value="Silver"]').addClass('active');
		}
	}

	function rimColorValidation() {
		// console.log('entering to rimColorValidation');
		const rimColorSelect = $('#rim_color');
		rimColorSelect.empty().append(`
						<option class="category" value="Black">Black</option>
						<option class="category" value="Silver">Silver</option>
						<option class="category" value="Matte-Black">Matte Black</option>
						<option class="category" value="Blue">Blue</option>
						<option class="category" value="Green">Green</option>
						<option class="category" value="Gold">Gold</option>
						<option class="category" value="Magnesium">Magnesium</option>
						<option class="category" value="Orange">Orange</option>
						<option class="category" value="Purple">Purple</option>
						<option class="category" value="Red">Red</option>
						<option class="category" value="Baby-Blue">Baby Blue</option>
						<option class="category" value="Flo-Yellow">Flo Yellow</option>
						<option class="category" value="Nardo-Grey">Nardo Grey</option>
						<option class="category" value="Orange">Orange</option>
						<option class="category" value="School-Bus-Yellow">School Bus Yellow</option>
						<option class="category" value="White">White</option>
						<option class="category" value="Teal">Teal</option>
						<option class="category" value="Illusion-Violet">Illusion Violet</option>
				`);

				const rim_color_wrapper = $('.rim_color_wrapper');
				rim_color_wrapper.empty().append(`
						<div class="color-swatch active show" data-category="anodized" data-value="Black" style="background: url(${colorImages}black.svg?v=1717478021);"></div>
						<div class="color-swatch" data-category="anodized" data-value="Silver" style="background: url(${colorImages}silver.svg?v=1717478021);"></div>
						<div class="color-swatch" data-category="anodized" data-value="Matte-Black" style="background: url(${colorImages}matte-black.svg?v=1717478021);"></div>
						<div class="color-swatch" data-category="anodized" data-value="Blue" style="background: url(${colorImages}blue.svg?v=1717478021);"></div>
						<div class="color-swatch" data-category="anodized" data-value="Green" style="background: url(${colorImages}green.svg?v=1717478021);"></div>
						<div class="color-swatch" data-category="anodized" data-value="Gold" style="background: url(${colorImages}gold.svg?v=1717478021);"></div>
						<div class="color-swatch" data-category="anodized" data-value="Magnesium" style="background: url(${colorImages}magnesium.svg?v=1717478021);"></div>
						<div class="color-swatch" data-category="anodized" data-value="Orange" style="background: url(${colorImages}orange.svg?v=1717478021);"></div>
						<div class="color-swatch" data-category="anodized" data-value="Purple" style="background: url(${colorImages}purple.svg?v=1717478021);"></div>
						<div class="color-swatch" data-category="anodized" data-value="Red" style="background: url(${colorImages}red.svg?v=1717478021);"></div>
						<div class="color-swatch" data-category="powder-coat" data-value="Blue" style="background: url(${colorImages}blue.svg?v=1717478021);"></div>
						<div class="color-swatch" data-category="powder-coat" data-value="Baby-Blue" style="background: url(${colorImages}baby-blue.svg?v=1717478021);"></div>
						<div class="color-swatch" data-category="powder-coat" data-value="Flo-Yellow" style="background: url(${colorImages}flo-yellow.svg?v=1717478021);"></div>
						<div class="color-swatch" data-category="powder-coat" data-value="Nardo-Grey" style="background: url(${colorImages}nardo-grey.svg?v=1717478021);"></div>
						<div class="color-swatch" data-category="powder-coat" data-value="Orange" style="background: url(${colorImages}orange.svg?v=1717478021);"></div>
						<div class="color-swatch" data-category="powder-coat" data-value="School-Bus-Yellow" style="background: url(${colorImages}school-bus-yellow.svg?v=1717478021);"></div>
						<div class="color-swatch" data-category="powder-coat" data-value="White" style="background: url(${colorImages}white.svg?v=1717478021);"></div>
						<div class="color-swatch" data-category="powder-coat" data-value="Teal" style="background: url(${colorImages}teal.svg?v=1717478021);"></div>
						<div class="color-swatch" data-category="powder-coat" data-value="Illusion-Violet" style="background: url(${colorImages}illusion-violet.svg?v=1717478021);"></div>
				`);

		spoketitanium();
	}

	function gasgasbrakeremove() {
		if ($('select#bike_make').val() === "GasGas") {
			if ($('select#bike_year').val() <= 2019) {
				var select = $('#brake_rotor');
				select.empty().append('<option class="category" value="260mm">OEM 260mm</option>');
			} else {
				var select = $('#brake_rotor');
				select.empty().append('<option class="category" value="fixed">320mm Fixed</option><option value="320MM_FLOATING">320mm Floating</option>');
			}
		}
	}

	//Surron Mounted Tire Function
	function mbtiremounted() {
		if ($('select#rim_size').val() == "FRONT 21x1.60") {
			if ($('select#bike_model').val() === "X *FRONT*" || $('select#bike_model').val() === "X *REAR*" || $('select#bike_model').val() === "Ultra *FRONT*" || $('select#bike_model').val() === "Ultra *REAR*" || $('select#bike_model').val() === "Sting *FRONT*" || $('select#bike_model').val() === "Sting R *FRONT*" || $('select#bike_model').val() === "Sting MX5 *FRONT*" || $('select#bike_model').val() === "XXX *FRONT*" || $('select#bike_model').val() === "Sting *REAR*" || $('select#bike_model').val() === "Sting R *REAR*" || $('select#bike_model').val() === "Sting MX5 *REAR*" || $('select#bike_model').val() === "XXX *REAR*") {
				var select = $('#mbtire');
				select.empty().append('<option class="category" value="mounted_no">No</option><option class="category" value="Shinko_241">Shinko 241</option><option class="category" value="dunlop_mx33">Dunlop MX33</option>');

				var image_name = images + $('select#mbtire').val() + "-" + $('select#wheel_type').val() + ".png";
				var imageArr9 = [image_name];
				var divArr9 = ["resultAreaID_1_8"];
				$('#resultAreaID_1_8 img').attr('src', image_name);
				$("#mbtiretr").show();
			} else {
				var select = $('#mbtire');
				select.empty().append('<option class="category" value="mounted_no">No</option><option class="category" value="dunlop_mx33">Dunlop MX33</option>');

				var image_name = images + $('select#mbtire').val() + "-" + $('select#wheel_type').val() + ".png";
				var imageArr9 = [image_name];
				var divArr9 = ["resultAreaID_1_8"];
				$('#resultAreaID_1_8 img').attr('src', image_name);
				$("#mbtiretr").show();
			}
		} else if ($('select#rim_size').val() == "FRONT 19x1.60" || $('select#rim_size').val() == "REAR 19x1.60") {
			if ($('select#bike_model').val() === "X *FRONT*" || $('select#bike_model').val() === "X *REAR*" || $('select#bike_model').val() === "Ultra *FRONT*" || $('select#bike_model').val() === "Ultra *REAR*" || $('select#bike_model').val() === "Sting *FRONT*" || $('select#bike_model').val() === "Sting R *FRONT*" || $('select#bike_model').val() === "Sting MX5 *FRONT*" || $('select#bike_model').val() === "XXX *FRONT*" || $('select#bike_model').val() === "Sting *REAR*" || $('select#bike_model').val() === "Sting R *REAR*" || $('select#bike_model').val() === "Sting MX5 *REAR*" || $('select#bike_model').val() === "XXX *REAR*") {
				var select = $('#mbtire');
				select.empty().append('<option class="category" value="mounted_no">No</option><option class="category" value="Shinko_241">Shinko 241</option><option class="category" value="shinko_524">Shinko 524</option>');

				var image_name = images + $('select#mbtire').val() + "-" + $('select#wheel_type').val() + ".png";
				var imageArr9 = [image_name];
				var divArr9 = ["resultAreaID_1_8"];
				$('#resultAreaID_1_8 img').attr('src', image_name);
				$("#mbtiretr").show();
			} else {
				var select = $('#mbtire');
				select.empty().append('<option class="category" value="mounted_no">No</option><option class="category" value="shinko_524">Shinko 524</option>');

				var image_name = images + $('select#mbtire').val() + "-" + $('select#wheel_type').val() + ".png";
				var imageArr9 = [image_name];
				var divArr9 = ["resultAreaID_1_8"];
				$('#resultAreaID_1_8 img').attr('src', image_name);
				$("#mbtiretr").show();
			}
		} else if ($('select#rim_size').val() == "REAR 16x1.85") {
			if ($('select#bike_model').val() === "X *FRONT*" || $('select#bike_model').val() === "X *REAR*" || $('select#bike_model').val() === "Ultra *FRONT*" || $('select#bike_model').val() === "Ultra *REAR*" || $('select#bike_model').val() === "Sting *FRONT*" || $('select#bike_model').val() === "Sting R *FRONT*" || $('select#bike_model').val() === "Sting MX5 *FRONT*" || $('select#bike_model').val() === "XXX *FRONT*" || $('select#bike_model').val() === "Sting *REAR*" || $('select#bike_model').val() === "Sting R *REAR*" || $('select#bike_model').val() === "Sting MX5 *REAR*"  || $('select#bike_model').val() === "XXX *REAR*") {
				var select = $('#mbtire');
				select.empty().append('<option class="category" value="mounted_no">No</option><option class="category" value="Shinko_241">Shinko 241</option><option class="category" value="shinko_r525">Shinko R525 Cheater</option>');

				var image_name = images + $('select#mbtire').val() + "-" + $('select#wheel_type').val() + ".png";
				var imageArr9 = [image_name];
				var divArr9 = ["resultAreaID_1_8"];
				$('#resultAreaID_1_8 img').attr('src', image_name);
				$("#mbtiretr").show();
			} else {
				var select = $('#mbtire');
				select.empty().append('<option class="category" value="mounted_no">No</option><option class="category" value="shinko_r525">Shinko R525 Cheater</option>');

				var image_name = images + $('select#mbtire').val() + "-" + $('select#wheel_type').val() + ".png";
				var imageArr9 = [image_name];
				var divArr9 = ["resultAreaID_1_8"];
				$('#resultAreaID_1_8 img').attr('src', image_name);
				$("#mbtiretr").show();
			}
		} else if ($('select#rim_size').val() == "REAR 18x1.85" || $('select#rim_size').val() === "REAR 18x2.15") {
			if ($('select#bike_model').val() === "X *FRONT*" || $('select#bike_model').val() === "X *REAR*" || $('select#bike_model').val() === "Ultra *FRONT*" || $('select#bike_model').val() === "Ultra *REAR*" || $('select#bike_model').val() === "Sting *FRONT*" || $('select#bike_model').val() === "Sting R *FRONT*" || $('select#bike_model').val() === "Sting MX5 *FRONT*" || $('select#bike_model').val() === "XXX *FRONT*" || $('select#bike_model').val() === "Sting *REAR*" || $('select#bike_model').val() === "Sting R *REAR*" || $('select#bike_model').val() === "Sting MX5 *REAR*" || $('select#bike_model').val() === "XXX *REAR*") {
				var select = $('#mbtire');
				select.empty().append('<option class="category" value="mounted_no">No</option><option class="category" value="Shinko_241">Shinko 241</option>');

				var image_name = images + $('select#mbtire').val() + "-" + $('select#wheel_type').val() + ".png";
				var imageArr9 = [image_name];
				var divArr9 = ["resultAreaID_1_8"];
				$('#resultAreaID_1_8 img').attr('src', image_name);
				$("#mbtiretr").show();
			} else {
				var select = $('#mbtire');
				select.empty().append('<option class="category" value="mounted_no">No</option><option class="category" value="dunlop_mx33">Dunlop MX33</option>');

				var image_name = images + $('select#mbtire').val() + "-" + $('select#wheel_type').val() + ".png";
				var imageArr9 = [image_name];
				var divArr9 = ["resultAreaID_1_8"];
				$('#resultAreaID_1_8 img').attr('src', image_name);
				$("#mbtiretr").show();
			}
		} else if ($('select#rim_size').val() == "FRONT 17x2.50" || $('select#rim_size').val() == "FRONT 17x2.15" || $('select#rim_size').val() == "REAR 17x2.50") {
			if ($('select#bike_model').val() === "X *FRONT*" || $('select#bike_model').val() === "X *REAR*" || $('select#bike_model').val() === "Ultra *FRONT*" || $('select#bike_model').val() === "Ultra *REAR*" || $('select#bike_model').val() === "Sting *FRONT*" || $('select#bike_model').val() === "Sting R *FRONT*" || $('select#bike_model').val() === "Sting MX5 *FRONT*" || $('select#bike_model').val() === "XXX *FRONT*" || $('select#bike_model').val() === "Sting *REAR*" || $('select#bike_model').val() === "Sting R *REAR*" || $('select#bike_model').val() === "Sting MX5 *REAR*" || $('select#bike_model').val() === "XXX *REAR*") {
				var select = $('#mbtire');
				select.empty().append('<option class="category" value="mounted_no">No</option><option class="category" value="michelin">Michelin City Extra</option><option class="category" value="Shinko_241">Shinko 241</option>');

				if ($('select#mbtire').val() == "michelin") {
					var image_name = images + $('select#mbtire').val() + "-" + $('select#wheel_type').val() + ".png";
				} else {
					var image_name = images + $('select#mbtire').val() + "-" + $('select#wheel_type').val() + ".png";
				}
				var imageArr9 = [image_name];
				var divArr9 = ["resultAreaID_1_8"];
				$('#resultAreaID_1_8 img').attr('src', image_name);
				$("#mbtiretr").show();
			} else {
				var select = $('#mbtire');
				select.empty().append('<option class="category" value="mounted_no">No</option><option class="category" value="michelin">Michelin City Extra</option>');

				if ($('select#mbtire').val() == "michelin") {
					var image_name = images + $('select#mbtire').val() + "-" + $('select#wheel_type').val() + ".png";
				} else {
					var image_name = images + $('select#mbtire').val() + "-" + $('select#wheel_type').val() + ".png";
				}
				var imageArr9 = [image_name];
				var divArr9 = ["resultAreaID_1_8"];
				$('#resultAreaID_1_8 img').attr('src', image_name);
				$("#mbtiretr").show();
			}
		} else if ($('select#rim_size').val() == "FRONT 17x3.00") {
			if ($('select#bike_model').val() === "Ultra *FRONT*") {
				console.log('Ultra BEe 17x3.00');
				$("#mbtiretr").show();
			}
		} else if ($('select#rim_size').val() == "REAR 17x4.25") {
			if ($('select#bike_model').val() === "Ultra *REAR*") {
				console.log('Ultra BEe 17x4.25');
				$("#mbtiretr").show();
			}
		}
		else {
			var select = $('#mbtire');
			select.empty().append('<option class="category" value="mounted_no" selected>No</option>');
			$("#mbtiretr").hide();
			$("#resultAreaID_1_8").hide();
		}


		if ($('select#rim_size').val() == "REAR 18x1.85") {
			var select = $('#mbtire');
			var options = select.html();
			options += `<option class="category" value="Kenda_K257D">Kenda K257D</option>`;
			select.empty().append(options);
		}


		($('select#mbtire').val() == "mounted_no") ? $("#resultAreaID_1_8").hide(): $("#resultAreaID_1_8").show();




	}

	//Hide 320mm Floating Brake Rotor Style option with Bike Year
	function hide320mm() {
		var make = $('select#bike_make').val();
		if (make == "Husqvarna") {
			var bike = $('select#bike_year').val();
			if (bike >= 2000 & bike <= 2013) {
				select = $('#brake_rotor');
				select.empty().append(' <option value="Wave">Wave</option>');
			} else if (bike >= 2014) {
				select = $('#brake_rotor');
				select.empty().append(' <option value="Wave">Wave</option><option value="320MM_FLOATING">320mm Floating</option>');
			}
		}
	}

	//Tubeless Wheel Conditions.
	function tubelesswheel() {
		//val select = $('#rim_size');
		if ($('select#rim_size').val() == 'FRONT 17x3.50' || $('select#rim_size').val() == 'FRONT 16.5x3.5' || $('select#rim_size').val() == 'REAR 17x4.25' || $('select#rim_size').val() == 'REAR 17x5.00') {
			if ($('select#mtl').val() == "No") {
				$('#resultAreaID_1_11').hide();
			} else {
				$('#resultAreaID_1_11').show();
				var image_name = images + "tubeless-" + $('select#mtl').val() + "-" + $('select#wheel_type').val() + ".png";
				var imageArr10 = [image_name];
				var divArr10 = ["resultAreaID_1_11"];
				$('#resultAreaID_1_11 img').attr('src', image_name);

			}
			$('#make_tubeless').show();
		} else {
			$('#make_tubeless').hide();
			$('#resultAreaID_1_11').hide();
		}
	}

	$('select#bike_make').change(function () {

		$('select#hidden_bike_model').empty();
		switch ($('select#bike_make').val()) {
			case 'Bonnell':
				models = {
					'805RX *FRONT*': '805RX',
					'805RX *REAR*': '805RX',
				};
				hub_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Gold': 'Gold',
					'Green': 'Green',
					'Orange': 'Orange',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				rim_colors = {
					'Black': 'Black',
					'Matte-Black': 'Matte Black',
					'Blue': 'Blue',
					'Baby Blue': 'Baby Blue',
					'Flo-Yellow': 'Flo Yellow',
					'Nardo-Grey': 'Nardo Grey',
					'Orange': 'Orange',
					'School-Bus-Yellow': 'School-Bus-Yellow',
					'White': 'White'
				};
				spoke_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Blue': 'Blue',
					'Green': 'Green',
					'Nardo-Grey': 'Nardo Grey',
					'Orange': 'Orange',
					'Powder-Blue': 'Powder-Blue',
					'Red': 'Red',
					'White': 'White',
					'Flo-Yellow': 'Flo Yellow',
					'School-Bus-Yellow': 'School-Bus-Yellow',
					'Titanium': 'Titanium'
				};
				nipple_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Orange': 'Orange',
					'Green': 'Green',
					'Gold': 'Gold',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				rim_size = {
					'FRONT 21x1.60': 'FRONT 21x1.60',
				};
				brake_rotor = {
					'Wave': 'Wave',
				};
				break;
			case '79 Bike': //79 Bike
				models = {
					'Falcon *FRONT*': 'Falcon M',
					'FalconS *FRONT*': 'Falcon S',

					'Falcon *REAR*': 'Falcon M',
					'FalconS *REAR*': 'Falcon M',
				};
				hub_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Gold': 'Gold',
					'Green': 'Green',
					'Orange': 'Orange',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				rim_colors = {
					'Black': 'Black',
					'Matte-Black': 'Matte Black',
					'Blue': 'Blue',
					'Baby Blue': 'Baby Blue',
					'Flo-Yellow': 'Flo Yellow',
					'Nardo-Grey': 'Nardo Grey',
					'Orange': 'Orange',
					'School-Bus-Yellow': 'School-Bus-Yellow',
					'White': 'White'
				};
				spoke_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Blue': 'Blue',
					'Green': 'Green',
					'Nardo-Grey': 'Nardo Grey',
					'Orange': 'Orange',
					'Powder-Blue': 'Powder-Blue',
					'Red': 'Red',
					'White': 'White',
					'Flo-Yellow': 'Flo Yellow',
					'School-Bus-Yellow': 'School-Bus-Yellow',
					'Titanium': 'Titanium'
				};
				nipple_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Orange': 'Orange',
					'Green': 'Green',
					'Gold': 'Gold',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				rim_size = {
					'FRONT 16x1.65': 'FRONT 16x1.65',
					'FRONT 17x2.15': 'FRONT 17x2.15',
					'FRONT 17x2.50': 'FRONT 17x2.50',
					'FRONT 21x1.60': 'FRONT 21x1.60',
					'FRONT 19x1.60': 'FRONT 19x1.60',
				};
				brake_rotor = {
					'203_mm': '203 x 1.8 mm Fixed',
					'220_mm': '220 x 1.8 mm Fixed',
					'220_mm_floating': '220 x 1.8 mm Floating',
					'220_mm_2': '220mm x 2.3mm Floating',
					'240_mm_2': '240mm x 2.3mm Floating',
				};
				break;
			case 'Surron': //Surron
				models = {
					'X *FRONT*': 'Light Bee',
					'Ultra *FRONT*': 'Ultra Bee',

					'X *REAR*': 'Light Bee',
					'Ultra *REAR*': 'Ultra Bee',
				};
				hub_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Gold': 'Gold',
					'Green': 'Green',
					'Orange': 'Orange',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				rim_colors = {
					'Silver': 'Silver',
                    'Black': 'Black',
					'Matte-Black': 'Matte Black',
					'Blue': 'Blue',
					'Baby Blue': 'Baby Blue',
					'Flo-Yellow': 'Flo Yellow',
					'Nardo-Grey': 'Nardo Grey',
					'Orange': 'Orange',
					'School-Bus-Yellow': 'School-Bus-Yellow',
					'White': 'White'
				};
				spoke_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Blue': 'Blue',
					'Green': 'Green',
					'Nardo-Grey': 'Nardo Grey',
					'Orange': 'Orange',
					'Powder-Blue': 'Powder-Blue',
					'Red': 'Red',
					'White': 'White',
					'Flo-Yellow': 'Flo Yellow',
					'School-Bus-Yellow': 'School-Bus-Yellow',
					'Titanium': 'Titanium'
				};
				nipple_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Orange': 'Orange',
					'Green': 'Green',
					'Gold': 'Gold',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				rim_size = {
					'FRONT 16x1.65': 'FRONT 16x1.65',
					'FRONT 17x2.15': 'FRONT 17x2.15',
					'FRONT 17x2.50': 'FRONT 17x2.50',
					'FRONT 21x1.60': 'FRONT 21x1.60',
					'FRONT 19x1.60': 'FRONT 19x1.60',
				};
				brake_rotor = {
					'203_mm': '203 x 1.8 mm Fixed',
					'220_mm': '220 x 1.8 mm Fixed',
					'220_mm_floating': '220 x 1.8 mm Floating',
					'220_mm_2': '220mm x 2.3mm Floating',
					'240_mm_2': '240mm x 2.3mm Floating',
				};
				break;
			case 'Altis': //Surron
				models = {
					'X *FRONT*': 'Sigma',
					'X *REAR*': 'Sigma',
				};
				hub_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Gold': 'Gold',
					'Green': 'Green',
					'Orange': 'Orange',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				rim_colors = {
					'Silver': 'Silver',
                    'Black': 'Black',
					'Matte-Black': 'Matte Black',
					'Blue': 'Blue',
					'Baby Blue': 'Baby Blue',
					'Flo-Yellow': 'Flo Yellow',
					'Nardo-Grey': 'Nardo Grey',
					'Orange': 'Orange',
					'School-Bus-Yellow': 'School-Bus-Yellow',
					'White': 'White'
				};
				spoke_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Blue': 'Blue',
					'Green': 'Green',
					'Nardo-Grey': 'Nardo Grey',
					'Orange': 'Orange',
					'Powder-Blue': 'Powder-Blue',
					'Red': 'Red',
					'White': 'White',
					'Flo-Yellow': 'Flo Yellow',
					'School-Bus-Yellow': 'School-Bus-Yellow',
					'Titanium': 'Titanium'
				};
				nipple_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Orange': 'Orange',
					'Green': 'Green',
					'Gold': 'Gold',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				rim_size = {
					'FRONT 16x1.65': 'FRONT 16x1.65',
					'FRONT 17x2.15': 'FRONT 17x2.15',
					'FRONT 17x2.50': 'FRONT 17x2.50',
					'FRONT 21x1.60': 'FRONT 21x1.60',
					'FRONT 19x1.60': 'FRONT 19x1.60',
				};
				brake_rotor = {
					'203_mm': '203 x 1.8 mm Fixed',
					'220_mm': '220 x 1.8 mm Fixed',
					'220_mm_floating': '220 x 1.8 mm Floating',
					'220_mm_2': '220mm x 2.3mm Floating',
					'240_mm_2': '240mm x 2.3mm Floating',
				};
				break;
			case 'Rawr': //Rawr
				models = {
					'X *FRONT*': 'Mantis',
					'X *REAR*': 'Mantis',
				};
				hub_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Gold': 'Gold',
					'Green': 'Green',
					'Orange': 'Orange',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				rim_colors = {
					'Black': 'Black',
					'Matte-Black': 'Matte Black',
					'Blue': 'Blue',
					'Baby Blue': 'Baby Blue',
					'Flo-Yellow': 'Flo Yellow',
					'Nardo-Grey': 'Nardo Grey',
					'Orange': 'Orange',
					'School-Bus-Yellow': 'School-Bus-Yellow',
					'White': 'White'
				};
				spoke_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Blue': 'Blue',
					'Green': 'Green',
					'Nardo-Grey': 'Nardo Grey',
					'Orange': 'Orange',
					'Powder-Blue': 'Powder-Blue',
					'Red': 'Red',
					'White': 'White',
					'Flo-Yellow': 'Flo Yellow',
					'School-Bus-Yellow': 'School-Bus-Yellow',
					'Titanium': 'Titanium'
				};
				nipple_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Orange': 'Orange',
					'Green': 'Green',
					'Gold': 'Gold',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				rim_size = {
					'FRONT 16x1.65': 'FRONT 16x1.65',
					'FRONT 17x2.15': 'FRONT 17x2.15',
					'FRONT 17x2.50': 'FRONT 17x2.50',
					'FRONT 21x1.60': 'FRONT 21x1.60',
					'FRONT 19x1.60': 'FRONT 19x1.60',
				};
				brake_rotor = {
					'203_mm': '203 x 1.8 mm Fixed',
					'220_mm': '220 x 1.8 mm Fixed',
					'220_mm_floating': '220 x 1.8 mm Floating',
					'220_mm_2': '220mm x 2.3mm Floating',
					'240_mm_2': '240mm x 2.3mm Floating',
				};
				break;
			case 'Segway': //Honda
				models = {

					'X 160 *FRONT*': 'X 160',
					'X 260 *FRONT*': 'X 260',

					'X 160 *REAR*': 'X 160',
					'X 260 *REAR*': 'X 260',
				};
				hub_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Gold': 'Gold',
					'Green': 'Green',
					'Orange': 'Orange',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				rim_colors = {
					'Black': 'Black',
					'Matte-Black': 'Matte Black',
					'Blue': 'Blue',
					'Baby Blue': 'Baby Blue',
					'Flo-Yellow': 'Flo Yellow',
					'Nardo-Grey': 'Nardo Grey',
					'Orange': 'Orange',
					'School-Bus-Yellow': 'School-Bus-Yellow',
					'White': 'White'
				};
				spoke_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Blue': 'Blue',
					'Green': 'Green',
					'Nardo-Grey': 'Nardo Grey',
					'Orange': 'Orange',
					'Powder-Blue': 'Powder-Blue',
					'Red': 'Red',
					'White': 'White',
					'Flo-Yellow': 'Flo Yellow',
					'School-Bus-Yellow': 'School-Bus-Yellow',
					'Titanium': 'Titanium'
				};
				nipple_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Orange': 'Orange',
					'Green': 'Green',
					'Gold': 'Gold',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				rim_size = {
					'FRONT 16x1.65': 'FRONT 16x1.65',
					'FRONT 17x2.15': 'FRONT 17x2.15',
					'FRONT 17x2.50': 'FRONT 17x2.50',
					'FRONT 21x1.60': 'FRONT 21x1.60',
					'FRONT 19x1.60': 'FRONT 19x1.60',
				};
				brake_rotor = {
					'203_mm': '203 x 1.8 mm Fixed',
					'220_mm': '220 x 1.8 mm Fixed',
				};
				break;
			case 'Talaria': //Surron
				models = {
					'Sting *FRONT*': 'Sting MX3',
					'Sting R *FRONT*': 'Sting R-MX4',
					'XXX *FRONT*': 'XXX',
					'Sting MX5 *FRONT*': 'Sting MX5',

					'Sting *REAR*': 'Sting MX3',
					'Sting R *REAR*': 'Sting R-MX4',
					'XXX *REAR*': 'XXX',
					'Sting MX5 *REAR*': 'Sting MX5',
				};
				hub_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Gold': 'Gold',
					'Green': 'Green',
					'Orange': 'Orange',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				rim_colors = {
					'Black': 'Black',
					'Matte-Black': 'Matte Black',
					'Blue': 'Blue',
					'Baby Blue': 'Baby Blue',
					'Flo-Yellow': 'Flo Yellow',
					'Nardo-Grey': 'Nardo Grey',
					'Orange': 'Orange',
					'School-Bus-Yellow': 'School-Bus-Yellow',
					'White': 'White'
				};
				spoke_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Blue': 'Blue',
					'Green': 'Green',
					'Nardo-Grey': 'Nardo Grey',
					'Orange': 'Orange',
					'Powder-Blue': 'Powder-Blue',
					'Red': 'Red',
					'White': 'White',
					'Flo-Yellow': 'Flo Yellow',
					'School-Bus-Yellow': 'School-Bus-Yellow',
					'Titanium': 'Titanium'
				};
				nipple_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Orange': 'Orange',
					'Green': 'Green',
					'Gold': 'Gold',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				rim_size = {
					'FRONT 16x1.65': 'FRONT 16x1.65',
					'FRONT 17x2.15': 'FRONT 17x2.15',
					'FRONT 17x2.50': 'FRONT 17x2.50',
					'FRONT 21x1.60': 'FRONT 21x1.60',
					'FRONT 19x1.60': 'FRONT 19x1.60',
				};
				brake_rotor = {
					'203_mm': '203 x 1.8 mm Fixed',
					'220_mm': '220 x 1.8 mm Fixed',
					'220_mm_floating': '220 x 1.8 mm Floating',
				};
				break;
			case 'ERIDE': //ERIDE
				models = {
					'PRO-SS *FRONT*': 'PRO-SS',
					'PRO 2.0 *FRONT*': 'PRO 2.0',
					'SR 3.0 *FRONT*': 'SR/3.0',
					
					'PRO-SS *REAR*': 'PRO-SS',
					'PRO 2.0 *REAR*': 'PRO 2.0',
					'SR 3.0 *REAR*': 'SR/3.0',
				};
				hub_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Gold': 'Gold',
					'Green': 'Green',
					'Orange': 'Orange',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				rim_colors = {
					'Black': 'Black',
					'Blue': 'Blue',
					'Baby Blue': 'Baby Blue',
					'Flo-Yellow': 'Flo Yellow',
					'Nardo-Grey': 'Nardo Grey',
					'Orange': 'Orange',
					'School-Bus-Yellow': 'School-Bus-Yellow',
					'White': 'White'
				};
				spoke_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Blue': 'Blue',
					'Green': 'Green',
					'Nardo-Grey': 'Nardo Grey',
					'Orange': 'Orange',
					'Powder-Blue': 'Powder-Blue',
					'Red': 'Red',
					'White': 'White',
					'Flo-Yellow': 'Flo Yellow',
					'School-Bus-Yellow': 'School-Bus-Yellow',
					'Titanium': 'Titanium'
				};
				nipple_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Orange': 'Orange',
					'Green': 'Green',
					'Gold': 'Gold',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				rim_size = {
					'FRONT 16x1.65': 'FRONT 16x1.65',
					'FRONT 17x2.15': 'FRONT 17x2.15',
					'FRONT 17x2.50': 'FRONT 17x2.50',
					'FRONT 21x1.60': 'FRONT 21x1.60',
					'FRONT 19x1.60': 'FRONT 19x1.60',
				};
				brake_rotor = {
								'220mm Fixed': '220mm Fixed',
								'220mm Floating': '220mm Floating',
							};
			break;
		case 'Throne': // THRONE
				models = {
					'SRPNT X3 *FRONT*': 'SRPNT X3',

					'SRPNT X3 *REAR*': 'SRPNT X3',
				};
				hub_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Gold': 'Gold',
					'Green': 'Green',
					'Orange': 'Orange',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				rim_colors = {
					'Black': 'Black',
					'Blue': 'Blue',
					'Baby Blue': 'Baby Blue',
					'Flo-Yellow': 'Flo Yellow',
					'Nardo-Grey': 'Nardo Grey',
					'Orange': 'Orange',
					'School-Bus-Yellow': 'School-Bus-Yellow',
					'White': 'White'
				};
				spoke_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Blue': 'Blue',
					'Green': 'Green',
					'Nardo-Grey': 'Nardo Grey',
					'Orange': 'Orange',
					'Powder-Blue': 'Powder-Blue',
					'Red': 'Red',
					'White': 'White',
					'Flo-Yellow': 'Flo Yellow',
					'School-Bus-Yellow': 'School-Bus-Yellow',
					'Titanium': 'Titanium'
				};
				nipple_colors = {
					'Silver': 'Silver',
					'Black': 'Black',
					'Red': 'Red',
					'Blue': 'Blue',
					'Orange': 'Orange',
					'Green': 'Green',
					'Gold': 'Gold',
					'Purple': 'Purple',
					'Magnesium': 'Magnesium'
				};
				rim_size = {
					'FRONT 16x1.65': 'FRONT 16x1.65',
					'FRONT 17x2.15': 'FRONT 17x2.15',
					'FRONT 17x2.50': 'FRONT 17x2.50',
					'FRONT 21x1.60': 'FRONT 21x1.60',
					'FRONT 19x1.60': 'FRONT 19x1.60',
				};
				brake_rotor = {
					'220_mm': '220 x 1.8 mm Fixed',
					'220_mm_floating': '220 x 1.8 mm Floating',
				};
				break;
		}

		var model_element = $('#bike_model');
		var rim_size_element = $('#rim_size');
		var brake_rotor_element = $('#brake_rotor');
		var sprocket_size_element = $('#sprocket_size')

		var model_select = model_element.prop('options');
		var rim_size_select = rim_size_element.prop('options');
		var brake_rotor_select = brake_rotor_element.prop('options');
		var sprocket_size_select = sprocket_size_element.prop('options');

		$('option', model_element).remove();
		$('option', rim_size_element).remove();
		$('option', brake_rotor_element).remove();

		$.each(models, function (val, text) {
			var new_opt = new Option(text, val);

			model_select[model_select.length] = new_opt;
			if (val.indexOf('*FRONT') != -1 || text.indexOf('*FRONT') != -1)
				new_opt.className = 'front';
			else
				new_opt.className = 'rear';
		});
		// color append function start
		var hubColorsSelect = $("#hub_colors_select"); // Assuming you have a select element with the id 'hub_colors_select'
		var hubColorWrapper = $(".hub_color_wrapper");
		var hiddenInput = $("#hub_color");
		hubColorWrapper.empty();

		$.each(hub_colors, function (index, colorValue) {
			const formattedColor = colorValue.replace(" ", "-").toLowerCase();
			// Create a new color swatch element
			var colorSwatch = $("<div>", {
				class: "color-swatch",
				"data-value": colorValue.replace(" ", "-"),
				style: `background: url(${colorImages}${formattedColor}.svg?v=1717478021);`,
				title: colorValue
			});
			hubColorWrapper.append(colorSwatch);

			colorSwatch.on("click", function () {
				hubColorWrapper.find(".color-swatch").removeClass("active");
				$(this).addClass("active");
				hiddenInput.val(colorValue);
			});
		});

		$(".hub_color_wrapper .color-swatch:first").click();
		var initialColorValue = hiddenInput.val();
		hubColorWrapper
			.find('.color-swatch[data-value="' + initialColorValue + '"]')
			.addClass("active");

		var anodizedRim = ['silver', 'black', 'blue', 'green', 'gold', 'magnesium', 'orange', 'purple', 'red'];
		var powderCoatedRim = [];

		// color append function start
		var rimColorsSelect = $("#rim_colors_select"); // Assuming you have a select element with the id 'rim_colors_select'
		var rimColorWrapper = $(".rim_color_wrapper");
		var hiddenInput = $("#rim_color");
		// rimColorWrapper.empty();
		// // console.log(rim_colors);
		// $.each(rim_colors, function(index, colorValue) {
		// 	const formattedColor = colorValue.replace(" ", "-").toLowerCase();
		// 	// Create a new color swatch element
		//           var colorname = colorValue.toLowerCase();
		//           var dataCategory = anodizedRim.includes(colorname) ? "anodized" : "powder-coated"; 
		//           // console.log({dataCategory});
		//           var colorSwatch = $("<div>", {
		//             class: "color-swatch category",
		//             "data-value": colorValue.replace(" ", "-"),
		//             "data-category": dataCategory,
		//             style: `background: url(${colorImages}${formattedColor}.svg?v=1717478021);`,
		//             title: colorValue
		//           });
		//           // var colorSwatch = `<div class="color-swatch category" data-category="`+dataCategory+`" title="`+colorValue+`" data-value="`+colorValue+`" style="background: "`+ colorValue +`;" ></div>`;
		//           // console.log(colorSwatch);
		// 	rimColorWrapper.append(colorSwatch);

		// 	colorSwatch.on("click", function() {
		// 		rimColorWrapper.find(".color-swatch").removeClass("active");
		// 		$(this).addClass("active");
		// 		hiddenInput.val(colorValue);
		// 	});
		// });

		$(".rim_color_wrapper .color-swatch:first").click();
		$(".rim-color-type .rim-type-wrap.anodized").click();

		var initialColorValue = hiddenInput.val();
		rimColorWrapper
			.find('.color-swatch[data-value="' + initialColorValue + '"]')
			.addClass("active");
		// color append function end

		// color append function start
		var spokeColorsSelect = $("#spoke_colors_select"); // Assuming you have a select element with the id 'spoke_colors_select'
		var spokeColorWrapper = $(".spoke_color_wrapper");
		var hiddenInput = $("#spoke_color");
		spokeColorWrapper.empty();

		$.each(spoke_colors, function (index, colorValue) {
			const formattedColor = colorValue.replace(" ", "-").toLowerCase();
			// Create a new color swatch element
			var colorSwatch = $("<div>", {
				class: "color-swatch",
				"data-value": colorValue.replace(" ", "-"),
				style: `background: url(${colorImages}${formattedColor}.svg?v=1717478021);`,
				title: colorValue
			});
			spokeColorWrapper.append(colorSwatch);

			colorSwatch.on("click", function () {
				spokeColorWrapper.find(".color-swatch").removeClass("active");
				$(this).addClass("active");
				hiddenInput.val(colorValue);
			});
		});
		$(".spoke_color_wrapper .color-swatch:first").click();
		var initialColorValue = hiddenInput.val();
		spokeColorWrapper
			.find('.color-swatch[data-value="' + initialColorValue + '"]')
			.addClass("active");
		// color append function end

		// color append function start
		var nippleColorsSelect = $("#nipple_colors_select"); // Assuming you have a select element with the id 'nipple_colors_select'
		var nippleColorWrapper = $(".nipple_color_wrapper");
		var hiddenInput = $("#nipple_color");
		nippleColorWrapper.empty();

		$.each(nipple_colors, function (index, colorValue) {
			const formattedColor = colorValue.replace(" ", "-").toLowerCase();
			// Create a new color swatch element
			var colorSwatch = $("<div>", {
				class: "color-swatch",
				"data-value": colorValue.replace(" ", "-"),
				style: `background: url(${colorImages}${formattedColor}.svg?v=1717478021);`,
				title: colorValue
			});
			nippleColorWrapper.append(colorSwatch);

			colorSwatch.on("click", function () {
				nippleColorWrapper.find(".color-swatch").removeClass("active");
				$(this).addClass("active");
				hiddenInput.val(colorValue);
			});
		});
		$(".nipple_color_wrapper .color-swatch:first").click();
		var initialColorValue = hiddenInput.val();
		nippleColorWrapper
			.find('.color-swatch[data-value="' + initialColorValue + '"]')
			.addClass("active");
		// color append function end

		var rimSizeSelect = $("select#rim_size");
		$.each(rim_size, function (value, text) {
			// Create a new option element and append it to the select element
			rimSizeSelect.append(
				$("<option>", {
					value: value,
					text: text,
				})
			);
		});
		var brakeRotorSelect = $("select#brake_rotor");
		$.each(brake_rotor, function (value, text) {
			// Create a new option element and append it to the select element
			brakeRotorSelect.append(
				$("<option>", {
					value: value,
					text: text,
				})
			);
		});
		updateBrakeRotor();
		syncNoRotorOption();

		if ($('select#wheel_type').val() == 1) //front
		{
			$('#sprocket').show();
			$('#resultAreaID_1_7').show();
			$('#resultAreaID_1_6').hide();
			if ($('select#brake_rotor').val() == "220_mm_floating") {
				var image_name = images + "S-" + $('select#brake_rotor').val() + ".png";
				var imageArr6 = [image_name];
				var divArr6 = ["resultAreaID_1_7"];
				// $('#resultAreaID_1_7 img').attr('src', image_name);

			} else {
				var image_name = images + "S-" + $('select#brake_rotor').val() + ".png";
				var imageArr6 = [image_name];
				var divArr6 = ["resultAreaID_1_7"];
				// $('#resultAreaID_1_7 img').attr('src', image_name);
			}
		} else { //rear
			$('#sprocket').hide();
			//$('#resultAreaID_1_6').hide();
		}

		var image_name = images + "rotor.png";
		var imageArr5 = [image_name];
		var divArr5 = ["resultAreaID_1_6"];
		$('#resultAreaID_1_6 img').attr('src', image_name);
		

		// Hide Blue rim color
		rimcolorhideblue();
		rimcolorblack();
		$(".rim-color-type .rim-type-wrap.anodized").click();
	});


	$('select#bike_make').change(function () {
		// document.getElementById('rotor-text').style.margin = '';
		// document.getElementById('rotor-text').style.top = '';
		document.getElementById('resultAreaID_1_6').style.width = '';
		document.getElementById('resultAreaID_1_6').style.height = '';
		document.getElementById('resultAreaID_1_6').style.top = '';
		$('#resultAreaID_1_4').hide();

		// Hide Blue rim color
		rimcolorhideblue();

	});

	$('select#bike_make').change(function () {
		if ($('select#wheel_type').val() == 'FRONT') {
			$('#sprocket').hide();
			//$('#resultAreaID_1_7').hide();
			$('#resultAreaID_1_6').hide();
		} else {
			$('#sprocket').show();
			$('#resultAreaID_1_7').show();
			$('#resultAreaID_1_6').show();
			var image_name = images + "rotor.png";
			var imageArr5 = [image_name];
			var divArr5 = ["resultAreaID_1_6"];
			// $('#resultAreaID_1_6 img').attr('src', image_name);
		}

		var select_model = $('select#bike_model');

		$("option:selected", select_model).removeAttr("selected");
		$('select#hidden_bike_model option').appendTo('select#bike_model');
		switch (this.value) {
			default:
			case 'FRONT':
				$('select#bike_model option.rear').appendTo('select#hidden_bike_model');
				break;
			case 'REAR':
				$('select#bike_model option.front').appendTo('select#hidden_bike_model');
				break;
		}
		select_model.val(select_model.find('option').first().val()).change();
		// Hide Blue rim color
		rimcolorhideblue();

		var selectElement = document.getElementById("wheel_type");
		if (selectElement) {
			// Reset the selection to the first option
			selectElement.selectedIndex = 0;
		} else {
			console.error('Select element not found');
		}

		var bikemake = $('select#bike_make').val();
		var bikemodel = $('select#bike_model').val();
		var select = $('#rim_size');

		if (bikemake == 'Talaria' && bikemodel == 'Sting *REAR*') {
			select.empty().append('<option value="REAR 17x3.00">REAR 17x3.00</option><option value="REAR 17x2.50">REAR 17x2.50</option><option value="REAR 18x1.85">REAR 18x1.85</option><option value="REAR 19x1.60">REAR 19x1.60</option><option value="REAR 16x1.85">REAR 16x1.85</option>');
		}
		if (bikemake == 'Surron' && bikemodel == 'X *REAR*') {
			select.empty().append('<option value="REAR 17x3.00">REAR 17x3.00</option><option value="REAR 17x2.50">REAR 17x2.50</option><option value="REAR 18x1.85">REAR 18x1.85</option><option value="REAR 19x1.60">REAR 19x1.60</option><option value="REAR 16x1.85">REAR 16x1.85</option>');
		}
	});

	var bikeyear = function () {
		//Bike Year Start
		//Declare Selected Bike Model Variable
		var sel_bike_model = $('select#bike_model').val();
		var sel_year = $('#bike_year');
		var previous_year = sel_year.val();
		console.log(previous_year)
		//Option Year Variable
		var y81 = '<option value="1981">1981</option>';
		var y82 = '<option value="1982">1982</option>';
		var y83 = '<option value="1983">1983</option>';
		var y84 = '<option value="1984">1984</option>';
		var y85 = '<option value="1985">1985</option>';
		var y86 = '<option value="1986">1986</option>';
		var y87 = '<option value="1987">1987</option>';
		var y88 = '<option value="1988">1988</option>';
		var y89 = '<option value="1989">1989</option>';
		var y90 = '<option value="1990">1990</option>';
		var y91 = '<option value="1991">1991</option>';
		var y92 = '<option value="1992">1992</option>';
		var y93 = '<option value="1993">1993</option>';
		var y94 = '<option value="1994">1994</option>';
		var y95 = '<option value="1995">1995</option>';
		var y96 = '<option value="1996">1996</option>';
		var y97 = '<option value="1997">1997</option>';
		var y98 = '<option value="1998">1998</option>';
		var y99 = '<option value="1999">1999</option>';
		var y00 = '<option value="2000">2000</option>';
		var y01 = '<option value="2001">2001</option>';
		var y02 = '<option value="2002">2002</option>';
		var y03 = '<option value="2003">2003</option>';
		var y04 = '<option value="2004">2004</option>';
		var y05 = '<option value="2005">2005</option>';
		var y06 = '<option value="2006">2006</option>';
		var y07 = '<option value="2007">2007</option>';
		var y08 = '<option value="2008">2008</option>';
		var y09 = '<option value="2009">2009</option>';
		var y10 = '<option value="2010">2010</option>';
		var y11 = '<option value="2011">2011</option>';
		var y12 = '<option value="2012">2012</option>';
		var y13 = '<option value="2013">2013</option>';
		var y14 = '<option value="2014">2014</option>';
		var y15 = '<option value="2015">2015</option>';
		var y16 = '<option value="2016">2016</option>';
		var y17 = '<option value="2017">2017</option>';
		var y18 = '<option value="2018">2018</option>';
		var y19 = '<option value="2019">2019</option>';
		var y20 = '<option value="2020">2020</option>';
		var y21 = '<option value="2021">2021</option>';
		var y22 = '<option value="2022">2022</option>';
		var y23 = '<option value="2023">2023</option>';
		var y24 = '<option value="2024">2024</option>';
		var y25 = '<option value="2025">2025</option>';
		var y26 = '<option value="2026">2026</option>';
		var y27 = '<option value="2027">2027</option>';
		//Global Usage
		//else if(sel_bike_model === "") {sel_year.empty().append();}
		//y86 + y87 + y88 + y89 + y90 + y91 + y92 + y93 + y94 + y95 + y96 + y97 + y98 + y99 + y00 + y01 + y02 + y03 + y04 + y05 + y06 + y07 + y08 + y09 + y10 + y11 + y12 + y13 + y14 + y15 + y16 + y17 + y18 + y19

		if (sel_bike_model === "X *FRONT*" || sel_bike_model === "Sting *FRONT*" || sel_bike_model === "XX *FRONT*" || sel_bike_model === "Black Edition *FRONT*" || sel_bike_model === "X *REAR*" || sel_bike_model === "Sting *REAR*" || sel_bike_model === "XX *REAR*" || sel_bike_model === "Black Edition *REAR*" || sel_bike_model === "X 160 *FRONT*" || sel_bike_model === "X 260 *FRONT*" || sel_bike_model === "X 160 *REAR*" || sel_bike_model === "X 260 *REAR*") {
			sel_year.empty().append(y19 + y20 + y21 + y22 + y23 + y24);
		} else if (sel_bike_model === "Sting R *FRONT*" || sel_bike_model === "XXX *FRONT*" || sel_bike_model === "Ultra *FRONT*" || sel_bike_model === "Ultra *REAR*" || sel_bike_model === "Sting R *REAR*" ||sel_bike_model === "XXX *REAR*") {
			sel_year.empty().append(y23 + y24);
		} else if (sel_bike_model === 'Sting MX5 *FRONT*' || sel_bike_model === "Sting MX5 *REAR*") {
			sel_year.empty().append(y23 + y24 + y25 + y26);
		} else if (sel_bike_model === "SR 3.0 *FRONT*" || sel_bike_model === "SR 3.0 *REAR*" || sel_bike_model === "SRPNT X3 *REAR*" || sel_bike_model === "SRPNT X3 *FRONT*") {
			sel_year.empty().append(y25 + y26 + y27);
		} else if (sel_bike_model === "805RX *FRONT*" || sel_bike_model === "805RX *REAR*") {
			sel_year.empty().append(y25 + y26 + y27);
		}

		if (sel_year.find(`option[value="${previous_year}"]`).length > 0) {
			sel_year.val(previous_year); // Set the previous year as selected
		} else {
			sel_year.find('option:first').prop('selected', true); // Default to the first year
		}


		//Hide Speedometer Magnets
		$("#sm_magnets").val(1);
		$("#speedometer").hide();
	}

	function speedometer() {
		var wheel = $('select#wheel_type').val();
		var make = $('select#bike_make').val();
		var model = $('select#bike_model').val();
		//Hide Speedometer Magnets
		$("#sm_magnets").val(1);
		$("#speedometer").hide();

	}

	let debounceTimer;
	let tire_image = {
		"GPR 300 150/60ZR17": "https://www.warp9racing.com/smwheel/sm_images/SM-REAR-tire650.png",
		"MICHELIN 2CT 150/60R17": "https://www.warp9racing.com/smwheel/sm_images/SM-REAR-tire650.png"
	}
	let debounceTimerPrice;
	document.addEventListener('wb_price_updated', function (e) {
		var data = e.detail;
		clearTimeout(debounceTimerPrice);
		debounceTimerPrice = setTimeout(function () {
			// console.log('Price Updated');
			console.log(data);
		}, 500);
	});
	var tprice = function () {

		//Change Tire image
		// clearTimeout(debounceTimer);
		// debounceTimer = setTimeout(function() {
		// 	console.log("This code runs only once after a delay!");
		// 	var selected_tire = $('#mbtire').val();
		// 	// if( selected_tire == "GPR 300 150/60ZR17"){
		// 	// 	$('div#resultAreaID_1_10 img').attr('src', "https://www.warp9racing.com/smwheel/sm_images/SM-REAR-tire650.png");
		// 	// 	$('div#resultAreaID_1_10').show();
		// 	// }else{
		// 	// 	$('div#resultAreaID_1_10 img').attr('src', "");
		// 	// 	$('div#resultAreaID_1_10').hide();
		// 	// }

		// 	if( selected_tire != "mbno"){
		// 		$('div#resultAreaID_1_10 img').attr('src', "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/SM-REAR-tire650_6d4c409a-011a-4913-a00a-2d296f7dca68.png?v=1729666392");
		// 		$('div#resultAreaID_1_10').show();
		// 	}else{
		// 		$('div#resultAreaID_1_10 img').attr('src', "");
		// 		$('div#resultAreaID_1_10').hide();
		// 	}

		// }, 500);
		if (role == "true") {
			var base_price = 299;
			var spoke_price = 40;
			var nipple_price = 25;
			var hub_price = 0;
			var brake_price = 0;
			var wheel_size_price = 0;
			var rim_color = 0;
			var sprocket_bolts = 0;
			var rotor_bolts = 0;
			var rim_size = 0;
			var magnet_price = 0;
			var mbtire_price = 0;
			var rim_lock = 0;
			if ($('select#wheel_type').val() === "FRONT"){
				base_price = 274;
            }
            if ($('select#bike_model').val() === "Ultra *FRONT*"){
                base_price = 322;
            }
            if ($('select#bike_model').val() === "Ultra *REAR*"){
                base_price = 352;
            }

			if ($('select#wheel_type').val() === "FRONT" || $('select#wheel_type').val() === "REAR") {
				// if ($('#rim_color').val() === "White" || $('#rim_color').val() === "Matte-Black" || $('#rim_color').val() === "Red" || $('#rim_color').val() === "Blue" || $('#rim_color').val() === "Orange" || $('#rim_color').val() === "Green" || $('#rim_color').val() === "Gold" || $('#rim_color').val() === "Purple" || $('#rim_color').val() === "Magnesium" || $('#rim_color').val() === "Flo-Yellow" || $('#rim_color').val() === "Nardo-Grey" || $('#rim_color').val() === "School-Bus-Yellow") {
				// 	rim_color = 35;
				// } else if ($('#rim_color').val() === "Blue") {
				// 	rim_color = 45;
				// } else if ($('#rim_color').val() === "Baby-Blue") {
				// 	rim_color = 45;
				// } else {
				// 	rim_color = 0;
				// }
				var anodizationColors = ['Silver', 'Black', 'Red', 'Blue', 'Gold', 'Green', 'Orange', 'Purple', 'Magnesium'];
				var powderCoatColors = ['School-Bus-Yellow', 'Coyote-Tan', 'PBlue', 'Blue', 'Army-Green', 'Baby-Blue', 'Baby-blue', 'Orange', 'Nardo Grey', 'Yellow', 'Flo-yellow', 'White', 'Teal', 'Illusion Violet', 'Illusion-Violet', 'Teal'];
				var specialColors = ['Illusion-Violet', 'Teal'];
				var rim_color_value = $('#rim_color').val();
				var rim_type = $('.rim-type-wrap.active').data('category');
				// Pricing details
				var standardPrice = 35;
				var powderCoatPrice = 35;
				var specialColorPrice = 60;

				if (rim_type === 'anodized' && anodizationColors.includes(rim_color_value)) {
					rim_color = standardPrice;
				} else if (rim_type === 'powder-coat' && powderCoatColors.includes(rim_color_value)) {
					specialColors.includes(rim_color_value) ? rim_color = specialColorPrice : rim_color = powderCoatPrice;
				} else {
					rim_color = 35;
				}
				// console.log({
				// 	rim_color_value
				// });
				// console.log({
				// 	rim_type
				// });
				// console.log({
				// 	rim_color
				// });
			}

			// RIM PRICE 0 IF ANOTIZED SILVER, BLACK, MATTE BLACK
			var rim_type = $('.rim-type-wrap.active').data('category');
			var rim_color_value = $('#rim_color').val();
			if (rim_type === 'anodized') {
				if (rim_color_value == "Black" || rim_color_value == "Silver" || rim_color_value == "Matte-Black") {
					rim_color = 0;
				}
			}
			// RIM PRICE 0 IF ANOTIZED SILVER, BLACK, MATTE BLACK
			if ($('select#rim_lock').val() === "Yes") {
				rim_lock = 13;
			} else {
    		rim_lock = 0;
			}


			if ($('select#rim_type').val() === "Elite")
				base_price = base_price + 20;



			if ($('select#brake_rotor').val() === "220_mm_2") {
				brake_price = brake_price + 39;
			}
			if ($('select#brake_rotor').val() === "220_mm") {
				brake_price = brake_price + 20;
			}
			if ($('select#brake_rotor').val() === "220_mm_floating") {
				brake_price = brake_price + 29;
			}
			if ($('select#brake_rotor').val() === "240_mm_2") {
				brake_price = brake_price + 45;
			}



			var carrier = $('#carrier_id');
			if (carrier.val() == "Yes") {
				base_price = base_price + 99;
			} else {
				base_price = base_price;
			}

			if ($('#spoke_color').val() === "Silver")
				spoke_price = 0;
			if ($('#spoke_color').val() === "Titanium")
				spoke_price = 179;

			if ($('#spoke_color').val() === "Teal" || $('#spoke_color').val() === "Illusion Violet") {
				spoke_price = 65;
			}

			if ($('#nipple_color').val() === "Silver" || $('#spoke_color').val() === "Titanium")
				nipple_price = 0;

			if ($('select#rim_size').val() === "FRONT 21x1.60" || $('select#rim_size').val() === "FRONT 19x1.60") {
				wheel_size_price = 0;
			}



			if ($('select#sprocket_bolts').val() === "Titanium") {
				sprocket_bolts = 29;
			}

			if ($('select#rotor_bolts').val() === "Titanium") {
				rotor_bolts = 21;
			}
			if ($('select#rim_size').val() == "FRONT 21x1.60" || $('select#rim_size').val() === "FRONT 19x1.60") {
				rim_size = 0;
			}
			if ($('select#rim_size').val() == "REAR 17x3.50") {
				rim_size = 61;
			}
			if ($('select#rim_size').val() == "REAR 17x3.00") {
				rim_size = 25;
			}

			if ($('select#sm_magnets').val() == "NO" || $('select#sm_magnets').val() == null) {
				magnet_price = 0;
			} else {
				magnet_price = 5;
			}
			//No SPROCKET
			sprocket_price = getSprocketPrice();

			if ($('select#mbtire').val() == "shinko_524") {
				mbtire_price = mbtire_price + 87;
			} else if ($('select#mbtire').val() == "dunlop_mx53") {
				mbtire_price = mbtire_price + 127;
			} else if ($('select#mbtire').val() == "shinko_r525") {
				mbtire_price = mbtire_price + 97;
			} else if ($('select#mbtire').val() == "dunlop_mx33") {
				mbtire_price = mbtire_price + 147;
			} else if ($('select#mbtire').val() == "michelin") {
				mbtire_price = mbtire_price + 103;
			} else if ($('select#mbtire').val() == "Shinko_241") {
				if ($('select#rim_size').val() == "FRONT 17x2.50" || $('select#rim_size').val() == "FRONT 17x2.15" || $('select#rim_size').val() == "REAR 16x1.85" || $('select#rim_size').val() == "REAR 17x2.50") {
					mbtire_price = mbtire_price + 105;
				} else if ($('select#rim_size').val() == "FRONT 19x1.60") {
					mbtire_price = mbtire_price + 102;
				} else if ($('select#rim_size').val() == "FRONT 21x1.60") {
					mbtire_price = mbtire_price + 113;
				} else if ($('select#rim_size').val() == "REAR 18x1.85") {
					mbtire_price = mbtire_price + 131;
				} else if ($('select#rim_size').val() == "REAR 19x1.60") {
					mbtire_price = mbtire_price + 140;
				} else {

				}
			} else if ($('select#mbtire').val() == "Kenda_K257D") {
				mbtire_price = mbtire_price + 105;
			} else {

			}

			var mbtire = $('#mbtire').val();
			var tirePrices = {
				"DUNLOP MX34 80/100-21": 165,
				"DUNLOP MX34 70/100-19": 103,
				"MICHELIN PS 2 90/80-17": 112,
				"Michelin City Extra": 123,
				"SHINKO 524 70/100-19": 110.95,
				"SHINKO 241 21x275": 107,
				"SHINKO 241 19x275": 97,
				"SHINKO 241 17X300": 100,
				"TUSK GROUND WIRE 70/100-19": 82.00,
				"TUSK EMEX T-35 80/100-21": 95.00,
				"DUNLOP MX34 90/100-16": 115,
				"DUNLOP MX33 90/100-18 REAR": 166,
				"KENDA K257D KLASSIC 3.50-18": 105.00,
				"SHINKO 525 90/100-16": 118.95,
				"SHINKO 241 18x350": 133,
				"SHINKO 241 16x300": 99,
				"TUSK GROUND WIRE 80/90-19": 85.00,
				"MICHELIN PS 2 110/70-17": 121,
				"MICHELIN 2CT 110/70ZR17": 218.95,
				"DUNLOP MX34 100/100-18": 180,
				"MICHELIN 2CT 150/60R17": 261.95,
				"TUSK EMEX T-35 100/100-18": 104.00,
				"MICHELIN PILOT POWER 2CT 110/70R17": 191,
				"MICHELIN PILOT POWER 2CT 150/60R17": 243,
				"BRIDGESTONE BATTLAX S22 140/70-17": 249,
				"CONTINENTAL CONTI ATTACK SM2 140/70-17": 343,
				"DUNLOP GPR-300 140/70R17": 256,
				"DUNLOP MX53 70/100-19": 132,
				"DUNLOP MX53 90/100-16": 144,
				"DUNLOP MX54 100/100-18": 180,
				"DUNLOP MX54 70/100-19": 103,
				"DUNLOP MX54 80/100-21": 165,
				"DUNLOP MX54 90/100-16": 115,
			};

			var selectedPrice = tirePrices[mbtire];
			if (selectedPrice !== undefined) {
				mbtire_price = selectedPrice;
			} else {
				mbtire_price = mbtire_price;
			}
			// console.log("Tire Price: $" + mbtire_price);

			// NEW brakeprice
			brake_price = getBrakePrice();
			// console.log("Dealer Brake Price: $" + brake_price);
			// NEW brakeprice
			if ($('select#rotor_bolts').val() === "Standard") {
				rotor_bolts = 0;
			} else {
				rotor_bolts = 21;
			}
			if (isBonnell805RxPricingModel()) {
				if ($('select#wheel_type').val() === "FRONT") {
					sprocket_bolts = 0;
				} else {
					sprocket_bolts = $('select#sprocket_bolts').val() === "Titanium" ? 39 : 0;
				}
				magnet_price = ($('select#sm_magnets').val() == "NO" || $('select#sm_magnets').val() == null) ? 0 : 7;
			}

			var standardPrices = applyStandardEbikePricing(true, { base_price: base_price, hub_price: hub_price, spoke_price: spoke_price, nipple_price: nipple_price, brake_price: brake_price, rim_color: rim_color, sprocket_price: sprocket_price });
			base_price = standardPrices.base_price;
			hub_price = standardPrices.hub_price;
			spoke_price = standardPrices.spoke_price;
			nipple_price = standardPrices.nipple_price;
			brake_price = standardPrices.brake_price;
			rim_color = standardPrices.rim_color;
			sprocket_price = standardPrices.sprocket_price;

			// console.log(base_price, hub_price, spoke_price, nipple_price, brake_price, wheel_size_price, rim_color, sprocket_bolts, rotor_bolts, rim_size, magnet_price, mbtire_price, rim_lock);
			var price = base_price + hub_price + spoke_price + nipple_price + brake_price + wheel_size_price + rim_color + sprocket_bolts + rotor_bolts + rim_size + magnet_price + mbtire_price + rim_lock + sprocket_price;
			price = roundUpIfEndsWith95(price);		
			new_base_price = price;
			const wb_price_updated = new CustomEvent('wb_price_updated', {
				detail: {
					base_price,
					hub_price,
					spoke_price,
					nipple_price,
					brake_price,
					wheel_size_price,
					rim_color,
					sprocket_bolts,
					rim_size,
					rotor_bolts,
					magnet_price,
					mbtire_price,
					rim_lock,
					price,
					sprocket_price,
					
				}
			});
			document.dispatchEvent(wb_price_updated);
			$('#price').text('$' + price);
			$('#amount').val(price);
			$('#dlr_price').val(price);
			$('#description1').val($('select#bike_make').val());
			$('#description2').val($('select#bike_model').val());
			$('#description3').val(" rim_size:" + $('select#rim_size').val());
			$('#description4').val(" hub_color:" + $('#hub_color').val());
			$('#description5').val(" rim_color:" + $('#rim_color').val());
			$('#description6').val(" spoke_color:" + $('#spoke_color').val());
			$('#description7').val(" nipple_color:" + $('#nipple_color').val());
			$('#description8').val(" brake_rotor:" + $('select#brake_rotor').val());
			$('#description9').val(" sprocket_teeth:" + $('select#sprocket_size').val());
			var retail_price = retailPrice();
			$('#retail-price').text('$' + retail_price);
			console.log(retail_price);

		} else {
			// console.log('Option Changed')
			var base_price = 412;
			var spoke_price = 65;
			var nipple_price = 35;
			var hub_price = 0;
			var brake_price = 0;
			var wheel_size_price = 0;
			var rim_color = 0;
			var sprocket_bolts = 0;
			var rotor_bolts = 0;
			var rim_size = 0;
			var magnet_price = 0;
			var mbtire_price = 0;
			var rim_lock = 0;
			var rim = $('select#rim_lock').val();
			if ($('select#rim_lock').val() === "Yes") {
				rim_lock = 21;
			} else {
				rim_lock = 0;
			}

			if ($('select#wheel_type').val() === "FRONT"){
				base_price = 304;
            }
            if ($('select#bike_model').val() === "Ultra *FRONT*"){
                base_price = 429;
            }
            if ($('select#bike_model').val() === "Ultra *REAR*"){
                base_price = 452;
            }

			if ($("select#bike_make").val() === "Surron" && $("select#wheel_type").val() === "REAR") {
				base_price = 412;
			}

			if ($('select#wheel_type').val() === "REAR" || $('select#wheel_type').val() === "FRONT") {
				// if ($('#rim_color').val() === "White" || $('#rim_color').val() === "Matte-Black" || $('#rim_color').val() === "Red" || $('#rim_color').val() === "Blue" || $('#rim_color').val() === "Orange" || $('#rim_color').val() === "Green" || $('#rim_color').val() === "Gold" || $('#rim_color').val() === "Purple" || $('#rim_color').val() === "Magnesium" || $('#rim_color').val() === "Flo-Yellow" || $('#rim_color').val() === "Nardo-Grey" || $('#rim_color').val() === "School-Bus-Yellow") {
				// 	rim_color = 50;
				// } else if ($('#rim_color').val() === "Blue") {
				// 	rim_color = 60;
				// } else if ($('#rim_color').val() === "Baby-Blue") {
				// 	rim_color = 60;
				// } else {
				// 	rim_color = 0;
				// }
				var anodizationColors = ['Silver', 'Black', 'Red', 'Blue', 'Gold', 'Green', 'Orange', 'Purple', 'Magnesium'];
				var powderCoatColors = ['School-Bus-Yellow', 'Coyote-Tan', 'PBlue', 'Blue', 'Army-Green', 'Baby-Blue', 'Baby-blue', 'Orange', 'Nardo-Grey', 'Yellow', 'Flo-yellow', 'White', 'Teal', 'Illusion Violet', 'Illusion-Violet', 'Teal'];
				var specialColors = ['Illusion-Violet', 'Teal'];
				var rim_color_value = $('#rim_color').val();
				var rim_type = $('.rim-type-wrap.active').data('category');
				// Pricing details
				var standardPrice = 50;
				var powderCoatPrice = 50;
				var specialColorPrice = 80;

				if (rim_type === 'anodized' && anodizationColors.includes(rim_color_value)) {
					rim_color = standardPrice;
				} else if (rim_type === 'powder-coat' && powderCoatColors.includes(rim_color_value)) {
					specialColors.includes(rim_color_value) ? rim_color = specialColorPrice : rim_color = powderCoatPrice;
				} else {
					rim_color = 50;
				}
				// console.log({
				// 	rim_color_value
				// });
				// console.log({
				// 	rim_type
				// });
				// console.log({
				// 	rim_color
				// });
			}

			// RIM PRICE 0 IF ANOTIZED SILVER, BLACK, MATTE BLACK
			var rim_type = $('.rim-type-wrap.active').data('category');
			var rim_color_value = $('#rim_color').val();
			if (rim_type === 'anodized') {
				if (rim_color_value == "Black" || rim_color_value == "Silver" || rim_color_value == "Matte-Black") {
					rim_color = 0;
				}
			}
			// RIM PRICE 0 IF ANOTIZED SILVER, BLACK, MATTE BLACK

			if ($('select#rim_type').val() === "Elite")
				base_price = base_price + 30;

			if ($('select#brake_rotor').val() === "220_mm_2" || $('select#brake_rotor').val() === "240_mm_2") {
				brake_price = brake_price + 65;
			}
			if ($('select#brake_rotor').val() === "220_mm") {
				brake_price = brake_price + 20;
			}
			if ($('select#brake_rotor').val() === "220_mm_floating") {
				brake_price = brake_price + 29;
			}

			var carrier = $('#carrier_id');
			if (carrier.val() == "Yes") {
				base_price = base_price + 125;
			} else {
				base_price = base_price;
			}

			if ($('#spoke_color').val() === "Silver")
				spoke_price = 0;
			if ($('#spoke_color').val() === "Titanium")
				spoke_price = 249;

			if ($('#spoke_color').val() === "Teal" || $('#spoke_color').val() === "Illusion Violet") {
				spoke_price = 89;
			}

			if ($('#nipple_color').val() === "Silver" || $('#spoke_color').val() === "Titanium")
				nipple_price = 0;


			if ($('select#rim_size').val() === "FRONT 21x1.60" || $('select#rim_size').val() === "FRONT 19x1.60") {
				wheel_size_price = 0;
			}




			if ($('select#sprocket_bolts').val() === "Titanium") {
				sprocket_bolts = 45;
			}

			if ($('select#rotor_bolts').val() === "Titanium") {
				rotor_bolts = 31;
			}
			if ($('select#rim_size').val() == "FRONT 21x1.60" || $('select#rim_size').val() === "FRONT 19x1.60") {
				rim_size = 0;
			}
			if ($('select#rim_size').val() == "REAR 19x3.00") {
				rim_size = 60;
			}

			if ($('select#rim_size').val() == "REAR 17x3.00") {
				rim_size = 49;
			}

			if ($('select#sm_magnets').val() == "NO" || $('select#sm_magnets').val() == null) {
				magnet_price = 0;
			} else {
				magnet_price = 10;
			}
			//No SPROCKET
			sprocket_price = getSprocketPrice();

			if ($('select#mbtire').val() == "shinko_524") {
				mbtire_price = mbtire_price + 87;
			} else if ($('select#mbtire').val() == "dunlop_mx53") {
				mbtire_price = mbtire_price + 127;
			} else if ($('select#mbtire').val() == "shinko_r525") {
				mbtire_price = mbtire_price + 97;
			} else if ($('select#mbtire').val() == "dunlop_mx33") {
				mbtire_price = mbtire_price + 147;
			} else if ($('select#mbtire').val() == "michelin") {
				mbtire_price = mbtire_price + 103;
			} else if ($('select#mbtire').val() == "Shinko_241") {
				if ($('select#rim_size').val() == "FRONT 17x2.50" || $('select#rim_size').val() == "FRONT 17x2.15" || $('select#rim_size').val() == "REAR 16x1.85" || $('select#rim_size').val() == "REAR 17x2.50") {
					mbtire_price = mbtire_price + 105;
				} else if ($('select#rim_size').val() == "FRONT 19x1.60") {
					mbtire_price = mbtire_price + 102;
				} else if ($('select#rim_size').val() == "FRONT 21x1.60") {
					mbtire_price = mbtire_price + 113;
				} else if ($('select#rim_size').val() == "REAR 18x1.85") {
					mbtire_price = mbtire_price + 131;
				} else if ($('select#rim_size').val() == "REAR 19x1.60") {
					mbtire_price = mbtire_price + 140;
				} else {

				}
			} else if ($('select#mbtire').val() == "Kenda_K257D") {
				mbtire_price = mbtire_price + 105;
			} else {

			}
			var mbtire = $('#mbtire').val();
			var tirePrices = {
				"DUNLOP MX34 80/100-21": 165,
				"DUNLOP MX34 70/100-19": 103,
				"MICHELIN PS 2 90/80-17": 112,
				"Michelin City Extra": 123,
				"SHINKO 524 70/100-19": 110.95,
				"SHINKO 241 21x275": 107,
				"SHINKO 241 19x275": 97,
				"SHINKO 241 17X300": 100,
				"TUSK GROUND WIRE 70/100-19": 82.00,
				"TUSK EMEX T-35 80/100-21": 95.00,
				"DUNLOP MX34 90/100-16": 115,
				"DUNLOP MX33 90/100-18 REAR": 166,
				"KENDA K257D KLASSIC 3.50-18": 105.00,
				"SHINKO 525 90/100-16": 118.95,
				"SHINKO 241 18x350": 133,
				"SHINKO 241 16x300": 99,
				"TUSK GROUND WIRE 80/90-19": 85.00,
				"MICHELIN PS 2 110/70-17": 121,
				"MICHELIN 2CT 110/70ZR17": 218.95,
				"DUNLOP MX34 100/100-18": 180,
				"MICHELIN 2CT 150/60R17": 261.95,
				"TUSK EMEX T-35 100/100-18": 104.00,
				"MICHELIN PILOT POWER 2CT 110/70R17": 191,
				"MICHELIN PILOT POWER 2CT 150/60R17": 243,
				"BRIDGESTONE BATTLAX S22 140/70-17": 249,
				"CONTINENTAL CONTI ATTACK SM2 140/70-17": 343,
				"DUNLOP GPR-300 140/70R17": 256,
				"DUNLOP MX53 70/100-19": 132,
				"DUNLOP MX53 90/100-16": 144,
				"DUNLOP MX54 100/100-18": 180,
				"DUNLOP MX54 70/100-19": 103,
				"DUNLOP MX54 80/100-21": 165,
				"DUNLOP MX54 90/100-16": 115,
			};

			var selectedPrice = tirePrices[mbtire];
			console.log('selectedPrice:', selectedPrice);
			if (selectedPrice !== undefined) {
				mbtire_price = selectedPrice;
			} else {
				mbtire_price = mbtire_price;
			}
			console.log("Tire Price: $" + mbtire_price);

			// NEW brakeprice
			brake_price = getBrakePrice();

			if ($('select#rotor_bolts').val() === "Standard") {
				rotor_bolts = 0;
			} else {
				rotor_bolts = 31;
			}
			// NEW brakeprice
			if (isBonnell805RxPricingModel()) {
				if ($('select#wheel_type').val() === "FRONT") {
					sprocket_bolts = 0;
				} else {
					sprocket_bolts = $('select#sprocket_bolts').val() === "Titanium" ? 59 : 0;
				}
				magnet_price = ($('select#sm_magnets').val() == "NO" || $('select#sm_magnets').val() == null) ? 0 : 11;
			}

			var standardPrices = applyStandardEbikePricing(false, { base_price: base_price, hub_price: hub_price, spoke_price: spoke_price, nipple_price: nipple_price, brake_price: brake_price, rim_color: rim_color, sprocket_price: sprocket_price });
			base_price = standardPrices.base_price;
			hub_price = standardPrices.hub_price;
			spoke_price = standardPrices.spoke_price;
			nipple_price = standardPrices.nipple_price;
			brake_price = standardPrices.brake_price;
			rim_color = standardPrices.rim_color;
			sprocket_price = standardPrices.sprocket_price;

			console.log(base_price, hub_price, spoke_price, nipple_price, brake_price, wheel_size_price, rim_color, sprocket_bolts, rotor_bolts, rim_size, magnet_price, mbtire_price, rim_lock);
			var price = base_price + hub_price + spoke_price + nipple_price + brake_price + wheel_size_price + rim_color + sprocket_bolts + rotor_bolts + rim_size + magnet_price + mbtire_price + rim_lock + sprocket_price;
			price = roundUpIfEndsWith95(price);		
			new_base_price = price;			
			const wb_price_updated = new CustomEvent('wb_price_updated', {
				detail: {
					base_price,
					hub_price,
					spoke_price,
					nipple_price,
					brake_price,
					wheel_size_price,
					rim_color,
					sprocket_bolts,
					rotor_bolts,
					magnet_price,
					mbtire_price,
					rim_lock,
					sprocket_price,
					price,
					rim_size
				}
			});
			document.dispatchEvent(wb_price_updated);

			$('#price').text('$' + price);
			$('#amount').val(price);
			$('#rgr_price').val(price);
			$('#description1').val($('select#bike_make').val());
			$('#description2').val($('select#bike_model').val());
			$('#description3').val(" rim_size:" + $('select#rim_size').val());
			$('#description4').val(" hub_color:" + $('#hub_color').val());
			$('#description5').val(" rim_color:" + $('#rim_color').val());
			$('#description6').val(" spoke_color:" + $('#spoke_color').val());
			$('#description7').val(" nipple_color:" + $('#nipple_color').val());
			$('#description8').val(" brake_rotor:" + $('select#brake_rotor').val());
			$('#description9').val(" sprocket_teeth:" + $('select#sprocket_size').val());
			return true;
		}
	}

	var retailPrice = function () {


		var base_price = 412;
		var spoke_price = 65;
		var nipple_price = 35;
		var hub_price = 0;
		var brake_price = 0;
		var wheel_size_price = 0;
		var rim_color = 0;
		var sprocket_bolts = 0;
		var rotor_bolts = 0;
		var rim_size = 0;
		var magnet_price = 0;
		var mbtire_price = 0;
		var rim_lock = 0;
		var rim = $('select#rim_lock').val();
		if ($('select#rim_lock').val() === "Yes") {
			rim_lock = 21;
		} else {
			rim_lock = 0;
		}

		if ($('select#wheel_type').val() === "FRONT"){
			base_price = 383;
        }
		if ($("select#bike_make").val() === "Surron" && $("select#wheel_type").val() === "REAR") {
			base_price = 412;
		}
        if ($('select#bike_model').val() === "Ultra *FRONT*"){
            base_price = 429;
        }
        if ($('select#bike_model').val() === "Ultra *REAR*"){
            base_price = 452;
        }

		if ($('select#wheel_type').val() === "REAR" || $('select#wheel_type').val() === "FRONT") {
			// if ($('#rim_color').val() === "White" || $('#rim_color').val() === "Matte-Black" || $('#rim_color').val() === "Red" || $('#rim_color').val() === "Blue" || $('#rim_color').val() === "Orange" || $('#rim_color').val() === "Green" || $('#rim_color').val() === "Gold" || $('#rim_color').val() === "Purple" || $('#rim_color').val() === "Magnesium" || $('#rim_color').val() === "Flo-Yellow" || $('#rim_color').val() === "Nardo-Grey" || $('#rim_color').val() === "School-Bus-Yellow") {
			// 	rim_color = 50;
			// } else if ($('#rim_color').val() === "Blue") {
			// 	rim_color = 60;
			// } else if ($('#rim_color').val() === "Baby-Blue") {
			// 	rim_color = 60;
			// } else {
			// 	rim_color = 0;
			// }
			var anodizationColors = ['Silver', 'Black', 'Red', 'Blue', 'Gold', 'Green', 'Orange', 'Purple', 'Magnesium'];
			var powderCoatColors = ['School-Bus-Yellow', 'Coyote-Tan', 'PBlue', 'Blue', 'Army-Green', 'Baby-Blue', 'Baby-blue', 'Orange', 'Nardo-Grey', 'Yellow', 'Flo-yellow', 'White', 'Teal', 'Illusion Violet', 'Illusion-Violet', 'Teal'];
			var specialColors = ['Illusion-Violet', 'Teal'];
			var rim_color_value = $('#rim_color').val();
			var rim_type = $('.rim-type-wrap.active').data('category');
			// Pricing details
			var standardPrice = 50;
			var powderCoatPrice = 50;
			var specialColorPrice = 80;

			if (rim_type === 'anodized' && anodizationColors.includes(rim_color_value)) {
				rim_color = standardPrice;
			} else if (rim_type === 'powder-coat' && powderCoatColors.includes(rim_color_value)) {
				specialColors.includes(rim_color_value) ? rim_color = specialColorPrice : rim_color = powderCoatPrice;
			} else {
				rim_color = 50;
			}
			// console.log({
			// 	rim_color_value
			// });
			// console.log({
			// 	rim_type
			// });
			// console.log({
			// 	rim_color
			// });
		}

		// RIM PRICE 0 IF ANOTIZED SILVER, BLACK, MATTE BLACK
		var rim_type = $('.rim-type-wrap.active').data('category');
		var rim_color_value = $('#rim_color').val();
		if (rim_type === 'anodized') {
			if (rim_color_value == "Black" || rim_color_value == "Silver" || rim_color_value == "Matte-Black") {
				rim_color = 0;
			}
		}
		// RIM PRICE 0 IF ANOTIZED SILVER, BLACK, MATTE BLACK

		if ($('select#rim_type').val() === "Elite")
			base_price = base_price + 30;

		if ($('select#brake_rotor').val() === "220_mm_2" || $('select#brake_rotor').val() === "240_mm_2") {
			brake_price = brake_price + 65;
		}
		if ($('select#brake_rotor').val() === "220_mm") {
			brake_price = brake_price + 20;
		}
		if ($('select#brake_rotor').val() === "220_mm_floating") {
			brake_price = brake_price + 29;
		}

		var carrier = $('#carrier_id');
		if (carrier.val() == "Yes") {
			base_price = base_price + 125;
		} else {
			base_price = base_price;
		}

		if ($('#spoke_color').val() === "Silver")
			spoke_price = 0;
		if ($('#spoke_color').val() === "Titanium")
			spoke_price = 249;

		if ($('#spoke_color').val() === "Teal" || $('#spoke_color').val() === "Illusion Violet") {
			spoke_price = 89;
		}

		if ($('#nipple_color').val() === "Silver" || $('#spoke_color').val() === "Titanium")
			nipple_price = 0;


		if ($('select#rim_size').val() === "FRONT 21x1.60" || $('select#rim_size').val() === "FRONT 19x1.60") {
			wheel_size_price = 0;
		}




		if ($('select#sprocket_bolts').val() === "Titanium") {
			sprocket_bolts = 45;
		}

		if ($('select#rotor_bolts').val() === "Titanium") {
			rotor_bolts = 31;
		}
		if ($('select#rim_size').val() == "FRONT 21x1.60" || $('select#rim_size').val() === "FRONT 19x1.60") {
			rim_size = 0;
		}
		if ($('select#rim_size').val() == "REAR 19x3.00") {
			rim_size = 60;
		}

		if ($('select#rim_size').val() == "REAR 17x3.00") {
			rim_size = 49;
		}

		if ($('select#sm_magnets').val() == "NO" || $('select#sm_magnets').val() == null) {
			magnet_price = 0;
		} else {
			magnet_price = 10;
		}
		//No SPROCKET
		sprocket_price = getSprocketPrice();

		if ($('select#mbtire').val() == "shinko_524") {
			mbtire_price = mbtire_price + 87;
		} else if ($('select#mbtire').val() == "dunlop_mx53") {
			mbtire_price = mbtire_price + 127;
		} else if ($('select#mbtire').val() == "shinko_r525") {
			mbtire_price = mbtire_price + 97;
		} else if ($('select#mbtire').val() == "dunlop_mx33") {
			mbtire_price = mbtire_price + 147;
		} else if ($('select#mbtire').val() == "michelin") {
			mbtire_price = mbtire_price + 103;
		} else if ($('select#mbtire').val() == "Shinko_241") {
			if ($('select#rim_size').val() == "FRONT 17x2.50" || $('select#rim_size').val() == "FRONT 17x2.15" || $('select#rim_size').val() == "REAR 16x1.85" || $('select#rim_size').val() == "REAR 17x2.50") {
				mbtire_price = mbtire_price + 105;
			} else if ($('select#rim_size').val() == "FRONT 19x1.60") {
				mbtire_price = mbtire_price + 102;
			} else if ($('select#rim_size').val() == "FRONT 21x1.60") {
				mbtire_price = mbtire_price + 113;
			} else if ($('select#rim_size').val() == "REAR 18x1.85") {
				mbtire_price = mbtire_price + 131;
			} else if ($('select#rim_size').val() == "REAR 19x1.60") {
				mbtire_price = mbtire_price + 140;
			} else {

			}
		} else if ($('select#mbtire').val() == "Kenda_K257D") {
			mbtire_price = mbtire_price + 105;
		} else {

		}
		var mbtire = $('#mbtire').val();
		var tirePrices = {
			"DUNLOP MX34 80/100-21": 165,
			"DUNLOP MX34 70/100-19": 103,
			"MICHELIN PS 2 90/80-17": 112,
			"Michelin City Extra": 123,
			"SHINKO 524 70/100-19": 110.95,
			"SHINKO 241 21x275": 107,
			"SHINKO 241 19x275": 97,
			"SHINKO 241 17X300": 100,
			"TUSK GROUND WIRE 70/100-19": 82.00,
			"TUSK EMEX T-35 80/100-21": 95.00,
			"DUNLOP MX34 90/100-16": 115,
			"DUNLOP MX33 90/100-18 REAR": 166,
			"KENDA K257D KLASSIC 3.50-18": 105.00,
			"SHINKO 525 90/100-16": 118.95,
			"SHINKO 241 18x350": 133,
			"SHINKO 241 16x300": 99,
			"TUSK GROUND WIRE 80/90-19": 85.00,
			"MICHELIN PS 2 110/70-17": 121,
			"MICHELIN 2CT 110/70ZR17": 218.95,
			"DUNLOP MX34 100/100-18": 180,
			"MICHELIN 2CT 150/60R17": 261.95,
			"TUSK EMEX T-35 100/100-18": 104.00,
			"MICHELIN PILOT POWER 2CT 110/70R17": 191,
			"MICHELIN PILOT POWER 2CT 150/60R17": 243,
			"BRIDGESTONE BATTLAX S22 140/70-17": 249,
			"CONTINENTAL CONTI ATTACK SM2 140/70-17": 343,
			"DUNLOP GPR-300 140/70R17": 256,
			"DUNLOP MX53 70/100-19": 132,
			"DUNLOP MX53 90/100-16": 144,
			"DUNLOP MX54 100/100-18": 180,
			"DUNLOP MX54 70/100-19": 103,
			"DUNLOP MX54 80/100-21": 165,
			"DUNLOP MX54 90/100-16": 115,
		};

		var selectedPrice = tirePrices[mbtire];
		if (selectedPrice !== undefined) {
			mbtire_price = selectedPrice;
		} else {
			mbtire_price = mbtire_price;
		}
		// console.log("Tire Price: $" + mbtire_price);

		// NEW brakeprice
		brake_price = getBrakePrice();

		if ($('select#rotor_bolts').val() === "Standard") {
			rotor_bolts = 0;
		} else {
			rotor_bolts = 31;
		}
		var standardPrices = applyStandardEbikePricing(false, { base_price: base_price, hub_price: hub_price, spoke_price: spoke_price, nipple_price: nipple_price, brake_price: brake_price, rim_color: rim_color, sprocket_price: sprocket_price });
		base_price = standardPrices.base_price;
		hub_price = standardPrices.hub_price;
		spoke_price = standardPrices.spoke_price;
		nipple_price = standardPrices.nipple_price;
		brake_price = standardPrices.brake_price;
		rim_color = standardPrices.rim_color;
		sprocket_price = standardPrices.sprocket_price;

		// NEW brakeprice
		// console.log(base_price, hub_price, spoke_price, nipple_price, brake_price, wheel_size_price, rim_color, sprocket_bolts, rotor_bolts, rim_size, magnet_price, mbtire_price, rim_lock);
		var price = base_price + hub_price + spoke_price + nipple_price + brake_price + wheel_size_price + rim_color + sprocket_bolts + rotor_bolts + rim_size + magnet_price + mbtire_price + rim_lock + sprocket_price;
		
		price = roundUpIfEndsWith95(price);	
		return price
	}

	$('select#bike_model').change(function () {
		bikeyear();
		var bikeModelValue = $('#bike_model').val();

		if (bikeModelValue && bikeModelValue.includes('FRONT')) {
			//Sting Brake Rotor Style
			if ($('select#bike_model').val() === "805RX *FRONT*") {
				select = $('#brake_rotor');
				select.empty().append('<option value="Wave">Wave</option>');
			} else if ($('select#bike_model').val() === "X *FRONT*" || $('select#bike_model').val() === "Sting R *FRONT*" || $('select#bike_model').val() === "Sting MX5 *FRONT*"  || $('select#bike_model').val() === "Sting *FRONT*" || $('select#bike_model').val() === "XXX *FRONT*") {
				select = $('#brake_rotor');
				select.empty().append('<option value="203_mm">203 x 1.8 mm Fixed</option><option value="220_mm">220 x 1.8 mm Fixed</option><option value="220_mm_floating">220 x 1.8 mm Floating</option><option class="category" value="220_mm_2">220mm x 2.3mm Floating</option><option class="category" value="240_mm_2">240mm x 2.3mm Floating</option>');
			} else if ($('select#bike_model').val() === "X 260 *FRONT*") {
				select = $('#brake_rotor');
				select.empty().append('<option value="203_mm">203 x 1.8 mm Fixed</option><option value="220_mm">220 x 1.8 mm Fixed</option><option value="220_mm_floating">220 x 1.8 mm Floating</option><option class="category" value="240_mm_2">240mm x 2.3mm Floating</option>');
			} else if ($('select#bike_model').val() === "Ultra *FRONT*") {
				select = $('#brake_rotor');
				select.empty().append('<option value="240_mm">240 x 3.0 mm Fixed</option>');
			} else {
				select = $('#brake_rotor');
				select.empty().append('<option value="203_mm">203 x 1.8 mm Fixed</option><option value="220_mm">220 x 1.8 mm Fixed</option><option value="220_mm_floating">220 x 1.8 mm Floating</option>');
			}
			//    $('select#wheel_type').val('FRONT');
			$('#brake_rotor').prop("disabled", false);


			if ($('select#wheel_type').val() == 1) //front
			{

				$('#sprocket').show();
				$('#resultAreaID_1_7').show();
				$('#resultAreaID_1_6').hide();
				if ($('select#brake_rotor').val() == "220_mm_floating") {
					var image_name = images + "S-" + $('select#brake_rotor').val() + ".png";
					var imageArr6 = [image_name];
					var divArr6 = ["resultAreaID_1_7"];
					// $('#resultAreaID_1_7 img').attr('src', image_name);

				} else {
					var image_name = images + "S-" + $('select#brake_rotor').val() + ".png";
					var imageArr6 = [image_name];
					var divArr6 = ["resultAreaID_1_7"];
					// $('#resultAreaID_1_7 img').attr('src', image_name);
				}
			} else { //rear

				$('#sprocket').hide();
				//$('#resultAreaID_1_7').hide();
			}
		} else {
			//    $('select#wheel_type').val('REAR');
			$('select#brake_rotor').val('fixed');
			$('#brake_rotor').prop("disabled", false);
			//Sting Brake Rotor Style
			if ($('select#bike_model').val() === "805RX *REAR*") {
				select = $('#brake_rotor');
				select.empty().append('<option value="Wave">Wave</option>');
			} else if ($('select#bike_model').val() === "X *FRONT*" || $('select#bike_model').val() === "Sting R *FRONT*" || $('select#bike_model').val() === "Sting *FRONT*" || $('select#bike_model').val() === "XXX *FRONT*") {
				select = $('#brake_rotor');
				select.empty().append('<option value="203_mm">203 x 1.8 mm Fixed</option><option value="220_mm">220 x 1.8 mm Fixed</option><option value="220_mm_floating">220 x 1.8 mm Floating</option><option class="category" value="220_mm_2">220mm x 2.3mm Floating</option><option class="category" value="240_mm_2">240mm x 2.3mm Floating</option>');
			} else if ($('select#bike_model').val() === "X 260 *FRONT*") {
				select = $('#brake_rotor');
				select.empty().append('<option value="203_mm">203 x 1.8 mm Fixed</option><option value="220_mm">220 x 1.8 mm Fixed</option><option value="220_mm_floating">220 x 1.8 mm Floating</option><option class="category" value="240_mm_2">240mm x 2.3mm Floating</option>');
			} else if ($('select#bike_model').val() === "Ultra *REAR*") {
				select = $('#brake_rotor');
				select.empty().append('<option value="240_mm">240 x 3.0 mm Fixed</option>');
			} else {
				select = $('#brake_rotor');
				select.empty().append('<option value="203_mm">203 x 1.8 mm Fixed</option><option value="220_mm">220 x 1.8 mm Fixed</option><option value="220_mm_floating">220 x 1.8 mm Floating</option>');
			}
			if ($('select#wheel_type').val() == 1) //front
			{
				$('#sprocket').show();
				$('#resultAreaID_1_7').show();
				$('#resultAreaID_1_6').hide();
				if ($('select#brake_rotor').val() == "220_mm_floating") {
					var image_name = images + "S-" + $('select#brake_rotor').val() + ".png";
					var imageArr6 = [image_name];
					var divArr6 = ["resultAreaID_1_7"];
					// $('#resultAreaID_1_7 img').attr('src', image_name);

				} else {
					var image_name = images + "S-" + $('select#brake_rotor').val() + ".png";
					var imageArr6 = [image_name];
					var divArr6 = ["resultAreaID_1_7"];
					// $('#resultAreaID_1_7 img').attr('src', image_name);
				}
			} else { //rear
				$('#sprocket').hide();
				//$('#resultAreaID_1_7').hide();
			}
		}
		updateBrakeRotor();
		syncNoRotorOption();
		// if ($('#bike_model').val().includes("260mm") || $('select#bike_model').val().indexOf("256mm") >= 0 || $('select#bike_model').val().indexOf("300mm") >= 0 || $('select#bike_model').val().indexOf("310mm") >= 0) {
		// 	$('select#brake_rotor').val('fixed');
		// 	$('#brake_rotor').prop("disabled", true);
		// }
		var bike_model = $('#bike_model').val();

		if (!bike_model) {
			const hiddenBikeModel = document.querySelector('#hidden_bike_model');
			const visibleBikeModel = document.querySelector('#bike_model');
			const hiddenOptions = hiddenBikeModel.options;
			bike_model = hiddenBikeModel.value;

			Array.from(hiddenOptions).forEach(option => {
				visibleBikeModel.add(new Option(option.text, option.value));
			});
		}

		var values = ['260mm', '256mm', '300mm', '310mm'];

		if (values.some(value => bike_model.indexOf(value) >= 0)) {
			$('select#brake_rotor').val('fixed');
			$('#brake_rotor').prop("disabled", true);
		}

		//HUB COLOR
		var image_name = images + "hub-top-" + $('#hub_color').val() + "-" + $('select#wheel_type').val() + ".png";
		var imageArr1 = [image_name];
		var divArr1 = ["resultAreaID_1_0"];
		$('#resultAreaID_1_0 img').attr('src', image_name);

		var image_name = images + "hub-bottom-" + $('#hub_color').val() + "-" + $('select#wheel_type').val() + ".png";
		var imageArr6 = [image_name];
		var divArr6 = ["resultAreaID_1_5"];
		$('#resultAreaID_1_5 img').attr('src', image_name);
		//RIM COLOR
		var image_name = images + "rim-" + $('#rim_color').val() + "-" + $('select#wheel_type').val() + ".png";
		var imageArr2 = [image_name];
		var divArr2 = ["resultAreaID_1_1"];
		$('#resultAreaID_1_1 img').attr('src', image_name);
		//SPOKE COLOR
		var image_name = images + "spokes-" + $('#spoke_color').val() + "-" + $('select#wheel_type').val() + ".png";
		var imageArr3 = [image_name];
		var divArr3 = ["resultAreaID_1_2"];
		$('#resultAreaID_1_2 img').attr('src', image_name);
		//NIPPLE COLOR
		var image_name = images + "nipple-" + $('#nipple_color').val() + "-" + $('select#wheel_type').val() + ".png";
		var imageArr4 = [image_name];
		var divArr4 = ["resultAreaID_1_3"];
		$('#resultAreaID_1_3 img').attr('src', image_name);
		//SPROCKET SIZE
		if ($('select#brake_rotor').val() == "220_mm_floating") {
			var image_name = images + "S-" + $('select#brake_rotor').val() + ".png";
			var imageArr6 = [image_name];
			var divArr6 = ["resultAreaID_1_7"];
			// $('#resultAreaID_1_7 img').attr('src', image_name);

		} else {
			var image_name = images + "S-" + $('select#brake_rotor').val() + ".png";
			var imageArr6 = [image_name];
			var divArr6 = ["resultAreaID_1_7"];
			// $('#resultAreaID_1_7 img').attr('src', image_name);
		}

		if ($('select#wheel_type').val() == "FRONT") {
			$('#sprocket').hide();
			// $('#resultAreaID_1_7').hide();
			$('#resultAreaID_1_6').hide();
		} else {
			$('#sprocket').show();
			$('#resultAreaID_1_7').show();
			$('#resultAreaID_1_6').show();
			var image_name = images + "rotor.png";
			var imageArr5 = [image_name];
			var divArr5 = ["resultAreaID_1_6"];
			// $('#resultAreaID_1_6 img').attr('src', image_name);
		}

		$('#carrier_id').prop('selectedIndex', 0);

		var select_model = $('select#bike_model');


		$('#rotor_bolts').prop('selectedIndex', 0);


		select = $('#sprocket_bolts');
		select.empty().append(' <option class="category" value="Standard">Standard</option><option class="category" value="Titanium">Titanium</option>');

		select = $('#rotor_bolts');
		select.empty().append(' <option class="category" value="Standard">Standard</option><option class="category" value="Titanium">Titanium</option>');
		


		// Hide Blue rim color
		rimcolorhideblue();
		if ($('select#bike_model').val() === "Ultra *REAR*") {
			var select = $('#sprocket_size');
			select.empty().append(ULTRA_BEE_SPROCKET_OPTIONS_HTML);
		} else {
			var select = $('#sprocket_size');
			select.empty().append('<option class="category" value="42 Teeth">42 Teeth</option><option class="category" value="48 Teeth">48 Teeth</option><option class="category" value="52 Teeth">52 Teeth</option><option class="category" value="54 Teeth">54 Teeth</option><option class="category" value="58 Teeth">58 Teeth</option><option class="category" value="60 Teeth">60 Teeth</option><option class="category" value="62 Teeth">62 Teeth</option><option class="category" value="64 Teeth">64 Teeth</option><option class="category" value="no">No Sprocket</option>');
		}
		updateModelSpecificSprocketOptions();
		updateBrakeRotor();
		//Rim Type Elite
		if ($('select#rim_size').val() === "REAR 18x1.85" || $('select#rim_size').val() === "FRONT 21x1.60" || $('select#rim_size').val() === "REAR 18x2.15") {
			if ($('select#bike_model').val() === "Ultra *FRONT*" || $('select#bike_model').val() === "Ultra *REAR*" || $('select#bike_model').val() === "X *REAR*" || $('select#bike_model').val() === "X *FRONT*" || $('select#bike_model').val() === "Sting *FRONT*" || $('select#bike_model').val() === "Sting *REAR*" || $('select#bike_model').val() === "Sting R *FRONT*" || $('select#bike_model').val() === "Sting MX5 *FRONT*"  || $('select#bike_model').val() === "XXX *FRONT*" || $('select#bike_model').val() === "Sting R *REAR*" || $('select#bike_model').val() === "Sting MX5 *REAR*"  || $('select#bike_model').val() === "XXX *REAR*") {
				$("#rim_type_field").show();
				var select = $('#rim_type');
				select.empty().append('<option value="Standard">Standard</option><option id="Elite" class="category" value="Elite">Elite</option>');
			}
		} else {
			$("#rim_type_field").hide();
			var select = $('#rim_type');
			select.empty().append('<option value="Standard">Standard</option>');
		}
	});

	$('select#bike_model').change(function () {
		//Display Default Hub
		var image_name = images + "hub-top-" + $('#hub_color').val() + '-' + $('select#wheel_type').val() + ".png";
		var imageArr5 = [image_name];
		var divArr5 = ["resultAreaID_1_0"];
		$('#resultAreaID_1_0 img').attr('src', image_name);

		var image_name = images + "hub-bottom-" + $('#hub_color').val() + "-" + $('select#wheel_type').val() + ".png";
		var imageArr6 = [image_name];
		var divArr6 = ["resultAreaID_1_5"];
		$('#resultAreaID_1_5 img').attr('src', image_name);

		//Display Default Spokes
		var image_name = images + "spokes-" + $('#spoke_color').val() + "-" + $('select#wheel_type').val() + ".png";
		var imageArr3 = [image_name];
		var divArr3 = ["resultAreaID_1_2"];
		$('#resultAreaID_1_2 img').attr('src', image_name);;
		//Remove Cush Rotor
		document.getElementById('resultAreaID_1_4').innerHTML = '';
		//Display Hub COLOR
		// document.getElementById('hub-color').style.display = 'block';

		document.getElementById('resultAreaID_1_6').style.width = '';
		document.getElementById('resultAreaID_1_6').style.height = '';
		document.getElementById('resultAreaID_1_6').style.top = '';

		if ($('select#brake_rotor').val() == "220_mm_floating") {
			var image_name = images + "S-" + $('select#brake_rotor').val() + ".png";
			var imageArr6 = [image_name];
			var divArr6 = ["resultAreaID_1_7"];
			$('#resultAreaID_7_0 img').attr('src', image_name);

		} else {
			var image_name = images + "S-" + $('select#brake_rotor').val() + ".png";
			var imageArr6 = [image_name];
			var divArr6 = ["resultAreaID_1_7"];
			$('#resultAreaID_7_0 img').attr('src', image_name);
		}


	});

	$('select#bike_model').change(function () {
		if ($('select#wheel_type').val() == 'FRONT') {
			$('#sprocket').hide();
			// $('#resultAreaID_1_7').hide();
			$('#resultAreaID_1_6').hide();
		} else {
			var carrier = $('#carrier_id');
			if (carrier.val() == "Yes") {
				$('#sprocket').show();
			} else {
				if ($('#sprocket').css('display') == 'none') {
					$('#sprocket').hide();
				} else {
					$('#sprocket').show();
				}
			}
			$('#resultAreaID_1_7').show();
			$('#resultAreaID_1_6').show();
			var image_name = images + "rotor.png";
			var imageArr5 = [image_name];
			var divArr5 = ["resultAreaID_1_6"];
			// $('#resultAreaID_1_6 img').attr('src', image_name);
		}

		//Display All Hub Colors
		// $.fn.allhubcolors;

		//Nipple Spoke Color
		nipplespokecolor();
		nipplecolorreset();
		mbtiremounted();
	});

	$('select#rim_size').change(function () {
		if ($('select#bike_model').val() == "1987-2007 KLR650 *FRONT*" || $('select#bike_model').val() == "2008 - Current KLR650 *FRONT*") {
			if ($('select#rim_size').val() == "21”x1.60”" || $('select#rim_size').val() == "21”x1.85” (oem size)") {
				var select = $('#brake_rotor');
				select.empty().append('<option value="280MM_FLOATING">280mm Floating</option>');
			}
		}
		if ($('select#rim_size').val() == "21x1.85 (OEM SIZE)") {
			// $.fn.allhubcolors;
		}

		if ($('select#rim_size').val() == "FRONT 21x1.60") {
			var select = $('#rim_color');
			select.val('Black');
			//Rim Color Temp Hide
			// select.empty().append('<option class="opdis" value="Anodized" disabled>Anodized</option><option class="category" value="Black">Black</option><option class="category" value="Blue">Blue</option><option class="category" value="Gold">Gold</option><option class="category" value="Magnesium">Magnesium</option><option class="category" value="Matte-Black">Matte Black</option><option class="category" value="Purple">Purple</option><option class="category" value="Red">Red</option><option class="category" value="Silver">Silver</option><option class="opdis" value="Powder-Coated" disabled>Powder Coated</option><option class="category" value="Blue">Blue</option><option class="category" value="Baby-Blue">Baby Blue</option><option class="category" value="Flo-Yellow">Flo Yellow</option><option class="category" value="Nardo-Grey">Nardo Grey</option><option class="category" value="Orange">Orange</option><option class="category" value="School-Bus-Yellow">School Bus Yellow</option><option class="category" value="White">White</option>');
			var rim_color_wrapper = $('.rim_color_wrapper');
			// rim_color_wrapper.empty().append(`<div class="color-swatch category show" data-category="anodized" data-value="Black" title="Black" style="background: url(${colorImages}black.svg?v=1717478021);"></div>
			//    <div class="color-swatch category" data-category="powder-coat" data-value="Blue" title="Blue" style="background: url(${colorImages}blue.svg?v=1717478021);"></div>
			//    <div class="color-swatch category" data-category="powder-coat" data-value="Gold" title="Gold" style="background: url(${colorImages}gold.svg?v=1717478021);"></div>
			//    <div class="color-swatch category" data-category="powder-coat" data-value="Magnesium" title="Magnesium" style="background: url(${colorImages}magnesium.svg?v=1717478021);"></div>
			//    <div class="color-swatch category" data-category="powder-coat" data-value="Matte-Black" title="Matte Black" style="background: url(${colorImages}matte-black.svg?v=1717478021);"></div>
			//    <div class="color-swatch category" data-category="powder-coat" data-value="Purple" title="Purple" style="background: url(${colorImages}purple.svg?v=1717478021);"></div>
			//    <div class="color-swatch category" data-category="powder-coat" data-value="Red" title="Red" style="background: url(${colorImages}red.svg?v=1717478021);"></div>
			//    <div class="color-swatch category" data-category="powder-coat" data-value="Silver" title="Silver" style="background: url(${colorImages}silver.svg?v=1717478021);"></div>
			//    <div class="color-swatch category" data-category="powder-coat" data-value="Blue" title="Blue" style="background: url(${colorImages}blue.svg?v=1717478021);"></div>
			//    <div class="color-swatch category" data-category="powder-coat" data-value="Baby-Blue" title="Baby Blue" style="background: url(${colorImages}baby-blue.svg?v=1717478021);"></div>
			//    <div class="color-swatch category" data-category="powder-coat" data-value="Flo-Yellow" title="Flo Yellow" style="background: url(${colorImages}flo-yellow.svg?v=1717478021);"></div>
			//    <div class="color-swatch category" data-category="powder-coat" data-value="Nardo-Grey" title="Nardo Grey" style="background: url(${colorImages}nardo-grey.svg?v=1717478021);"></div>
			//    <div class="color-swatch category" data-category="powder-coat" data-value="Orange" title="Orange" style="background: url(${colorImages}orange.svg?v=1717478021);"></div>
			//    <div class="color-swatch category" data-category="powder-coat" data-value="School-Bus-Yellow" title="School Bus Yellow" style="background: url(${colorImages}school-bus-yellow.svg?v=1717478021);"></div>
			//    <div class="color-swatch category" data-category="powder-coat" data-value="White" title="White" style="background: url(${colorImages}white.svg?v=1717478021);"></div>
			//    `);

		}
		var image_name = images + "rim-" + $('#rim_color').val() + "-" + $('select#wheel_type').val() + ".png";
		var imageArr2 = [image_name];
		var divArr2 = ["resultAreaID_1_1"];
		$('#resultAreaID_1_1 img').attr('src', image_name);

		var select = $('#spoke_color');
		select.empty().append('<option class="category" value="Silver">Silver</option><option class="category" value="Black">Black</option><option class="category" value="Blue">Blue</option><option class="category" value="Green">Green</option><option class="category" value="Nardo-Grey">Nardo Grey</option><option class="category" value="Orange">Orange</option><option class="category" value="Blue">Powder Blue</option><option class="category" value="Red">Red</option><option class="category" value="White">White</option><option class="category" value="Flo-Yellow">Flo Yellow</option><option class="category" value="School-Bus-Yellow">School Bus Yellow</option><option class="category" value="Titanium">Titanium</option>');
		var select = $('#nipple_color');
		select.empty().append('<option class="category" value="Silver">Silver</option><option class="category" value="Black">Black</option><option class="category" value="Red">Red</option><option class="category" value="Blue">Blue</option><option class="category" value="Orange">Orange</option><option class="category" value="Green">Green</option><option class="category" value="Gold">Gold</option><option class="category" value="Purple">Purple</option><option class="category" value="Magnesium">Magnesium</option>');

		var image_name = images + "rim-" + $('#rim_color').val() + "-" + $('select#wheel_type').val() + ".png";
		var imageArr2 = [image_name];
		var divArr2 = ["resultAreaID_1_1"];
		$('#resultAreaID_1_1 img').attr('src', image_name);
		//Call Mounted Tire Function
		mbtiremounted();
		rimcolorblack();

		//Rim Type Elite
		if ($('select#rim_size').val() === "REAR 18x1.85" || $('select#rim_size').val() === "FRONT 21x1.60" || $('select#rim_size').val() === "REAR 18x2.15") {
			if ($('select#bike_model').val() === "Ultra *FRONT*" || $('select#bike_model').val() === "Ultra *REAR*" || $('select#bike_model').val() === "X *REAR*" || $('select#bike_model').val() === "X *FRONT*" || $('select#bike_model').val() === "Sting *FRONT*" || $('select#bike_model').val() === "Sting *REAR*" || $('select#bike_model').val() === "Sting R *FRONT*" || $('select#bike_model').val() === "Sting MX5 *FRONT*" || $('select#bike_model').val() === "XXX *FRONT*" || $('select#bike_model').val() === "Sting R *REAR*" || $('select#bike_model').val() === "Sting MX5 *REAR*" || $('select#bike_model').val() === "XXX *REAR*") {
				$("#rim_type_field").show();
				var select = $('#rim_type');
				select.empty().append('<option value="Standard">Standard</option><option id="Elite" class="category" value="Elite">Elite</option>');
			}
		} else {
			$("#rim_type_field").hide();
			var select = $('#rim_type');
			select.empty().append('<option value="Standard">Standard</option>');
		}
		
		if ($('select#rim_lock').val() === "Yes") {
			$("#resultAreaID_1_9").show();
		} else {
			$("#resultAreaID_1_9").hide();
		}

		if ($('select#bike_model').val() === "Ultra *REAR*") {
			var select = $('#sprocket_size');
			select.empty().append(ULTRA_BEE_SPROCKET_OPTIONS_HTML);
		} else {
			var select = $('#sprocket_size');
			select.empty().append('<option class="category" value="42 Teeth">42 Teeth</option><option class="category" value="48 Teeth">48 Teeth</option><option class="category" value="52 Teeth">52 Teeth</option><option class="category" value="54 Teeth">54 Teeth</option><option class="category" value="58 Teeth">58 Teeth</option><option class="category" value="60 Teeth">60 Teeth</option><option class="category" value="62 Teeth">62 Teeth</option><option class="category" value="64 Teeth">64 Teeth</option><option class="category" value="no">No Sprocket</option>');
		}
		updateModelSpecificSprocketOptions();
		updateBrakeRotor();
	});

	function hideShowRimColor(rim_type, rim_size) {
		if (rim_type == 'Elite') {
			// Elite rims are only available in black.
			$(".rim-type-wrap.anodized").show().trigger("click");
			applyEliteBlackRimOnly();

		} else {
			//show all rims
			$(".rim-type-wrap.anodized").show();
			$(".rim-type-wrap.anodized").trigger("click");
		}
	}

	$('select#rim_type').change(function () {
		var rim_type = $('select#rim_type').val();
		var rim_size = $('select#rim_size').val();
		var rimcolor = hideShowRimColor(rim_type, rim_size);
	});

	$('select#bike_model').change(speedometer);
	$('select#bike_make').change(bikeyear);
	$('select#bike_model').change(spoketitanium);
	$('select#bike_make').change(speedometer);
	$('select#wheel_type').change(speedometer);
	$('select#bike_year').change(spoketitanium);
	// $('select#rim_size').change(spoketitanium);
	$('select#rim_size').change(rimColorValidation);
	$('select#wheel_type').change(spoketitanium);

	$('select#bike_make').change(tprice);
	$('select#bike_model').change(tprice);
	$('select#carrier_id').change(tprice);


	$('select#rim_size').change(tprice);
	$('select#brake_rotor').change(tprice);
	$('select#sprocket_size').change(tprice);
	$('select#wheel_type').change(tprice);
	$('select#rim_type').change(tprice);
	$('select#cush_drive').change(tprice);
	$('select#sprocket_bolts').change(tprice);
	$('select#rotor_bolts').change(tprice);
	$('select#sm_magnets').change(tprice);
	$('select#mbtire').change(tprice);
	$(document).on('change', 'select, input', function () {
		tprice();
	});

	$('select#wheel_type').change(function () {


		var bikeModelSelect = document.getElementById("bike_model");
		const selectedText = bikeModelSelect.options[bikeModelSelect.selectedIndex].text;

		var select_model = $('select#bike_model');

		$("option:selected", select_model).removeAttr("selected");
		$('select#hidden_bike_model option').appendTo('select#bike_model');
		switch (this.value) {
			default:
			case 'FRONT':
				$('select#bike_model option.rear').appendTo('select#hidden_bike_model');
				break;
			case 'REAR':
				$('select#bike_model option.front').appendTo('select#hidden_bike_model');
				break;
		}
		select_model.val(select_model.find('option').first().val()).change();
		var options = bikeModelSelect.options;
		for (let i = 0; i < options.length; i++) {
			if (options[i].text === selectedText) {
				bikeModelSelect.selectedIndex = i;
				break;
			}
		}

		select_model.change();
		$('#rotor_bolts').prop('selectedIndex', 0);
		if ($('select#wheel_type').val() == "FRONT") {
			$('#sprocketbolts').css("display", "none");
		} else {
			$('#sprocketbolts').css("display", "block");
		}
		//Rim Type Elite
		if ($('select#rim_size').val() === "REAR 18x1.85" || $('select#rim_size').val() === "FRONT 21x1.60" || $('select#rim_size').val() === "REAR 18x2.15") {
			if ($('select#bike_model').val() === "Ultra *FRONT*" || $('select#bike_model').val() === "Ultra *REAR*" || $('select#bike_model').val() === "X *REAR*" || $('select#bike_model').val() === "X *FRONT*" || $('select#bike_model').val() === "Sting *FRONT*" || $('select#bike_model').val() === "Sting *REAR*" || $('select#bike_model').val() === "Sting R *FRONT*" || $('select#bike_model').val() === "Sting MX5 *FRONT*" || $('select#bike_model').val() === "XXX *FRONT*" || $('select#bike_model').val() === "Sting R *REAR*" || $('select#bike_model').val() === "Sting MX5 *REAR*" || $('select#bike_model').val() === "XXX *REAR*") {
				$("#rim_type_field").show();
				var select = $('#rim_type');
				select.empty().append('<option value="Standard">Standard</option><option id="Elite" class="category" value="Elite">Elite</option>');
			}
		} else {
			$("#rim_type_field").hide();
			var select = $('#rim_type');
			select.empty().append('<option value="Standard">Standard</option>');
		}

		if ($('select#bike_model').val() === "Ultra *REAR*") {
			var select = $('#sprocket_size');
			select.empty().append(ULTRA_BEE_SPROCKET_OPTIONS_HTML);
		} else {
			var select = $('#sprocket_size');
			select.empty().append('<option class="category" value="42 Teeth">42 Teeth</option><option class="category" value="48 Teeth">48 Teeth</option><option class="category" value="52 Teeth">52 Teeth</option><option class="category" value="54 Teeth">54 Teeth</option><option class="category" value="58 Teeth">58 Teeth</option><option class="category" value="60 Teeth">60 Teeth</option><option class="category" value="62 Teeth">62 Teeth</option><option class="category" value="64 Teeth">64 Teeth</option><option class="category" value="no">No Sprocket</option>');
		}
		updateModelSpecificSprocketOptions();
		updateBrakeRotor();

		var bikemake = $('select#bike_make').val();
		var bikemodel = $('select#bike_model').val();


		rimcolorhideblue();
	});

	$('select#wheel_type').change(function () {

		//HUB COLOR
		var image_name = images + "hub-top-" + $('#hub_color').val() + "-" + $('select#wheel_type').val() + ".png";
		var imageArr1 = [image_name];
		var divArr1 = ["resultAreaID_1_0"];
		$('#resultAreaID_1_0 img').attr('src', image_name);

		var image_name = images + "hub-bottom-" + $('#hub_color').val() + "-" + $('select#wheel_type').val() + ".png";
		var imageArr6 = [image_name];
		var divArr6 = ["resultAreaID_1_5"];
		$('#resultAreaID_1_5 img').attr('src', image_name);
		//RIM COLOR
		var image_name = images + "rim-" + $('#rim_color').val() + "-" + $('select#wheel_type').val() + ".png";
		var imageArr2 = [image_name];
		var divArr2 = ["resultAreaID_1_1"];
		$('#resultAreaID_1_1 img').attr('src', image_name);
		//SPOKE COLOR
		var image_name = images + "spokes-" + $('#spoke_color').val() + "-" + $('select#wheel_type').val() + ".png";
		var imageArr3 = [image_name];
		var divArr3 = ["resultAreaID_1_2"];
		$('#resultAreaID_1_2 img').attr('src', image_name);
		//NIPPLE COLOR
		var image_name = images + "nipple-" + $('#nipple_color').val() + "-" + $('select#wheel_type').val() + ".png";
		var imageArr4 = [image_name];
		var divArr4 = ["resultAreaID_1_3"];
		$('#resultAreaID_1_3 img').attr('src', image_name);

		//SPROCKET SIZE
		if ($('#speedometer').css('display') != 'none') {

		} else {
			if ($('select#wheel_type').val() == 'FRONT') {

				//Sting Brake Rotor Style
				if ($('select#bike_model').val() === "X *FRONT*" || $('select#bike_model').val() === "Sting R *FRONT*" || $('select#bike_model').val() === "Sting MX5 *FRONT*" || $('select#bike_model').val() === "Sting *FRONT*" || $('select#bike_model').val() === "XXX *FRONT*") {
					select = $('#brake_rotor');
					select.empty().append('<option value="203_mm">203 x 1.8 mm Fixed</option><option value="220_mm">220 x 1.8 mm Fixed</option><option value="220_mm_floating">220 x 1.8 mm Floating</option><option class="category" value="220_mm_2">220mm x 2.3mm Floating</option><option class="category" value="240_mm_2">240mm x 2.3mm Floating</option>');
				} else if ($('select#bike_model').val() === "X 260 *FRONT*") {
					select = $('#brake_rotor');
					select.empty().append('<option value="203_mm">203 x 1.8 mm Fixed</option><option value="220_mm">220 x 1.8 mm Fixed</option><option value="220_mm_floating">220 x 1.8 mm Floating</option><option class="category" value="240_mm_2">240mm x 2.3mm Floating</option>');
				} else if ($('select#bike_model').val() === "Ultra *FRONT*") {
					select = $('#brake_rotor');
					select.empty().append('<option value="240_mm">240 x 3.0 mm Fixed</option>');
				} else {

					select = $('#brake_rotor');
					select.empty().append('<option value="203_mm">203 x 1.8 mm Fixed</option><option value="220_mm">220 x 1.8 mm Fixed</option><option value="220_mm_floating">220 x 1.8 mm Floating</option>');
				}
				$('#sprocket').hide();
				//$('#resultAreaID_1_7').hide();
				$('#resultAreaID_1_6').hide();
			} else {
				// console.log('here it comes');

				//Sting Brake Rotor Style
				if ($('select#bike_model').val() === "X *FRONT*" || $('select#bike_model').val() === "Sting R *FRONT*" || $('select#bike_model').val() === "Sting MX5 *FRONT*"  || $('select#bike_model').val() === "Sting *FRONT*" || $('select#bike_model').val() === "XXX *FRONT*") {
					select = $('#brake_rotor');
					select.empty().append('<option value="203_mm">203 x 1.8 mm Fixed</option><option value="220_mm">220 x 1.8 mm Fixed</option><option value="220_mm_floating">220 x 1.8 mm Floating</option><option class="category" value="220_mm_2">220mm x 2.3mm Floating</option><option class="category" value="240_mm_2">240mm x 2.3mm Floating</option>');
				} else if ($('select#bike_model').val() === "X 260 *FRONT*") {
					select = $('#brake_rotor');
					select.empty().append('<option value="203_mm">203 x 1.8 mm Fixed</option><option value="220_mm">220 x 1.8 mm Fixed</option><option value="220_mm_floating">220 x 1.8 mm Floating</option><option class="category" value="240_mm_2">240mm x 2.3mm Floating</option>');
				} else if ($('select#bike_model').val() === "Ultra *REAR*") {
					select = $('#brake_rotor');
					select.empty().append('<option value="240_mm">240 x 3.0 mm Fixed</option>');
				} else {
					select = $('#brake_rotor');
					select.empty().append('<option value="203_mm">203 x 1.8 mm Fixed</option><option value="220_mm">220 x 1.8 mm Fixed</option><option value="220_mm_floating">220 x 1.8 mm Floating</option>');
				}
				if ($('select#brake_rotor').val() == "220_mm_floating") {
					var image_name = images + "S-" + $('select#brake_rotor').val() + ".png";
					var imageArr6 = [image_name];
					var divArr6 = ["resultAreaID_1_7"];
					// $('#resultAreaID_1_7 img').attr('src', image_name);

				} else {
					var image_name = images + "S-" + $('select#brake_rotor').val() + ".png";
					var imageArr6 = [image_name];
					var divArr6 = ["resultAreaID_1_7"];
					// $('#resultAreaID_1_7 img').attr('src', image_name);
				}
			}

		}

		if ($('select#bike_model').val() === "Ultra *REAR*") {
			var select = $('#sprocket_size');
			select.empty().append(ULTRA_BEE_SPROCKET_OPTIONS_HTML);
		} else {
			var select = $('#sprocket_size');
			select.empty().append('<option class="category" value="42 Teeth">42 Teeth</option><option class="category" value="48 Teeth">48 Teeth</option><option class="category" value="52 Teeth">52 Teeth</option><option class="category" value="54 Teeth">54 Teeth</option><option class="category" value="58 Teeth">58 Teeth</option><option class="category" value="60 Teeth">60 Teeth</option><option class="category" value="62 Teeth">62 Teeth</option><option class="category" value="64 Teeth">64 Teeth</option><option class="category" value="no">No Sprocket</option>');
		}
		updateModelSpecificSprocketOptions();
		updateBrakeRotor();




		if ($('select#wheel_type').val() == 'FRONT') {
			$('#sprocket').hide();
			//$('#resultAreaID_1_7').hide();
			$('#resultAreaID_1_6').hide();
		} else {
			$('#sprocket').show();
			$('#resultAreaID_1_7').show();
			$('#resultAreaID_1_6').show();
			var image_name = images + "rotor.png";
			var imageArr5 = [image_name];
			var divArr5 = ["resultAreaID_1_6"];
			// $('#resultAreaID_1_6 img').attr('src', image_name);
		}


		if ($('select#wheel_type').val() == "FRONT") {
			$('#sprocketbolts').css("display", "none");
		} else {
			$('#sprocketbolts').css("display", "block");
		}
		//Call Mounted Tire Function
		mbtiremounted();
		// rimcolorblack();
		var select = $('#sprocket_size');
			select.val('no');
			select.change();
	});



	$(document).on("change", "#rim_color", function () {
		var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/e-rim-" + $('#rim_color').val() + "-" + $('select#wheel_type').val() + ".png";
		var imageArr2 = [image_name];
		var divArr2 = ["resultAreaID_1_1"];
		// $('#resultAreaID_1_1 img').attr('src', image_name );
		$('#resultAreaID_1_1 img').attr('src', image_name);
	});

	var rimHiddenInput = $('#rim_color');

	$(document).on("click", '.rim_color_wrapper .color-swatch', function () {
		var colorValue = $(this).data('value');
		$('.rim_color_wrapper .color-swatch').removeClass('active');
		$(this).addClass('active');
		rimHiddenInput.val(colorValue);
		// console.log('changed rim color: ', colorValue);
		var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/e-rim-" + $('#rim_color').val() + "-" + $('select#wheel_type').val() + ".png";
		$('#resultAreaID_1_1 img').attr('src', image_name);

		var colorTitle = $(this).attr('title') ? $(this).attr('title') : $(this).data('value');
		$('#selected_rim_color').html(colorTitle.replaceAll('-', " "));
		tprice();
	});

	// Hub Color
	var hubcolorSwatches = $('.hub_color_wrapper .color-swatch');
	var hubHiddenInput = $('#hub_color');

	$(document).on("click", '.hub_color_wrapper .color-swatch', function () {
		var colorValue = $(this).data('value');
		hubcolorSwatches.removeClass('active');
		$(this).addClass('active');
		hubHiddenInput.val(colorValue);
		var image_name = images + "hub-top-" + $('#hub_color').val() + "-" + $('select#wheel_type').val() + ".png";
		var imageArr1 = [image_name];
		var divArr1 = ["resultAreaID_1_0"];
		$('#resultAreaID_1_0 img').attr('src', image_name);
		var image_name = images + "hub-bottom-" + $('#hub_color').val() + "-" + $('select#wheel_type').val() + ".png";
		var imageArr6 = [image_name];
		var divArr6 = ["resultAreaID_1_5"];
		$('#resultAreaID_1_5 img').attr('src', image_name);

		document.getElementById('resultAreaID_1_6').style.width = '';
		document.getElementById('resultAreaID_1_6').style.height = '';
		document.getElementById('resultAreaID_1_6').style.top = '';

		if ($('select#brake_rotor').val() == "220_mm_floating") {
			var image_name = images + "S-" + $('select#brake_rotor').val() + ".png";
			var imageArr6 = [image_name];
			var divArr6 = ["resultAreaID_1_7"];
			$('#resultAreaID_7_0 img').attr('src', image_name);

		} else {
			var image_name = images + "S-" + $('select#brake_rotor').val() + ".png";
			var imageArr6 = [image_name];
			var divArr6 = ["resultAreaID_1_7"];
			$('#resultAreaID_7_0 img').attr('src', image_name);
		}

		tprice();
		var colorTitle = $(this).attr('title') || $(this).data('value');
		$('#selected_hub_color').html(colorTitle);
	});

	var nipplecolorSwatches = $('.nipple_color_wrapper .color-swatch');
	var nippleHiddenInput = $('#nipple_color');
	$(document).on("click", '.nipple_color_wrapper .color-swatch', function () {
		var colorValue = $(this).data('value');
		nipplecolorSwatches.removeClass('active');
		$(this).addClass('active');
		nippleHiddenInput.val(colorValue);
		var image_name = images + "nipple-" + $('#nipple_color').val() + "-" + $('select#wheel_type').val() + ".png";
		$('#resultAreaID_1_3 img').attr('src', image_name);
		tprice();
		var colorTitle = $(this).attr('title') || $(this).data('value');
		$('#selected_nipple_color').html(colorTitle);
	});

	// Spoke Color
	var spokeHiddenInput = $('#spoke_color');

	$(document).on("click", '.spoke_color_wrapper .color-swatch', function () {
		var spokecolorSwatches = $('.spoke_color_wrapper .color-swatch');
		var colorValue = $(this).data('value');
		spokecolorSwatches.removeClass('active');
		$(this).addClass('active');
		spokeHiddenInput.val(colorValue);
		if ($('select#cush_drive').val() != "unavailable") {
			//Display Cush Spokes
			var image_name = images + "cush-spokes-" + $('#spoke_color').val() + "-" + $('select#wheel_type').val() + ".png";
			$('#resultAreaID_1_2 img').attr('src', image_name);
		} else {
			//SPOKE COLOR
			var image_name = images + "spokes-" + $('#spoke_color').val() + "-" + $('select#wheel_type').val() + ".png";
			$('#resultAreaID_1_2 img').attr('src', image_name);
		}
		tprice();
		var colorTitle = $(this).attr('title') || $(this).data('value');
		$('#selected_spoke_color').html(colorTitle);
	});

	$('select#mtl').change(function () {
		tubelesswheel();
		if ($('select#mtl').val() != "No") {
			$('#mbtire').prop('selectedIndex', 0);
			$('#mbtire option').eq(2).remove();
			$('#resultAreaID_1_10').show();
			var image_name = "https://cdn.shopify.com/s/files/1/0676/2096/2552/files/SM-" + $("select#wheel_type").val() + "-tire650.png";
			var imageArr9 = [image_name];
			var divArr9 = ["resultAreaID_1_10"];
			$('#resultAreaID_1_10 img').attr("src", image_name);
		} else {
			// $('#resultAreaID_1_10').hide();
			if (!$('#mbtire option').filter('[value="mbno"]').length) {
				$('#mbtire').append($('<option>').val('mbno').text('No'));
			}
		}
	});

	$('select#mbtire').change(function () {
		if ($('select#rim_size').val() == "FRONT 21x1.60") {
			var select = $('#mbtire');
			var image_name = images + $('select#mbtire').val() + "-" + $('select#wheel_type').val() + ".png";
			var imageArr9 = [image_name];
			var divArr9 = ["resultAreaID_1_8"];
			$('#resultAreaID_1_8 img').attr('src', image_name);
			$("#mbtiretr").show();

		} else if ($('select#rim_size').val() == "FRONT 19x1.60" || $('select#rim_size').val() == "REAR 19x1.60") {
			var image_name = images + $('select#mbtire').val() + "-" + $('select#wheel_type').val() + ".png";
			var imageArr9 = [image_name];
			var divArr9 = ["resultAreaID_1_8"];
			$('#resultAreaID_1_8 img').attr('src', image_name);
			$("#mbtiretr").show();
		} else if ($('select#rim_size').val() == "REAR 16x1.85") {
			var image_name = images + $('select#mbtire').val() + "-" + $('select#wheel_type').val() + ".png";
			var imageArr9 = [image_name];
			var divArr9 = ["resultAreaID_1_8"];
			$('#resultAreaID_1_8 img').attr('src', image_name);
			$("#mbtiretr").show();
		} else if ($('select#rim_size').val() == "REAR 18x1.85" || $('select#rim_size').val() === "REAR 18x2.15") {
			var image_name = images + $('select#mbtire').val() + "-" + $('select#wheel_type').val() + ".png";
			var imageArr9 = [image_name];
			var divArr9 = ["resultAreaID_1_8"];
			$('#resultAreaID_1_8 img').attr('src', image_name);
			$("#mbtiretr").show();
        } else if ($('select#rim_size').val() == "REAR 17x3.00") {
                var image_name = images + $('select#mbtire').val() + "-" + $('select#wheel_type').val() + ".png";
                var imageArr9 = [image_name];
                var divArr9 = ["resultAreaID_1_8"];
                $('#resultAreaID_1_8 img').attr('src', image_name);
                $("#mbtiretr").show();
		} else if ($('select#rim_size').val() == "FRONT 17x2.50" || $('select#rim_size').val() == "FRONT 17x2.15" || $('select#rim_size').val() == "REAR 17x2.50") {
			if ($('select#mbtire').val() == "michelin") {
				var image_name = images + "dunlop-mic-" + $('select#wheel_type').val() + ".png";
			} else {
				var image_name = images + $('select#mbtire').val() + "-" + $('select#wheel_type').val() + ".png";
			}
			var imageArr9 = [image_name];
			var divArr9 = ["resultAreaID_1_8"];
			$('#resultAreaID_1_8 img').attr('src', image_name);
			$("#mbtiretr").show();
		} else if ($('select#rim_size').val() == "FRONT 17x3.00" || $('select#rim_size').val() == "REAR 17x4.25") {
			$("#mbtiretr").show();
		} else {
			var select = $('#mbtire');
			select.empty().append('<option class="category" value="mounted_no" selected>No</option>');
			$("#mbtiretr").hide();
			$("#resultAreaID_1_8").hide();
		}

		($('select#mbtire').val() == "mounted_no") ? $("#resultAreaID_1_8").hide(): $("#resultAreaID_1_8").show();
	});

	// $('select#brake_rotor').change(function() {

	// 	var cushsel = $('#cush_drive');
	// 	if (cushsel.val() == "available") {

	// 	}
	// 	if ($('select#bike_model').val() === "1996 - 2016 DR650 *REAR*" || $('select#bike_model').val() == "790 Adventure *REAR*" || $('select#bike_model').val() == "890 Adventure *REAR*" || $('select#bike_model').val() == "890 Adventure R *REAR*" || $('select#bike_model').val() == "790 Adventure R *REAR*" || $('select#bike_model').val() == "2008 – 2013 KTM 690 ENDURO * REAR *" || $('select#bike_model').val() == "2014 – 2016 KTM 690 ENDURO ABS * REAR *" || $('select#bike_model').val() == "1997-2007 KLR650 *REAR*" || $('select#bike_model').val() == "2008 - Current KLR650 *REAR* " || $('select#bike_model').val() == "2016 - Current 701 Enduro *REAR*") {
	// 		$("#resultAreaID_1_6").attr('style', 'width:150px;height:95px;');
	// 	} else {
	// 		if ($('select#brake_rotor').val() === "320MM_FLOATING") {
	// 			$("#resultAreaID_1_6").attr('style', 'width:185px;height:185px;');
	// 			$(".text").attr('style', 'margin-top: 209px;');
	// 		} else {
	// 			$("#resultAreaID_1_6").attr('style', 'width:185px;height:185px;');
	// 			$(".text").attr('style', 'margin-top: 209px;');
	// 		}
	// 	}
	// 	if ($('select#bike_model').val() == '790 Adventure *FRONT*' || $('select#bike_model').val() == '790 Adventure R *FRONT*' || $('select#bike_model').val() == '890 Adventure *FRONT*' || $('select#bike_model').val() == '890 Adventure R *FRONT*') {
	// 		var image_name = images + "dual-rotor-" + $('select#wheel_type').val() + ".png";
	// 		var imageArr5 = [image_name];
	// 		$('#resultAreaID_1_6 img').attr("src", image_name);
	// 	} else {
	// 		var image_name = images + "S-" + $('select#brake_rotor').val() + ".png";
	// 		var imageArr5 = [image_name];
	// 		$('#resultAreaID_1_6 img').attr("src", image_name);
	// 	}
	// });

	$('select#brake_rotor').change(function () {

		if ($('select#brake_rotor').val() == "220_mm_floating") {
			var image_name = images + "S-" + $('select#brake_rotor').val() + ".png";
			var imageArr5 = [image_name];
			// $('#resultAreaID_1_7 img').attr("src", image_name);
		} else {
			var image_name = images + "S-" + $('select#brake_rotor').val() + ".png";
			var imageArr5 = [image_name];
			// $('#resultAreaID_1_7 img').attr("src", image_name);
		}
		var image_name = images + "rotor.png";
		var imageArr5 = [image_name];
		// $('#resultAreaID_1_6 img').attr("src", image_name);


	});

	tprice();
	// change year on wheel type
	$('select#wheel_type').change(bikeyear);

	function transformFieldName(name) {
		return name.replace(/_/g, ' ')
			.replace(/\w\S*/g, function (txt) {
				return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
			});
	}

	function transformFieldValue(value) {
		return value ? value.charAt(0).toUpperCase() + value.substr(1).toLowerCase() : value;
	}

	function collectFormData() {
		var formDataArray = [];
		$('#custom-wheel-form select, #custom-wheel-form input[type="text"], #custom-wheel-form input[type="hidden"]').each(function () {
			var fieldName = $(this).attr('name');
			var fieldValue = $(this).val();
			if (fieldName) {
				var fieldData = {
					name: transformFieldName(fieldName),
					value: transformFieldValue(fieldValue)
				};
				formDataArray.push(fieldData);
			}
		});
		return formDataArray;
	}

	function collectFormDataPartNumber() {
		var formDataArrayPartNumber = [];
		$('#custom-wheel-form select, #custom-wheel-form input[type="text"], #custom-wheel-form input[type="hidden"]').each(function () {
			var fieldName = $(this).attr('name');
			var fieldValue = $(this).val();
			if (fieldName) {
				var fieldData = {
					name: fieldName,
					value: fieldValue
				};
				formDataArrayPartNumber.push(fieldData);
			}
		});
		return formDataArrayPartNumber;
	}

	function generateSKU(make, model, wheelSize, spokeColor, location, rimColor, hubColor, rotorSize, nippleColor) {
		return `${make}-${model}${wheelSize}${hubColor}${rimColor}${location}.${spokeColor}${nippleColor}-${rotorSize}`;
	}

	var rimColorMappings = {
		"1": "Silver",
		"2": "Black",
		"3": "Red",
		"4": "Blue",
		"5": "Orange",
		"6": "Magnesium",
		"7": "Green",
		"9": "Gold",
		"FY": "Flo Yellow",
		"NG": "Nardo Grey",
		"V": "Purple"
	};

	var colorToCodeMappings = {};
	$.each(rimColorMappings, function (key, value) {
		colorToCodeMappings[value.toLowerCase()] = key;
	});

	var hubColorMappings = {
		"1": "Silver",
		"2": "Black",
		"3": "Red",
		"4": "Blue",
		"5": "Orange",
		"6": "Magnesium",
		"7": "Green",
		"9": "Gold",
		"V": "Purple"
	};

	// Reverse the mapping to search by color name
	var hubcolorToCodeMappings = {};
	$.each(hubColorMappings, function (key, value) {
		hubcolorToCodeMappings[value.toLowerCase()] = key;
	});

	var spokeColorMappings = {
		"1": "Silver",
		"2": "Black",
		"3": "Red",
		"4": "Blue",
		"5": "Orange",
		"6": "Magnesium",
		"7": "Green",
		"9": "Gold",
		"V": "Purple",
		"SY": "School-Bus-Yellow"
	};

	var spokecolorToCodeMappings = {};
	$.each(spokeColorMappings, function (key, value) {
		spokecolorToCodeMappings[value.toLowerCase()] = key;
	});

	var nippleColorMappings = {
		"1": "Silver",
		"2": "Black",
		"3": "Red",
		"4": "Blue",
		"5": "Orange",
		"6": "Magnesium",
		"7": "Green",
		"9": "Gold",
		"V": "Purple"
	};

	var nipplecolorToCodeMappings = {};
	$.each(nippleColorMappings, function (key, value) {
		nipplecolorToCodeMappings[value.toLowerCase()] = key;
	});

	function customSKU() {
		var formData = collectFormDataPartNumber();
		// console.log({
		// 	formData
		// });

		var properties = {};
		var makeCode = '';
		var modelCode = '';
		var rimCode = '';
		var rimColorCode = '';
		var hubCode = '';
		var wheelCode = '';
		var spokeColorCode = '';
		var brakeRotorCode = '';
		var nippleColorCode = '';

		formData.forEach(function (field) {
			properties[field.name] = field.value;
			switch (field.name) {
				case 'bike_make':
					switch (field.value) {
						case 'Surron':
							makeCode = 'S';
							break;
						case 'ERIDE':
							makeCode = 'E';
							break;
						case 'Segway':
							makeCode = 'SW';
							break;
						case 'Talaria':
							makeCode = 'T';
							break;
					}
					case 'bike_model':
						switch (field.value) {
							case 'X *FRONT*':
								modelCode = 'X';
								break;
							case 'Ultra *FRONT*':
								modelCode = 'U';
								break;
							case 'PRO-SS *FRONT*':
								modelCode = 'P';
								break;
							case 'PRO 2.0 *FRONT*':
								modelCode = 'P2';
								break;
							case 'X 160 *FRONT*':
								modelCode = 'X160';
								break;
							case 'X 260 *FRONT*':
								modelCode = 'X260';
								break;
							case 'Sting *FRONT*':
								modelCode = 'X';
								break;
							case 'Sting R *FRONT*':
								modelCode = 'XR';
								break;
							case 'XXX *FRONT*':
								modelCode = 'XXX';
								break;
								break;
						}
						case 'rim_size':
							var match = field.value.match(/\d+/); // Match the first sequence of digits
							if (match) {
								rimCode = match[0];
							} else {
								rimCode = field.value;
							}
							break;

						case 'hub_color':
							hubCode = hubcolorToCodeMappings[properties.hub_color.toLowerCase()] || properties.hub_color;
							break;

						case 'rim_color':
							rimColorCode = colorToCodeMappings[properties.rim_color.toLowerCase()] || properties.rim_color;
							break;

						case 'wheel_type':
							wheelCode = field.value === 'FRONT' ? 'F' : 'R';
							break;

						case 'spoke_color':
							spokeColorCode = spokecolorToCodeMappings[properties.spoke_color.toLowerCase()] || properties.spoke_color;
							break;

						case 'nipple_color':
							nippleColorCode = nipplecolorToCodeMappings[properties.nipple_color.toLowerCase()] || properties.nipple_color;
							break;

						case 'brake_rotor':
							switch (field.value) {
								case '203_mm':
									brakeRotorCode = '203';
									break;
								case '220_mm':
									brakeRotorCode = '220';
									break;
								case '220_mm_floating':
									brakeRotorCode = 'A220';
									break;
								case '220_mm_2':
									brakeRotorCode = 'A220_23';
									break;
								case '240_mm_2':
									brakeRotorCode = 'A240_23';
									break;
							}
							break;
			}
		});
		// console.log({
		// 	modelCode
		// });
		var customSKU = generateSKU(makeCode, modelCode, rimCode, spokeColorCode, wheelCode, rimColorCode, hubCode, brakeRotorCode, nippleColorCode);
		// console.log({
		// 	customSKU
		// });
		return customSKU;
	}

	$('.act-btn-custom').on('click', function () {
		var selectedvariant = $('#custom-wheel-form').attr("data-variantid");
		var totalpersonalizeitem = parseInt(new_base_price - base_price) / 0.01;
		var title = $('.product-info-heading ').text();
		// console.log(base_price, new_base_price, totalpersonalizeitem);
		var withtire = "45197490913528";
		var withouttire = "45197490946296";
		var tirevalue = $('select#mbtire').val();
		selectedvariant = withouttire;
		// if(tirevalue != 'mbno' || tirevalue != 'undefined'){
		//  selectedvariant = withtire; 
		// } 
		var rim_size = document.querySelector('#rim_size').value;
		var wheel_type = document.querySelector('#wheel_type').value;
		var has_tire = document.querySelector('#mbtire').value

		if (wheel_type == "FRONT") {
			if (has_tire != "mbno") { // HAS TIRE
				if (rim_size.includes('17')) {
					selectedvariant = 45907929759992;
				} else if (rim_size.includes('19')) {
					selectedvariant = 45907928645880;
				} else if (rim_size.includes('21')) {
					selectedvariant = 45907928383736;
				}
			} else { // NO TIRE
				if (rim_size.includes('16')) {
					selectedvariant = 45907924091128;
				} else if (rim_size.includes('17')) {
					selectedvariant = 45907923730680;
				} else if (rim_size.includes('18')) {
					selectedvariant = 45907923370232;
				} else if (rim_size.includes('19')) {
					selectedvariant = 45907923075320;
				} else if (rim_size.includes('21')) {
					selectedvariant = 45907922452728;
				}
			}
		} else {
			if (has_tire != "mbno") { // HAS TIRE
				if (rim_size.includes('16')) {
					selectedvariant = 45907931136248;
				} else if (rim_size.includes('17')) {
					selectedvariant = 45907930644728;
				} else if (rim_size.includes('18')) {
					selectedvariant = 45907930317048;
				} else if (rim_size.includes('19')) {
					selectedvariant = 45907929989368;
				}
			} else { // NO TIRE
				if (rim_size.includes('16')) {
					selectedvariant = 45907925532920;
				} else if (rim_size.includes('17')) {
					selectedvariant = 45907925205240;
				} else if (rim_size.includes('18')) {
					selectedvariant = 45907924779256;
				} else if (rim_size.includes('19')) {
					selectedvariant = 45907924418808;
				}
			}
		}
		var Part_Number = customSKU();
		// return false;
		var formData = collectFormData();
		if ($('#wheel_type').val() == "FRONT") {
			formData = formData.filter(function (item) {
				return item.name !== "Sprocket Bolts" && item.name !== "Sprocket Size";
			});
		}

		formData = formData.filter(function (item) {
			return item.name !== "Mbtire";
		});
		var properties = {};
		formData.forEach(function (field) {
			properties[field.name] = field.value;
		});
		properties['__extraPricing'] = totalpersonalizeitem;
		properties['Mbtire'] = $('#mbtire').val();
		// properties['PartNumber'] = Part_Number;

		let newObject = {
			product: title,
			__parentVariant: selectedvariant
		};

		let wbproperties = {
			...newObject,
			...properties
		};
		properties['__price'] = new_base_price;

		// var requestData = {
		// 	items: [{
		// 			quantity: totalpersonalizeitem, // Adjust the quantity as needed
		// 			id: 44252901507320, // Use your actual product ID\
		// 			properties: wbproperties
		// 		},
		// 		{
		// 			quantity: 1, // Adjust the quantity as needed
		// 			id: selectedvariant, // Use your actual product ID
		// 			properties: properties
		// 		}
		// 	]
		// };
		var requestData = {
			items: [{
				quantity: 1, // Adjust the quantity as needed
				id: selectedvariant, // Use your actual product ID
				properties: properties
			}]
		};

		const bikeModelSelect = document.getElementById("bike_model");
		const selectedModelText = bikeModelSelect.options[bikeModelSelect.selectedIndex].text;

		requestData.items[0].properties["Bike Model"] = selectedModelText;
		$.ajax({
			url: "/cart/add.js",
			type: "POST",
			data: JSON.stringify(requestData),
			contentType: "application/json",
			dataType: 'json',
			success: function (response) {
				// console.log("Item added to the cart successfully.", response);
				window.location.href = "/cart";
			},
			error: function (xhr, status, error) {
				console.error("Error adding item to the cart.", status, error);
			}
		});
	});


	$('.product.product-page').addClass('init');

});



function roundUpIfEndsWith95(price) {
  return Math.ceil(price);
}